/**
 * CollectFee Component
 * 
 * Supports URL parameters for deep linking and state preservation:
 * - studentId: ID of the selected student
 * - searchLevel: 1 (Branch filter) or 2 (Student search)
 * - tab: 1 (Term Based) or 2 (Student Profile)
 * - boardId, branchId, classId, sectionId: For branch-based filtering
 * - searchValue, username: For student search
 * - orgId: Organization ID for multi-tenant support
 * 
 * Example URLs:
 * - /collect-fee?studentId=123&searchLevel=2&tab=1&orgId=org123
 * - /collect-fee?studentId=456&searchLevel=1&boardId=1&branchId=2&classId=3&sectionId=4&orgId=org456
 * - /collect-fee?searchLevel=2&studentId=e153cdda-50c1-70ca-90d6-26b75330a1da&status=success&txnId=ORD_123&orgId=org789
 * 
 * Use CollectFee.generateURL({ studentId: '123', tab: 2, orgId: 'org123' }) to create navigation URLs
 */

import { SelectButton } from 'primereact/selectbutton';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import './styles.scss';
import './NTTPaymentComponent.scss';
import { Button } from 'primereact/button';
import { AddIcon2, CalenderIcon, ClassetEditIcon, CodeLinkIcon, DownloadIcon, InfoIcon2, } from '../svgIcons';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { BasicLazyParams, convertUtc } from '../../utile';
import { Dialog } from 'primereact/dialog';
import { baseUrlAdmin } from '../../store/apiConstants';
import { FinanceStudentProfile } from '../svgIcons';
import Service from '../../services';
import { Checkbox } from 'primereact/checkbox';
import ClassetStudentSearch from '../../classetComponents/classetStudentSearch';
import { RadioButton } from 'primereact/radiobutton';
import LoadingComponent from '../loadingComponent';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import { debounce } from 'lodash';
import moment from 'moment';
import ClassetInputText from '../../classetComponents/classetInputText';
import ClassetTextArea from '../../classetComponents/classetTextArea';
import { getFormFields, isFormValid, onDropDownChange, onTextChange } from '../../utile/formHelper';
import ClassetCalendar from '../../classetComponents/classetCalender';
import { paymentModes } from '../../constants';
import { Toast } from 'primereact/toast';
import NewFeeReciept from '../finance/newFeeReciept';
import BulkFeeReciepts from './bulkFeeReciepts';
import Axios from 'axios';
import BranchToSectionDD from '../BaseDropdownComponents/BranchToSectionDD';
import { Accordion, AccordionTab } from 'primereact/accordion';
import ClassetStudentSearchFilter from '../Search/ClassetStudentSearchFilter';

import { v4 as uuidv4 } from 'uuid';
import axios from 'axios'; // Import axios
import asymmetricEncryptionUtils from '../../utils/asymmetricEncryptionUtils';
import NTTPaymentComponent from './NTTPaymentComponent';
import withRouter from '../lib/withRouter';

const createFields = require('./collectFee.json');
const awsRegion = process.env.REACT_APP_AWS_REGION || 'ap-south-1';
const profilesBucket = process.env.REACT_APP_PROFILES_BUCKET || 'classet-profiles-old';

const options = [
    { value: 1, label: 'Term Based' },
    { value: 3, label: 'Fee Type Based' },
    { value: 2, label: 'Student Profile' },

];

export class CollectFee extends Component {
    constructor(props) {
        super(props);
        this.formFields = getFormFields(createFields, this.props.editData);
        this.state = {
            tab: 1,
            lazyParams: { ...BasicLazyParams, rows: 50 },
            termBasedData: [],
            formValidations: this.formFields?.formValidations,
            openCreateFeeDialog: false,
            searchInput: '',
            isLoading: false,
            searchLevel: 1,
            searchValue: '',
            students: [],
            studentId: '',
            totalRecords: '',
            advanceInfo: null,
            useAdvanceAmount: false,
            closedFees: [],
            expandedClosedFeeRows: null,
            payFeeFormData: {}, //form data
            termsAccepted: false,
            chequeIssuedTo: '',
            chequeNo: '',
            chequeDate: new Date(),
            bankName: '',
            bankBranchName: '',
            destinationBank: '',
            transctionId: '',
            partialPayment: '',
            bankOptions: [],
            isEnableReceipt: false,
            installmentInfo: [],
            isInstallmentInfo: false,
            receiptModificationData: {},
            receipts: [],
            receiptsSummary: {
                totalPaid: 0,
                receiptCount: 0
            },
            showConfirmationDialog: false,
            modificationSummary: null,
            showFeePreview: false,
            modificationRemarks: '', // New state property for modification remarks
            // NTT Payment related states
            showNTTPayment: false,
            nttPaymentData: null,
            // Organization ID for multi-tenant support
            orgId: localStorage.getItem('selectedOrgId') || '',
            // Payment gateway settings from general settings
            paymentGatewayWeb: false,
            paymentGatewayBoth: false,
            paymentGatewayMobile: false,
            // Ad hoc charge collection
            adHocCollectDialogVisible: false,
            adHocCollectCharge: null,
            adHocCollectPaymentType: '74b95cc8-9736-44a0-b2df-325595783c3b',
            adHocCollectAmount: ''
        };
        this.debouncedApiCall = debounce(this.getTermBasedData, 500);
        this.service = new Service();
    }

    /**
     * Update URL query parameters when student is searched or other params change
     */
    updateURLQueryParams = (studentId = null, additionalParams = {}) => {
        const { navigate, location } = this.props;
        if (!navigate || !location) return;

        const searchParams = new URLSearchParams(location.search);

        // Handle studentId
        if (studentId) {
            searchParams.set('studentId', studentId);
        } else if (studentId === null) {
            searchParams.delete('studentId');
        }

        // Handle additional parameters
        Object.keys(additionalParams).forEach(key => {
            const value = additionalParams[key];
            if (value !== null && value !== undefined && value !== '') {
                searchParams.set(key, value);
            } else {
                searchParams.delete(key);
            }
        });

        // Construct the new URL
        const newSearch = searchParams.toString();
        const newPath = location.pathname + (newSearch ? `?${newSearch}` : '');

        // Update the URL without causing a re-render
        navigate(newPath, { replace: true });
    };
    /**
     * Get studentId from URL query parameters on component mount
     */
    getStudentIdFromURL = () => {
        const { location } = this.props;
        if (!location) return null;

        const searchParams = new URLSearchParams(location.search);
        return searchParams.get('studentId');
    };
    /**
     * Get all URL query parameters
     */
    getAllURLParams = () => {
        const { location } = this.props;
        if (!location) return {};

        const searchParams = new URLSearchParams(location.search);
        const params = {};

        for (let [key, value] of searchParams.entries()) {
            params[key] = value;
        }

        return params;
    };
    /**
     * Get specific URL parameter by key
     */
    getURLParam = (key) => {
        const { location } = this.props;
        if (!location) return null;

        const searchParams = new URLSearchParams(location.search);
        return searchParams.get(key);
    };
    /**
     * Get current organization ID from state or localStorage
     */
    getCurrentOrgId = () => {
        return this.state.orgId || localStorage.getItem('orgId') || '';
    };
    /**
     * Static method to generate URL with parameters for navigation from other components
     * Example usage: const url = CollectFee.generateURL({ studentId: '123', searchLevel: 2, tab: 1 });
     */
    static generateURL = (params = {}) => {
        const searchParams = new URLSearchParams();

        Object.keys(params).forEach(key => {
            const value = params[key];
            if (value !== null && value !== undefined && value !== '') {
                searchParams.set(key, value);
            }
        });

        const search = searchParams.toString();
        return `/collect-fee${search ? `?${search}` : ''}`;
    };

    /**
     * Check if URL contains payment success parameters
     */
    checkPaymentSuccessFromURL = () => {
        const { location } = this.props;
        if (!location) return null;

        // Handle URLs that might have encoded characters or malformed query strings
        let searchString = location.search;

        // If the URL has multiple question marks, use only the first part
        if (searchString.includes('?', 1)) {
            searchString = '?' + searchString.split('?').slice(1).join('&');
        }

        const searchParams = new URLSearchParams(searchString);

        // Check for payment success indicators
        const status = searchParams.get('status');
        const txnId = searchParams.get('txnId');
        const atomTxnId = searchParams.get('atomTxnId');
        const amount = searchParams.get('amount');
        const date = searchParams.get('date');
        const mode = searchParams.get('mode');
        const bankTxnId = searchParams.get('bankTxnId');

        // If we have payment success parameters, return the payment data
        if (status === 'success' && (txnId || atomTxnId)) {
            console.log('Payment success data extracted from URL:', {
                status,
                txnId,
                atomTxnId,
                amount,
                date,
                mode,
                bankTxnId
            });

            return {
                status,
                txnId,
                atomTxnId,
                amount: amount ? parseFloat(amount) : null,
                date: date ? decodeURIComponent(date) : null,
                mode,
                bankTxnId,
                // Additional data for receipt creation
                transactionId: atomTxnId || txnId,
                paymentMode: mode,
                amountPaid: amount ? parseFloat(amount) : null,
                transactionDate: date ? decodeURIComponent(date) : new Date().toISOString()
            };
        }

        return null;
    };

    /**
     * Handle payment success from URL and show receipt immediately
     */
    handlePaymentSuccessFromURL = (paymentData, studentId) => {
        console.log('Handling payment success from URL:', paymentData, 'for student:', studentId);

        // Set initial loading state
        this.setState({
            studentId: studentId,
            tab: 1,
            isLoading: true,
            searchLevel: 2
        });

        // Immediately call API to fetch latest receipt data
        this.fetchAndShowLatestReceipt(paymentData, studentId);
    };

    /**
     * Fetch and show the latest receipt using the new API endpoint
     */
    fetchAndShowLatestReceipt = (paymentData, studentId) => {
        console.log('Fetching latest receipt from API for student:', studentId);

        const payload = {
            user_id: studentId,
            academicYear: localStorage.getItem('userAcademicYear')
        };

        // Use the new API endpoint
        const url = `${baseUrlAdmin}/fee-collect/student-fee-info`;

        this.service.post(url, payload, true)
            .then(response => {
                console.log('API Response:', response);

                if (response?.status && response?.res?.data?.receipts) {
                    const apiData = response.res.data;
                    const receipts = apiData.receipts;
                    const userInfo = apiData.user_info;
                    const receiptsSummary = apiData.receiptsSummary;

                    // Find the latest receipt (by transaction ID or most recent)
                    let latestReceipt = null;

                    // First try to find receipt by transaction ID
                    if (paymentData.atomTxnId || paymentData.txnId) {
                        latestReceipt = receipts.find(receipt =>
                            receipt.transctionId === paymentData.atomTxnId ||
                            receipt.transctionId === paymentData.txnId ||
                            receipt.bankTxnId === paymentData.bankTxnId
                        );
                    }

                    // If not found by transaction ID, get the most recent receipt
                    if (!latestReceipt && receipts.length > 0) {
                        // Sort by creation date (most recent first)
                        const sortedReceipts = receipts.sort((a, b) => {
                            const dateA = new Date(a.createdAt || a.receiptDate);
                            const dateB = new Date(b.createdAt || b.receiptDate);
                            return dateB - dateA;
                        });
                        latestReceipt = sortedReceipts[0];
                    }

                    if (latestReceipt) {
                        // Process fee paid details to ensure numeric values
                        if (latestReceipt.feePaidDetails && Array.isArray(latestReceipt.feePaidDetails)) {
                            latestReceipt.feePaidDetails = latestReceipt.feePaidDetails.map(detail => ({
                                ...detail,
                                amountPaying: Number(detail.amountPaying || 0),
                                amountPaid: Number(detail.amountPaid || 0),
                                termWiseActualValue: Number(detail.termWiseActualValue || 0),
                                totalFee: Number(detail.totalFee || 0),
                                balance: Number(detail.balance || 0),
                                gstPaidNow: Number(detail.gstPaidNow || 0),
                                gst: Number(detail.gst || 0),
                                gstPaid: Number(detail.gstPaid || 0)
                            }));
                        }

                        // Ensure amount fields are numbers
                        latestReceipt.amountPaid = Number(latestReceipt.amountPaid || 0);
                        latestReceipt.totalAmount = Number(latestReceipt.totalAmount || latestReceipt.amountPaid || 0);

                        console.log('Latest receipt found:', latestReceipt);

                        // Prepare state update
                        const stateUpdate = {
                            isLoading: false,
                            isEnableReceipt: true,
                            receiptData: latestReceipt,
                            receipts: receipts,
                            receiptsSummary: receiptsSummary || {
                                totalPaid: latestReceipt.amountPaid,
                                receiptCount: receipts.length
                            }
                        };

                        // Only update user_info if API returns valid data
                        if (userInfo && Object.keys(userInfo).length > 0) {
                            stateUpdate.user_info = userInfo;
                        }

                        // Update state with actual receipt data
                        this.setState(stateUpdate);

                        // Show success message
                        if (this.toast) {
                            this.toast.show({
                                severity: 'success',
                                summary: 'Payment Successful',
                                detail: `Payment of ₹${Number(latestReceipt.amountPaid || 0).toFixed(2)} completed successfully. Receipt generated.`,
                                life: 5000,
                                position: 'bottom'
                            });
                        }

                        // Update URL parameters to reflect current state
                        const additionalParams = {
                            searchLevel: 2,
                            tab: 1
                        };
                        this.updateURLQueryParams(studentId, additionalParams);

                        // Refresh term-based data to show updated payment status
                        this.getTermBasedData();

                        // Clean up payment URL parameters after showing the receipt
                        setTimeout(() => {
                            this.cleanUpPaymentURLParams();
                        }, 3000);

                    } else {
                        // No receipts found, show fallback message
                        this.handleReceiptNotFound(paymentData, studentId);
                    }
                } else {
                    // API call failed or no data, show fallback
                    console.warn('No receipt data found in API response');
                    this.handleReceiptNotFound(paymentData, studentId);
                }
            })
            .catch(error => {
                console.error('Error fetching latest receipt:', error);
                this.handleReceiptNotFound(paymentData, studentId);
            });
    };

    /**
     * Handle case when receipt is not found in API
     */
    handleReceiptNotFound = (paymentData, studentId) => {
        console.log('Receipt not found, showing fallback message');

        this.setState({
            isLoading: false,
            studentId: studentId,
            tab: 1
        });

        if (this.toast) {
            this.toast.show({
                severity: 'info',
                summary: 'Payment Successful',
                detail: `Payment of ₹${paymentData.amount || 0} completed successfully. Receipt will be available shortly.`,
                life: 5000,
                position: 'bottom'
            });
        }

        // Update URL parameters
        const additionalParams = {
            searchLevel: 2,
            tab: 1
        };
        this.updateURLQueryParams(studentId, additionalParams);

        // Refresh term-based data
        this.getTermBasedData();

        // Clean up payment URL parameters after showing the message
        setTimeout(() => {
            this.cleanUpPaymentURLParams();
        }, 3000);
    };

    /**
     * Get payment mode display name from code
     */
    getPaymentModeDisplay = (modeCode) => {
        const modeMap = {
            'CC': 'Credit Card',
            'DC': 'Debit Card',
            'NB': 'Net Banking',
            'UPI': 'UPI',
            'CASH': 'Cash',
            'CHEQUE': 'Cheque',
            'DD': 'Demand Draft'
        };
        return modeMap[modeCode] || 'Online Payment';
    };

    /**
     * Get payment mode ID from code (these should match your payment mode constants)
     */
    getPaymentModeId = (modeCode) => {
        const modeIdMap = {
            'CC': 'b9e46415-1b11-4377-9105-58b98c230935', // Credit Card
            'DC': '274a4416-2454-4f3a-b741-89c67361ae1f', // Debit Card
            'NB': 'b9e46415-1b11-4377-9105-58b98c230935', // Net Banking (same as CC for now)
            'UPI': 'b9e46415-1b11-4377-9105-58b98c230935', // UPI (same as CC for now)
            'CASH': '74b95cc8-9736-44a0-b2df-325595783c3b', // Cash
            'CHEQUE': '1c98862e-46dc-4454-a120-7d15e2e56e2f', // Cheque
            'DD': '9d08ebab-2d3e-4a30-8460-4e4092fe30a1' // DD
        };
        return modeIdMap[modeCode] || 'b9e46415-1b11-4377-9105-58b98c230935'; // Default to online
    };

    /**
     * Fetch student data to update receipt details using new API endpoint
     */
    fetchStudentDataForReceipt = (studentId, receiptData) => {
        const payload = {
            user_id: studentId,
            academicYear: localStorage.getItem('userAcademicYear')
        };

        // Use the new API endpoint
        const url = `${baseUrlAdmin}/fee-collect/student-fee-info`;

        this.service.post(url, payload, true)
            .then(response => {
                if (response?.status && response?.res?.data) {
                    const apiData = response.res.data;
                    const studentInfo = apiData.user_info;
                    const receipts = apiData.receipts || [];
                    const receiptsSummary = apiData.receiptsSummary;

                    // Update receipt data with actual student details
                    const updatedReceiptData = {
                        ...receiptData,
                        given_name: studentInfo?.given_name || studentInfo?.firstName || 'Student',
                        enrollmentId: studentInfo?.username || 'N/A',
                        className: studentInfo?.className || 'N/A',
                        sectionName: studentInfo?.sectionName || 'N/A',
                        parentName: studentInfo?.parentName || '',
                        // Add more student details as needed
                    };

                    // Prepare state update
                    const stateUpdate = {
                        receiptData: updatedReceiptData,
                        receipts: receipts.length > 0 ? receipts : [updatedReceiptData],
                        receiptsSummary: receiptsSummary || {
                            totalPaid: Number(updatedReceiptData.amountPaid || 0),
                            receiptCount: receipts.length || 1
                        }
                    };

                    // Only update user_info if API returns valid data
                    if (studentInfo && Object.keys(studentInfo).length > 0) {
                        stateUpdate.user_info = studentInfo;
                    }

                    // Update state with actual student data
                    this.setState(stateUpdate);

                    console.log('Student data fetched and receipt updated:', updatedReceiptData);
                }
            })
            .catch(error => {
                console.error('Error fetching student data for receipt:', error);
                // Keep the existing data if fetching fails
            });
    };

    /**
     * Fetch specific receipt by transaction ID using new API endpoint
     */
    fetchSpecificReceipt = (paymentData, studentId) => {
        // First fetch all receipts for the student using new API
        const payload = {
            user_id: studentId,
            academicYear: localStorage.getItem('userAcademicYear')
        };


        // Use the new API endpoint
        const url = `${baseUrlAdmin}/fee-collect/student-fee-info`;

        this.service.post(url, payload, true)
            .then(response => {
                if (response?.status && response?.res?.data?.receipts) {
                    const apiData = response.res.data;
                    const receipts = apiData.receipts;
                    const receiptsSummary = apiData.receiptsSummary;

                    // Try to find the receipt with matching transaction ID
                    const matchingReceipt = receipts.find(receipt => {
                        return receipt.transctionId === paymentData.atomTxnId ||
                            receipt.transctionId === paymentData.txnId ||
                            receipt.bankTxnId === paymentData.bankTxnId;
                    });

                    if (matchingReceipt) {
                        // Process fee paid details to ensure numeric values
                        if (matchingReceipt.feePaidDetails && Array.isArray(matchingReceipt.feePaidDetails)) {
                            matchingReceipt.feePaidDetails = matchingReceipt.feePaidDetails.map(detail => ({
                                ...detail,
                                amountPaying: Number(detail.amountPaying || 0),
                                amountPaid: Number(detail.amountPaid || 0),
                                termWiseActualValue: Number(detail.termWiseActualValue || 0),
                                totalFee: Number(detail.totalFee || 0),
                                balance: Number(detail.balance || 0),
                                gstPaidNow: Number(detail.gstPaidNow || 0),
                                gst: Number(detail.gst || 0),
                                gstPaid: Number(detail.gstPaid || 0)
                            }));
                        }

                        // Show success message
                        if (this.toast) {
                            this.toast.show({
                                severity: 'success',
                                summary: 'Payment Successful',
                                detail: `Payment of ₹${Number(matchingReceipt.amountPaid || paymentData.amount || 0).toFixed(2)} completed successfully. Receipt found.`,
                                life: 5000
                            });
                        }

                        // Prepare state update for matching receipt
                        const stateUpdate = {
                            isEnableReceipt: true,
                            receiptData: matchingReceipt,
                            receipts: receipts,
                            receiptsSummary: receiptsSummary || {
                                totalPaid: Number(matchingReceipt.amountPaid || 0),
                                receiptCount: receipts.length
                            },
                            isLoading: false
                        };

                        // Only update user_info if API returns valid data
                        if (apiData.user_info && Object.keys(apiData.user_info).length > 0) {
                            stateUpdate.user_info = apiData.user_info;
                        }

                        // Show the specific receipt
                        this.setState(stateUpdate);
                    } else {
                        // Receipt not found yet, show general success message
                        if (this.toast) {
                            this.toast.show({
                                severity: 'info',
                                summary: 'Payment Successful',
                                detail: `Payment of ₹${paymentData.amount} completed successfully. Receipt will be available shortly.`,
                                life: 5000
                            });
                        }

                        // Prepare state update for no matching receipt
                        const stateUpdate = {
                            receipts: receipts,
                            receiptsSummary: receiptsSummary || { totalPaid: 0, receiptCount: receipts.length },
                            isLoading: false
                        };

                        // Only update user_info if API returns valid data
                        if (apiData.user_info && Object.keys(apiData.user_info).length > 0) {
                            stateUpdate.user_info = apiData.user_info;
                        }

                        this.setState(stateUpdate);
                    }
                } else {
                    this.setState({ isLoading: false });

                    if (this.toast) {
                        this.toast.show({
                            severity: 'warning',
                            summary: 'Payment Successful',
                            detail: `Payment of ₹${paymentData.amount} completed successfully. Please check receipts section.`,
                            life: 5000
                        });
                    }
                }
            })
            .catch(error => {
                console.error('Error fetching receipt:', error);
                this.setState({ isLoading: false });

                if (this.toast) {
                    this.toast.show({
                        severity: 'success',
                        summary: 'Payment Successful',
                        detail: `Payment of ₹${paymentData.amount} completed successfully.`,
                        life: 5000
                    });
                }
            });
    };

    /**
     * Clean up payment-related URL parameters while keeping studentId
     */
    cleanUpPaymentURLParams = () => {
        const { navigate, location } = this.props;
        if (!navigate || !location) return;

        // Handle complex URLs with multiple query sections
        let searchString = location.search;

        // If the URL has multiple question marks, use only the first part
        if (searchString.includes('?', 1)) {
            searchString = '?' + searchString.split('?').slice(1).join('&');
        }

        const searchParams = new URLSearchParams(searchString);

        // Preserve important application state parameters
        const preservedParams = {};
        const importantParams = [
            'studentId', 'searchLevel', 'tab', 'boardId', 'branchId',
            'classId', 'sectionId', 'searchValue', 'username', 'orgId'
        ];

        importantParams.forEach(param => {
            const value = searchParams.get(param);
            if (value) {
                preservedParams[param] = value;
            }
        });

        // Remove payment-related parameters
        const paymentParams = [
            'status', 'txnId', 'atomTxnId', 'amount', 'date', 'mode', 'bankTxnId',
            'payment', 'success', // Additional cleanup for malformed URLs
        ];

        // Create clean URL with preserved parameters
        const newSearchParams = new URLSearchParams();
        Object.keys(preservedParams).forEach(key => {
            newSearchParams.set(key, preservedParams[key]);
        });

        const newSearch = newSearchParams.toString();
        const newPath = location.pathname + (newSearch ? `?${newSearch}` : '');

        console.log('Cleaning URL from:', location.pathname + location.search, 'to:', newPath);
        navigate(newPath, { replace: true });
    };

    openAdHocCollectDialog = (rowData) => {
        this.setState({
            adHocCollectDialogVisible: true,
            adHocCollectCharge: rowData,
            adHocCollectAmount: String(rowData?.dueAmount || rowData?.balance || ''),
            adHocCollectPaymentType: '74b95cc8-9736-44a0-b2df-325595783c3b'
        });
    };

    collectAdHocCharge = async () => {
        const { adHocCollectCharge, adHocCollectPaymentType, adHocCollectAmount } = this.state;
        if (!adHocCollectCharge?.adHocChargeId) {
            this.toast.show({ severity: 'error', summary: 'Error', detail: 'Invalid charge selected', life: 3000 });
            return;
        }
        const amount = Number(adHocCollectAmount);
        if (!amount || amount <= 0) {
            this.toast.show({ severity: 'error', summary: 'Error', detail: 'Please enter a valid amount', life: 3000 });
            return;
        }

        this.setState({ isLoading: true });
        try {
            const payload = {
                academicYear: localStorage.getItem('userAcademicYear'),
                user_id: this.state.studentId,
                chargeIds: [adHocCollectCharge.adHocChargeId],
                amountPaying: amount,
                paymentType: adHocCollectPaymentType,
                transactionDate: new Date(),
                remarks: 'Collected via Collect Fee'
            };
            const response = await this.service.post(`${baseUrlAdmin}/student-additional-charges/collect`, payload, true);
            if (response?.status && response?.res?.status) {
                this.toast.show({ severity: 'success', summary: 'Success', detail: 'Ad hoc charge collected successfully', life: 3000 });
                this.setState({ adHocCollectDialogVisible: false, adHocCollectCharge: null, adHocCollectAmount: '' });
                this.getTermBasedData();
            } else {
                throw new Error(response?.res?.message || 'Failed to collect charge');
            }
        } catch (error) {
            this.toast.show({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
        } finally {
            this.setState({ isLoading: false });
        }
    };

    onHandlePayFee = (data) => {
        const { payFeeFormData } = this.state;
        const updatedFormData = { ...payFeeFormData, installmentId: data.installmentId, dueAmount: data.dueAmount, feeinstallmentTitle: data?.feeinstallmentTitle };
        this.setState({
            openCreateFeeDialog: true,
            feeInfoToPayFee: data,
            payFeeFormData: updatedFormData
        });
    };

    onHandleCustomFee = () => {
        this.setState({
            openCreateFeeDialog: true
        });
    };

    calculateFine = () => {
        let academicYear = localStorage.getItem('userAcademicYear');
        this.setState({ loading: true });
        let url = `${baseUrlAdmin}/fine/fine-apply?academicYear=${academicYear}`;
        this.service
            .post(url, { user_id: this.state.studentId, academicYear: academicYear }, true)
            .then((data) => {
                if (data.status) {
                    this.setState({ loading: false });
                    this.toast.show({ severity: 'success', summary: 'Successful', detail: data?.res?.message, life: 3000 });
                    this.getTermBasedData();
                } else {
                    this.setState({ isLoading: false });
                    this.toast.show({ severity: 'error', detail: 'Some error occurred', summary: 'Error', life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', detail: 'Some error occurred', summary: 'Error', life: 3000 });
            });
    };

    OnPayFee = () => {
        let academicYear = localStorage.getItem('userAcademicYear');
        let data = this.state.payFeeFormData;
        this.setState({ isLoading: true });
        let url = `${baseUrlAdmin}/fee-collect`;

        // Set amount paying based on partial payment flag
        data.amountPaying = this.state.partialPayment ? data.amountPaying : data?.dueAmount;

        // If using advance amount, ensure amount does not exceed available advance
        if (this.state.useAdvanceAmount && this.state.advanceInfo) {
            const advanceAmount = this.state.advanceInfo.advance;
            if (Number(data.amountPaying) > advanceAmount) {
                data.amountPaying = advanceAmount.toString();
                // Show toast notification
                this.toast.show({
                    severity: 'info',
                    summary: 'Advance Amount Used',
                    detail: `Amount limited to available advance: ₹${advanceAmount}`,
                    life: 3000
                });
            }
        }

        let payload = {
            branchId: this.state?.dropdownsData?.branchId,
            boardId: this.state?.dropdownsData?.boardId,
            classId: this.state?.dropdownsData?.classId,
            sectionId: this.state?.dropdownsData?.sectionId,
            studentId: this.state?.studentId,
            paymentType: data?.paymentType,
            amountPaying: Math.floor(Number(data?.amountPaying) * 100) / 100,
            remarks: data?.remarks,
            academicYear: academicYear,
            transactionDate: convertUtc(this.state.transactionDate),
            useAdvanceAmount: this.state.useAdvanceAmount ?? false
        };

        if (this.state.partialPayment) {
            delete payload?.term;
            payload.feeinstallmentTitle = data.feeinstallmentTitle
            payload.installmentId = data.installmentId
        }

        //cash
        if (data?.paymentType === '74b95cc8-9736-44a0-b2df-325595783c3b') {
            payload.destinationBank = this.state.destinationBank;
        } else if (data?.paymentType === '1c98862e-46dc-4454-a120-7d15e2e56e2f') {
            //cheque
            payload.chequeIssuedTo = this.state.chequeIssuedTo;
            payload.chequeNo = this.state.chequeNo;
            payload.chequeDate = convertUtc(this.state.chequeDate);
            payload.bankName = this.state.bankName;
            payload.bankBranchName = this.state.bankBranchName;
            payload.destinationBank = this.state.destinationBank;
        } else if (data?.paymentType === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1') {
            //dd
            payload.ddIssuedTo = this.state.chequeIssuedTo;
            payload.ddNo = this.state.chequeNo;
            payload.ddDate = convertUtc(this.state.chequeDate);
            payload.bankName = this.state.bankName;
            payload.bankBranchName = this.state.bankBranchName;
            payload.destinationBank = this.state.destinationBank;
        } else if (
            data?.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' ||
            data?.paymentType === 'b9e46415-1b11-4377-9105-58b98c230935' ||
            data?.paymentType === '274a4416-2454-4f3a-b741-89c67361ae1f' ||
            data?.paymentType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489'
        ) {
            payload.transctionId = this.state?.transctionId;
        }

        if (data?.paymentType === 'b9e46415-1b11-4377-9105-58b98c230935' ||
            data?.paymentType === '274a4416-2454-4f3a-b741-89c67361ae1f') {
            payload.cardNo = this.state?.cardNo;
            payload.approvalCode = this.state?.approvalCode;
            payload.rrNumber = this.state?.rrNumber;
            payload.userBankName = this.state?.userBankName;
        }

        const formStatus = isFormValid(createFields, this.formFields.formValidations, data);
        let isCompleteFormValid = true;
        if (!formStatus.formValidations.isFormValid) {
            this.setState({ formValidations: formStatus.formValidations });
            isCompleteFormValid = false;
        }
        let chequeFlag =
            data?.paymentType === '1c98862e-46dc-4454-a120-7d15e2e56e2f' || data?.paymentType === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1'
                ? this.state.bankName !== '' &&
                this.state.bankName !== undefined &&
                this.state.chequeIssuedTo !== '' &&
                this.state.chequeIssuedTo !== undefined &&
                this.state.chequeNo !== '' &&
                this.state.chequeNo !== undefined &&
                this.state.chequeDate !== '' &&
                this.state.chequeDate !== undefined &&
                this.state.bankBranchName !== '' &&
                this.state.bankBranchName !== undefined
                : true;
        let flag = true
        let flag2 = /^\d*\.?\d*$/.test(data?.amountPaying);
        if (isCompleteFormValid && chequeFlag && flag && flag2) {
            this.service
                .post(url, payload, true)
                .then((data) => {
                    if (data.status) {
                        this.setState({
                            openCreateFeeDialog: false,
                            chequeIssuedTo: '',
                            chequeNo: '',
                            ddDate: '',
                            bankName: '',
                            bankBranchName: '',
                            destinationBank: '',
                            transctionId: '',
                            payFeeFormData: {},
                            isLoading: false,
                            isEnableReceipt: true,
                            receiptData: data?.res?.data,
                            chequeDate: new Date(),
                            approvalCode: '',
                            rrNumber: '',
                            userBankName: '',
                            cardNo: '',
                            transactionDate: null,
                            useAdvanceAmount: false
                        });
                        this.toast.show({ severity: 'success', summary: 'Successful', detail: data?.res?.message, life: 3000 });
                        this.getTermBasedData();
                    } else {
                        this.setState({ isLoading: false });
                        this.toast.show({ severity: 'error', detail: data.errMessage, summary: 'Error', life: 3000 });
                    }
                })
                .catch((e) => {
                    this.setState({ isLoading: false });
                    this.toast.show({ severity: 'error', detail: 'Some error occurred', summary: 'Error', life: 3000 });
                });
        } else {
            if (!chequeFlag) {
                this.setState({ isLoading: false });
                this.toast?.show({ severity: 'error', summary: 'Please Check Validation', detail: 'Please Enter All Require Fields', life: 3000 });
            } else if (!flag) {
                this.setState({ isLoading: false });
                this.toast?.show({ severity: 'error', summary: 'Please Check Validation', detail: 'Please Enter Transaction Id ', life: 3000 });
            } else if (!flag2) {
                this.setState({ isLoading: false });
                this.toast?.show({ severity: 'error', summary: 'Please Check Amount', detail: 'Please enter valid amount', life: 3000 });
            } else {
                this.setState({ isLoading: false });
                this.toast?.show({ severity: 'error', summary: 'Validation Failed', detail: 'Please Enter all Required Fields', life: 3000 });
            }
        }
    };

    // ////////////PG SDK or Script loading////////
    loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    // loadCashfreeSDK = () => {
    // }
    handlePayment = async () => {
        let payType = this.state.payFeeFormData?.paymentType;
        let a = this.state.partialPayment ? this.state.payFeeFormData?.amountPaying : this.state.payFeeFormData?.dueAmount
        // Default payment gateway - can be configured via environment variable
        let PGtype = process.env.REACT_APP_DEFAULT_PAYMENT_GATEWAY || 'ntt_data';
        // let PGtype = 'cashfree';

        if (payType?.length && a > 0) {
            // Check if payment type is Online (1b1a76b4-c538-4968-a20b-0e5a3b4a1c54)
            if (payType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54') {
                // Check if Web Application is enabled in general settings
                if (!this.state.paymentGatewayWeb && !this.state.paymentGatewayBoth) {
                    this.toast.show({
                        severity: 'warn',
                        summary: 'Online Payment is Off',
                        detail: 'Online payment is off in Finance General Settings. Please enable Web Application payment gateway to proceed.',
                        life: 5000
                    });
                    return;
                }
            }

            if (payType === '74b95cc8-9736-44a0-b2df-325595783c3b' || payType === '1c98862e-46dc-4454-a120-7d15e2e56e2f' || payType === "9d08ebab-2d3e-4a30-8460-4e4092fe30a1" || payType === 'b9e46415-1b11-4377-9105-58b98c230935' || payType === "274a4416-2454-4f3a-b741-89c67361ae1f" || payType === '44f6b4d2-9f04-454c-b733-045a1bec3f39') {
                this.OnPayFee()
            } else {
                this.handlePaymentGateway(PGtype);
            }
        } else {
            this.toast.show({ severity: 'error', summary: 'Please Check Validation', detail: 'Please Fill Payment Type And Amount', life: 3000 });

        }
    };

    handlePaymentGateway = async (PGType) => {
        switch (PGType) {
            case 'razorpay': {
                const res = await this.loadRazorpayScript();
                if (!res) {
                    alert("Failed to load Razorpay SDK. Check your internet connection.");
                    return;
                }
                let url = `${baseUrlAdmin}/create-order`;
                let vurl = `${baseUrlAdmin}/verify-payment`;

                let payload = {
                    amount: this.state.partialPayment ? this.state.payFeeFormData?.amountPaying * 100 : this.state.payFeeFormData?.dueAmount * 100,
                    currency: "INR"
                }
                // Get order details from your backend
                const { data: order } = await Axios.post(url, payload);

                const options = {
                    key: "rzp_test_rJgczs9D0fmDjk", // Replace with your Razorpay key
                    amount: order.amount,
                    currency: order.currency,
                    name: "Classet",
                    description: "Purchase Description",
                    image: `https://${profilesBucket}.s3.${awsRegion}.amazonaws.com/uploads/17358829538761712311939159IMG-20231127-WA0017%20-%20Copy.jpg`,
                    order_id: order.id,
                    handler: async (response) => {
                        const result = await Axios.post(vurl, {
                            order_id: order.id,
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_signature: response.razorpay_signature,
                        });
                        this.setState({
                            transctionId: response.razorpay_payment_id
                        }, () => {
                            this.OnPayFee();
                        })
                    },


                    prefill: {
                        name: "Monangi Kiran",
                        email: "kiranm@classet.in",
                        contact: "7799279701",
                    },
                    theme: {
                        color: "#3399cc",
                    },
                };

                const paymentObject = new window.Razorpay(options);
                console.log("RAZOR", paymentObject)
                paymentObject.open();
            }; break;
            case 'cashfree': {
                let parentContactNumer;
                if (this.state.searchLevel === 2) {
                    parentContactNumer = this.state?.dropdownsData?.parentContactNumber[0];
                }

                const url = `${baseUrlAdmin}/cashfree/create-order`;
                const payload = {
                    orgId: localStorage.getItem('orgId'),
                    academicYear: localStorage.getItem('userAcademicYear'),
                    platform: 'web',
                    order_amount: this.state.partialPayment ? this.state.payFeeFormData?.amountPaying : this.state.payFeeFormData?.dueAmount,
                    order_currency: "INR",
                    order_id: "order_" + uuidv4(), // Generate a unique order ID using uuid
                    customer_details: {
                        // customer_name: "hello",
                        customer_name: this.state?.user_info?.firstName && this.state?.user_info?.lastName
                            ? `${this.state.user_info.firstName} ${this.state.user_info.lastName}`.trim()
                            : this.state?.user_info?.given_name,
                        customer_id: this.state?.studentId || this.state?.dropdownsData?.students?.user_id,
                        customer_email: this.state?.user_info?.email,
                        customer_phone: this.state.searchLevel === 2 ? parentContactNumer : this.state.user_info?.parentContactNo, // Include parent contact number if available
                        // customer_phone: this.state?.dropdownsData?.students?.phone_number || "7330707182",
                    },
                    order_meta: {
                        return_url: null,
                    },
                };

                this.setState({ isLoading: true });

                // Try asymmetric encryption first, fallback to symmetric, then unencrypted
                const encryptPayload = async (payload) => {
                    try {
                        // Use only asymmetric (hybrid) encryption for strong security
                        const hybridEncrypted = await asymmetricEncryptionUtils.prepareEncryptedPayload(payload);

                        if (hybridEncrypted.hybridEncrypted) {

                            return hybridEncrypted;
                        }

                        // If encryption fails, throw error instead of sending unencrypted data
                        throw new Error('Hybrid encryption failed');

                    } catch (error) {

                        throw new Error('Payment encryption failed. Please try again.');
                    }
                };

                encryptPayload(payload)
                    .then((encryptedPayload) => {
                        return this.service.post(url, encryptedPayload, true);
                    })
                    .then(async (response) => {
                        this.setState({ isLoading: false });

                        console.log('🔍 Raw Cashfree order creation response:', response);

                        // Decrypt the response if it's encrypted
                        let decryptedResponse = response;

                        // Check if response needs decryption
                        if (response?.res?.encrypted || response?.res?.hybridEncrypted) {
                            try {
                                console.log('🔓 Decrypting Cashfree order creation response...');
                                console.log('🔍 Response structure before decryption:', {
                                    hasRes: !!response.res,
                                    encrypted: response.res?.encrypted,
                                    hybridEncrypted: response.res?.hybridEncrypted,
                                    keys: Object.keys(response.res || {})
                                });

                                // Decrypt using asymmetric encryption utils
                                const decryptedData = await asymmetricEncryptionUtils.decryptResponse(response.res);

                                console.log('✅ Order creation response decrypted successfully');
                                console.log('🔍 Decrypted data structure:', {
                                    hasStatus: !!decryptedData.status,
                                    hasData: !!decryptedData.data,
                                    dataKeys: Object.keys(decryptedData.data || {}),
                                    hasPaymentSessionId: !!decryptedData.data?.payment_session_id
                                });

                                decryptedResponse = {
                                    ...response,
                                    res: decryptedData
                                };

                                // Also create direct data access for backward compatibility
                                decryptedResponse.data = decryptedData.data;
                                decryptedResponse.status = decryptedData.status;

                            } catch (decryptError) {
                                console.error('❌ Error decrypting order creation response:', decryptError);
                                console.warn('⚠️ Using original response due to decryption error');
                                // Continue with original response as fallback
                            }
                        } else {
                            console.log('✅ Response is not encrypted, using as-is');
                            // For unencrypted responses, ensure proper structure
                            if (response.res) {
                                decryptedResponse.data = response.res.data;
                                decryptedResponse.status = response.res.status;
                            }
                        }

                        console.log('🔍 Final decryptedResponse structure:', {
                            hasStatus: !!decryptedResponse.status,
                            hasData: !!decryptedResponse.data,
                            hasResStatus: !!decryptedResponse.res?.status,
                            hasResData: !!decryptedResponse.res?.data,
                            dataKeys: Object.keys(decryptedResponse.data || {}),
                            resDataKeys: Object.keys(decryptedResponse.res?.data || {})
                        });

                        // Check for payment_session_id in correct response structure
                        let paymentSessionId = null;
                        let foundInLocation = '';

                        // Primary locations - check decrypted response first
                        if (decryptedResponse.data?.payment_session_id) {
                            paymentSessionId = decryptedResponse.data.payment_session_id;
                            foundInLocation = 'decryptedResponse.data.payment_session_id';
                        } else if (decryptedResponse.res?.data?.payment_session_id) {
                            paymentSessionId = decryptedResponse.res.data.payment_session_id;
                            foundInLocation = 'decryptedResponse.res.data.payment_session_id';
                        } else if (decryptedResponse.data?.paymentSessionId) {
                            paymentSessionId = decryptedResponse.data.paymentSessionId;
                            foundInLocation = 'decryptedResponse.data.paymentSessionId';
                        } else if (decryptedResponse.res?.data?.paymentSessionId) {
                            paymentSessionId = decryptedResponse.res.data.paymentSessionId;
                            foundInLocation = 'decryptedResponse.res.data.paymentSessionId';
                        }
                        // Fallback locations - check original response
                        else if (response.data?.payment_session_id) {
                            paymentSessionId = response.data.payment_session_id;
                            foundInLocation = 'response.data.payment_session_id (fallback)';
                        } else if (response.res?.data?.payment_session_id) {
                            paymentSessionId = response.res.data.payment_session_id;
                            foundInLocation = 'response.res.data.payment_session_id (legacy fallback)';
                        }

                        // console.log('🔍 Payment session ID search result:', {
                        //     paymentSessionId,
                        //     foundInLocation,
                        //     searchedLocations: [
                        //         'decryptedResponse.data.payment_session_id',
                        //         'decryptedResponse.res.data.payment_session_id',
                        //         'decryptedResponse.data.paymentSessionId',
                        //         'decryptedResponse.res.data.paymentSessionId',
                        //         'response.data.payment_session_id',
                        //         'response.res.data.payment_session_id'
                        //     ]
                        // });



                        if (decryptedResponse.status && paymentSessionId) {



                            //TO CREATE ORDER -> from order, paymentSessionId generated -> payments gets completed.
                            // Open Cashfree checkout modal
                            const checkoutOptions = {
                                paymentSessionId: paymentSessionId,
                                redirectTarget: "_modal",
                            };
                            const initializeCashfree = async () => {
                                const { load } = await import('@cashfreepayments/cashfree-js');
                                // const cashfree = await load({ mode: "sandbox" }); // Use "production" for live environment
                                const cashfreeMode = process.env.REACT_APP_CASHFREE_MODE;
                                const cashfree = await load({ mode: cashfreeMode });



                                cashfree.checkout(checkoutOptions).then((result) => {
                                    if (result.error) {
                                        console.error("Payment error:", result.error);
                                    } else if (result.paymentDetails) {
                                        // console.log("===AFTER PAYMENT DETAILS===:", result);
                                        // console.log("Payment completed successfully:", result.paymentDetails);

                                        // store the payment details.
                                        sendPaymentSessionDetails()
                                        // console.log('PAYLOAD.ORDER_ID:', payload.order_id);
                                    }
                                });
                            };
                            initializeCashfree();

                            // Send and Store 
                            const sendPaymentSessionDetails = async () => {
                                // const isMobile = /Mobi|Android/i.test(navigator.userAgent); // Check if the user is on a mobile device
                                const isDoneThrough = "Web-Admin"
                                const loggedInUser = localStorage.getItem('username'); // Replace 'username' with the key used to store user info
                                // console.log("**********Payment Details:*****************", paymentDetails);

                                try {
                                    // Prepare the verify-and-collect payload
                                    const verifyCollectPayload = {
                                        // orgId: localStorage.getItem('orgId'),
                                        // academicYear: localStorage.getItem('userAcademicYear'),
                                        platform: 'web',

                                        orderId: payload.order_id, // Include order ID in the payload
                                        paymentSessionId: paymentSessionId, // Pass the session ID as payload
                                        paymentDetails: 'payment finished', // Include payment details

                                        academicYear: localStorage.getItem('userAcademicYear'),
                                        orgId: localStorage.getItem('orgId'),
                                        branchId: this.state?.dropdownsData?.branchId,
                                        boardId: this.state?.dropdownsData?.boardId || this.state?.user_info?.boardId,
                                        classId: this.state?.dropdownsData?.classId || this.state?.user_info?.classId,
                                        sectionId: this.state?.dropdownsData?.sectionId || this.state?.user_info?.sectionId,

                                        studentId: this.state?.studentId,
                                        enrollmentNo: this.state?.user_info?.enrollmentId || 'NA', // Include enrollment number if available
                                        feeType: this.state.payFeeFormData?.feeinstallmentTitle || 'fee collect', // Fee type/installment title

                                        parentContactNumber: this.state.searchLevel === 2 ? parentContactNumer : this.state.user_info?.parentContactNo, // Include parent contact number if available

                                        isDoneThrough: isDoneThrough, // Add the flag for web or mobile
                                        loggedInUser: loggedInUser, // Include the logged-in user information
                                    };

                                    // Encrypt verify-and-collect payload with asymmetric encryption only
                                    const encryptVerifyPayload = async (payload) => {
                                        try {
                                            // Use only asymmetric (hybrid) encryption for strong security

                                            const hybridEncrypted = await asymmetricEncryptionUtils.prepareEncryptedPayload(payload);

                                            if (hybridEncrypted.hybridEncrypted) {

                                                return hybridEncrypted;
                                            }

                                            // If encryption fails, throw error instead of sending unencrypted data
                                            throw new Error('Hybrid encryption failed for verify-and-collect');

                                        } catch (error) {

                                            throw new Error('Payment verification encryption failed. Please try again.');
                                        }
                                    };

                                    const encryptedVerifyPayload = await encryptVerifyPayload(verifyCollectPayload);
                                    const response = await this.service.post(`${baseUrlAdmin}/cashfree/verify-and-collect`, encryptedVerifyPayload, true);

                                    // Decrypt the response if it's encrypted (asymmetric only)
                                    let decryptedVerifyResponse = response;
                                    if (response?.res?.encrypted || response?.res?.hybridEncrypted) {
                                        try {
                                            console.log('🔓 Decrypting verify-and-collect response with asymmetric encryption...');

                                            // Use only asymmetric decryption for strong security
                                            let decryptedData = await asymmetricEncryptionUtils.decryptResponse(response.res);

                                            decryptedVerifyResponse = {
                                                ...response,
                                                res: decryptedData
                                            };

                                            console.log('✅ Verify-and-collect response decrypted successfully with RSA + AES');
                                        } catch (decryptError) {
                                            console.error('❌ Error decrypting verify-and-collect response:', decryptError);
                                            // Continue with original response as fallback
                                            console.warn('⚠️ Using original response due to decryption error');
                                        }
                                    }

                                    if (decryptedVerifyResponse?.res?.res?.data) {
                                        // Payment successful - handle receipt generation
                                        console.log(decryptedVerifyResponse?.res)
                                        console.log("Transaction ID from response:", decryptedVerifyResponse?.res?.transactionId);
                                        console.log("Transaction ID from response:", decryptedVerifyResponse?.res?.res?.transactionId);


                                        const receiptData = decryptedVerifyResponse.res.res.data;
                                        const paymentDetails = decryptedVerifyResponse.res.res.paymentDetails;
                                        console.log("Receipt Data:", receiptData);
                                        // console.log("transactionId:", paymentDetails.transactionId);

                                        // Attach transactionId from decryptedVerifyResponse?.res to receiptData
                                        if (decryptedVerifyResponse?.res?.res?.transactionId) {
                                            receiptData.transactionId = decryptedVerifyResponse.res.transactionId || decryptedVerifyResponse?.res?.res?.transactionId;
                                            receiptData.transctionId = decryptedVerifyResponse.res.transactionId || decryptedVerifyResponse?.res?.res?.transactionId; // Also set the misspelled version for compatibility
                                        }

                                        // Set transaction ID from Cashfree payment details or response
                                        const transactionId = decryptedVerifyResponse?.res?.res?.transactionId || paymentDetails?.cf_payment_id || 'N/A';


                                        // Set transaction ID from Cashfree payment details
                                        if (paymentDetails) {
                                            this.setState({
                                                // transctionId: 'fsadjfl',
                                                transctionId: transactionId,
                                            });
                                        }

                                        // Show success message
                                        this.toast.show({
                                            severity: 'success',
                                            summary: 'Payment Successful',
                                            detail: 'Payment completed successfully. Receipt generated.',
                                            life: 3000
                                        });

                                        // Set receipt data and show receipt dialog
                                        this.setState({
                                            isEnableReceipt: true,
                                            receiptData: receiptData,
                                            openCreateFeeDialog: false,
                                            isLoading: false,
                                            // Clear form data
                                            payFeeFormData: {},
                                            transactionDate: null,
                                            chequeIssuedTo: '',
                                            chequeNo: '',
                                            chequeDate: new Date(),
                                            bankName: '',
                                            bankBranchName: '',
                                            destinationBank: '',
                                            transctionId: '',
                                            approvalCode: '',
                                            rrNumber: '',
                                            userBankName: '',
                                            cardNo: ''
                                        });

                                        // Refresh the term-based data to show updated payment status
                                        this.getTermBasedData();

                                        // Optionally refresh receipts if on tab 2
                                        if (this.state.tab === 2) {
                                            this.fetchReceipts();
                                        }

                                    } else {
                                        this.toast.show({
                                            severity: 'error',
                                            summary: 'Error',
                                            detail: decryptedVerifyResponse?.res?.errMessage || 'Failed to verify payment details - receipts',
                                            life: 3000,
                                        });
                                    }

                                    // // Handle the response
                                    // if (response?.res.data.paymentDetailsFromCashfree[0]) {
                                    //     const paymentDet = response.res.data.paymentDetailsFromCashfree;
                                    //     if (Array.isArray(paymentDet) && paymentDet.length > 0) {
                                    //         const cfPaymentId = paymentDet[0]?.cf_payment_id;
                                    //         console.log("CF Payment ID:", cfPaymentId);
                                    //         this.setState({
                                    //             transctionId: cfPaymentId,
                                    //         }, () => {
                                    //             this.OnPayFee(); // Proceed with fee payment
                                    //         });
                                    //     } else {
                                    //         console.error("Payment details are missing or invalid:", paymentDet);
                                    //     }
                                    // } else {
                                    //     console.error("Invalid response structure:", response.data);
                                    // }
                                } catch (error) {
                                    console.error("Error sending payment session details:", error);

                                    // Check if it's an encryption error
                                    if (error.message && error.message.includes('encrypt')) {
                                        this.toast.show({
                                            severity: 'error',
                                            summary: 'Encryption Error',
                                            detail: 'Failed to encrypt payment verification data',
                                            life: 3000,
                                        });
                                    } else {
                                        this.toast.show({
                                            severity: 'error',
                                            summary: 'Error',
                                            detail: 'An error occurred while sending payment session details',
                                            life: 3000,
                                        });
                                    }
                                }
                            };



                        } else {
                            this.toast.show({
                                severity: 'error',
                                summary: 'Error',
                                detail: response.errMessage || 'Failed to create order (or) Cashfree subMerchantId not found for the organization',
                                life: 3000,
                            });
                        }
                    })
                    .catch((error) => {
                        this.setState({ isLoading: false });

                        // Check if it's an encryption error
                        if (error.message && error.message.includes('encrypt')) {
                            this.toast.show({
                                severity: 'error',
                                summary: 'Encryption Error',
                                detail: 'Failed to encrypt request data',
                                life: 3000,
                            });
                            console.error("Encryption error:", error);
                        } else {
                            this.toast.show({
                                severity: 'error',
                                summary: 'Error',
                                detail: 'An error occurred while creating order',
                                life: 3000,
                            });
                            console.error("Error in Cashfree order creation:", error);
                        }
                    });
            }; break;
            case 'ntt_data': {
                // NTT Data Payment Gateway Integration
                this.handleNTTDataPayment();
            }; break;
        }
    };


    /**
     * Handle NTT Data payment initiation
     */
    handleNTTDataPayment = () => {
        const { payFeeFormData, user_info, studentId, dropdownsData } = this.state;

        // Prepare payment data for NTT component
        const paymentData = {
            amount: this.state.partialPayment ? payFeeFormData?.amountPaying : payFeeFormData?.dueAmount,
            studentId: studentId,
            installmentId: payFeeFormData?.installmentId,
            feeType: payFeeFormData?.feeinstallmentTitle || 'fee collect',
            studentName: user_info?.firstName && user_info?.lastName
                ? `${user_info.firstName} ${user_info.lastName}`.trim()
                : user_info?.given_name,
            studentEmail: user_info?.email,
            studentPhone: user_info?.parentContactNo,
            branchId: dropdownsData?.branchId,
            boardId: dropdownsData?.boardId,
            classId: dropdownsData?.classId,
            sectionId: dropdownsData?.sectionId,
            orgId: this.getCurrentOrgId(),

            feeFor: 'Fee Collection'
            // orgId: localStorage.getItem('orgId')
        };

        this.setState({
            showNTTPayment: true,
            nttPaymentData: paymentData
        });
    };

    /**
     * Handle successful NTT payment
     */
    onNTTPaymentSuccess = (paymentResult) => {
        console.log('NTT Payment successful:', paymentResult);

        // Extract transaction ID from payment result
        const transactionId = paymentResult.transactionId || paymentResult.payment_id || paymentResult.atomTxnId || 'N/A';

        // Show success message
        this.toast.show({
            severity: 'success',
            summary: 'Payment Successful',
            detail: 'Payment completed successfully. Receipt generated.',
            life: 3000,
            position: 'bottom'
        });

        // Prepare receipt data similar to Cashfree pattern
        const receiptData = paymentResult.receiptData || paymentResult;

        // Ensure transaction ID is set in both fields for compatibility
        if (receiptData) {
            receiptData.transactionId = transactionId;
            receiptData.transctionId = transactionId; // Also set the misspelled version for compatibility
        }

        // Check if this is an old fee payment (from fee type based payment)
        const isOldFeePayment = this.state.nttPaymentData?.isOldFeePayment || false;

        // Set receipt data and show receipt dialog - following Cashfree pattern
        const stateUpdate = {
            isEnableReceipt: true,
            receiptData: receiptData,
            openCreateFeeDialog: false,
            isLoading: false,
            showNTTPayment: false,
            nttPaymentData: null,
            // Clear form data - same as Cashfree
            payFeeFormData: {},
            transactionDate: null,
            chequeIssuedTo: '',
            chequeNo: '',
            chequeDate: new Date(),
            bankName: '',
            bankBranchName: '',
            destinationBank: '',
            transctionId: '',
            approvalCode: '',
            rrNumber: '',
            userBankName: '',
            cardNo: ''
        };

        // If this is an old fee payment, also clear old fee payment specific fields
        if (isOldFeePayment) {
            stateUpdate.isPayOldFeeInfo = false;
            stateUpdate.receiptDate = null;
            stateUpdate.useAdvanceAmount = false;
            stateUpdate.feeTypeData = [];
        }

        this.setState(stateUpdate);

        // Refresh the term-based data to show updated payment status - same as Cashfree
        this.getTermBasedData();

        // Optionally refresh receipts if on tab 2 - same as Cashfree
        if (this.state.tab === 2) {
            this.fetchReceipts();
        }
    };

    /**
     * Handle NTT payment error
     */
    onNTTPaymentError = (error) => {
        console.error('NTT Payment error:', error);

        this.setState({
            showNTTPayment: false,
            nttPaymentData: null
        });

        if (this.toast) {
            this.toast.show({
                severity: 'error',
                summary: 'Payment Error in collect fee',
                detail: error.message || 'Payment failed. Please try again.',
                life: 5000,
                position: 'bottom'
            });
        }
    };

    /**
     * Handle NTT payment cancellation
     */
    onNTTPaymentCancel = () => {
        console.log('NTT Payment cancelled');

        this.setState({
            showNTTPayment: false,
            nttPaymentData: null
        });

        if (this.toast) {
            this.toast.show({
                severity: 'warn',
                summary: 'Payment Cancelled',
                detail: 'Payment was cancelled by user',
                life: 3000,
                position: 'bottom'
            });
        }
    };

    /**
     * Handle NTT Data payment for old fee payment flow
     */
    handleOldFeeNTTPayment = (PGType, feeInstallments) => {
        if (PGType !== 'ntt_data') {
            // If not NTT payment, use regular payment gateway
            this.handlePaymentGateway(PGType);
            return;
        }

        const { user_info, studentId, dropdownsData } = this.state;

        // Calculate total amount from fee installments
        const totalAmount = feeInstallments.reduce((sum, item) => sum + Number(item.amount || 0), 0);

        // Prepare payment data for NTT component - similar to regular flow but adapted for old fee payment
        const paymentData = {
            amount: totalAmount,
            studentId: studentId,
            feeInstallments: feeInstallments, // Pass the fee installments array
            feeType: 'Old Fee Payment', // Generic type for old fee payments
            studentName: user_info?.firstName && user_info?.lastName
                ? `${user_info.firstName} ${user_info.lastName}`.trim()
                : user_info?.given_name || 'Student',
            studentEmail: user_info?.email || 'student@classet.com',
            studentPhone: user_info?.parentContactNo || '9999999999',
            branchId: dropdownsData?.branchId,
            boardId: dropdownsData?.boardId,
            classId: dropdownsData?.classId,
            sectionId: dropdownsData?.sectionId,
            orgId: this.getCurrentOrgId(),
            // Additional data for old fee payment context
            isOldFeePayment: true,
            receiptDate: this.state?.receiptDate,
            useAdvanceAmount: this.state?.useAdvanceAmount || false,
            paymentType: this.state.payFeeFormData?.paymentType,
            // remarks: this.state.payFeeFormData?.remarks
        };

        this.setState({
            showNTTPayment: true,
            nttPaymentData: paymentData
        });
    };

    onHandleCancelPayFee = () => {
        this.setState({
            openCreateFeeDialog: false,
            chequeIssuedTo: '',
            chequeNo: '',
            ddDate: '',
            bankName: '',
            bankBranchName: '',
            destinationBank: '',
            transctionId: '',
            payFeeFormData: {},
            transactionDate: null,
            useAdvanceAmount: false,
            termsAccepted: false,
            // Reset NTT payment states
            showNTTPayment: false,
            nttPaymentData: null

        });
    };
    componentDidMount = () => {
        this.getBankDetails();
        this.getGeneralSettings(); // Fetch payment gateway settings

        // Get all URL parameters
        const urlParams = this.getAllURLParams();
        const paymentData = this.checkPaymentSuccessFromURL();
        const studentIdFromURL = urlParams.studentId;

        // Log URL parameters for debugging
        console.log('URL Parameters on mount:', urlParams);

        // PRIORITY: Handle payment success first - this bypasses normal flow
        if (paymentData && studentIdFromURL) {
            console.log('PAYMENT SUCCESS detected - showing receipt immediately');
            // Handle payment success scenario immediately
            this.handlePaymentSuccessFromURL(paymentData, studentIdFromURL);
            return; // Exit early to avoid normal data fetching
        }

        // Normal flow: Handle regular student selection from URL
        if (studentIdFromURL) {
            console.log('Student ID found in URL, setting up component:', studentIdFromURL);

            this.setState({
                studentId: studentIdFromURL
            }, () => {
                // Handle additional URL parameters first
                this.handleAdditionalURLParams(urlParams);

                // Determine which data to fetch based on search level and tab
                const searchLevel = parseInt(urlParams.searchLevel) || this.state.searchLevel;
                const tab = parseInt(urlParams.tab) || this.state.tab;

                console.log('Component setup - searchLevel:', searchLevel, 'tab:', tab);

                if (searchLevel === 1) {
                    // If using branch filter, check if we have dropdown data first
                    if (urlParams.branchId || urlParams.boardId || urlParams.classId || urlParams.sectionId) {
                        // We have some dropdown data, fetch students
                        this.getStudents();
                    } else {
                        // No dropdown data, might need to wait for dropdown selection
                        console.log('SearchLevel 1 but no dropdown data in URL');
                    }
                } else if (searchLevel === 2) {
                    // Student search level, fetch term data directly
                    console.log('SearchLevel 2 - fetching term data for student:', studentIdFromURL);
                    this.getTermBasedData();

                    // If tab is 2 (Student Profile), also fetch receipts
                    if (tab === 2) {
                        console.log('Tab 2 - also fetching receipts');
                        this.fetchReceipts();
                    }
                }
            });
        } else {
            // No studentId in URL, but handle other URL parameters
            console.log('No studentId in URL, handling other parameters');
            this.handleAdditionalURLParams(urlParams);
        }
    };

    handleSearchLevel = (value) => {
        // Clear URL parameters when switching search types except studentId
        const currentStudentId = this.state.studentId;
        const additionalParams = { searchLevel: value };

        // Preserve orgId when switching search levels
        if (this.state.orgId) {
            additionalParams.orgId = this.state.orgId;
        }

        this.updateURLQueryParams(currentStudentId, additionalParams);

        this.setState({
            searchLevel: value,
            username: '',
            studentId: '',
            termBasedData: [],
            searchValue: '',  // Clear search value
            dropdownsData: {
                boardId: '',
                branchId: '',
                classId: '',
                sectionId: ''
            },
            receipts: [],
            receiptsSummary: {
                totalPaid: 0,
                receiptCount: 0
            },
            feeTypeInfo: [],
            refundReceipts: [],
            user_info: {},
            tab: 1  // Always set tab to 1 (Term Based) when switching radio buttons
        });
    };

    /**
     * Handle additional URL parameters
     */
    handleAdditionalURLParams = (urlParams) => {
        const {
            searchLevel,
            tab,
            boardId,
            branchId,
            classId,
            sectionId,
            searchValue,
            username,
            studentId,
            orgId
        } = urlParams;

        const stateUpdates = {};
        let shouldFetchData = false;

        // Handle organization ID
        if (orgId) {
            stateUpdates.orgId = orgId;
            // Store orgId in localStorage for API calls
            localStorage.setItem('selectedOrgId', orgId);
        }

        // Handle search level
        if (searchLevel && (searchLevel === '1' || searchLevel === '2')) {
            stateUpdates.searchLevel = parseInt(searchLevel);
        }

        // Handle tab
        if (tab && (tab === '1' || tab === '2')) {
            stateUpdates.tab = parseInt(tab);
        }

        // Handle dropdown values for branch filter (searchLevel = 1)
        if (searchLevel === '1') {
            const dropdownsData = {};
            if (boardId) dropdownsData.boardId = boardId;
            if (branchId) dropdownsData.branchId = branchId;
            if (classId) dropdownsData.classId = classId;
            if (sectionId) dropdownsData.sectionId = sectionId;

            if (Object.keys(dropdownsData).length > 0) {
                stateUpdates.dropdownsData = { ...this.state.dropdownsData, ...dropdownsData };
                shouldFetchData = true;
            }
        }

        // Handle search values for student search (searchLevel = 2)
        if (searchLevel === '2') {
            if (searchValue) stateUpdates.searchValue = searchValue;
            if (username) stateUpdates.username = username;

            // If studentId is provided with searchLevel=2, we should fetch data
            if (studentId) {
                shouldFetchData = true;
            }
        }

        // Update state if there are any changes
        if (Object.keys(stateUpdates).length > 0) {
            console.log('Applying URL parameters to state:', stateUpdates);
            this.setState(stateUpdates, () => {
                // After state is updated, fetch data if needed
                if (shouldFetchData && studentId) {
                    console.log('Fetching data for studentId from URL:', studentId);
                    if (parseInt(searchLevel) === 2) {
                        // For student search level, directly fetch term data
                        this.getTermBasedData();

                        // If tab is 2, also fetch receipts
                        if (parseInt(tab) === 2) {
                            this.fetchReceipts();
                        }
                    } else if (parseInt(searchLevel) === 1) {
                        // For branch filter level, might need to fetch students first
                        this.getStudents();
                    }
                }
            });
        } else if (shouldFetchData && studentId) {
            // Even if no state updates, fetch data if studentId is available
            console.log('Fetching data for studentId from URL (no state changes):', studentId);
            this.getTermBasedData();

            // If tab is 2, also fetch receipts
            if (parseInt(tab) === 2) {
                this.fetchReceipts();
            }
        }
    };

    closedFeeRowExpansionTemplate = (rowData) => {
        const installments = rowData.installmentsInfo || [];
        const fmt = (v) => `₹${(Number(v) || 0).toFixed(2)}`;
        return (
            <div className="p-3" style={{ background: '#fafafa', borderTop: '1px solid #e0e0e0' }}>
                <div className="mb-3 flex align-items-center gap-2">
                    <i className="pi pi-list" style={{ color: '#424242' }}></i>
                    <span style={{ fontFamily: 'InterSemiBold', color: '#212121', fontSize: '14px' }}>
                        Installment Breakdown — {rowData.feeType}
                    </span>
                    <span style={{ fontFamily: 'InterRegular', color: '#757575', fontSize: '12px', marginLeft: '8px' }}>
                        ({installments.length} installment{installments.length !== 1 ? 's' : ''})
                    </span>
                </div>

                <div className="mb-3 flex gap-4 flex-wrap" style={{ background: '#f5f5f5', padding: '10px 14px', borderRadius: '6px', border: '1px solid #e0e0e0' }}>
                    <span style={{ fontFamily: 'InterMedium', fontSize: '13px' }}>
                        <strong>Total Fee:</strong> {fmt(rowData.totalFee)}
                    </span>
                    <span style={{ fontFamily: 'InterMedium', fontSize: '13px' }}>
                        <strong>Amount Paid:</strong> {fmt(rowData.amountPaid)}
                    </span>
                    <span style={{ fontFamily: 'InterMedium', fontSize: '13px' }}>
                        <strong>Closing Amount:</strong> {fmt(rowData.closingAmount)}
                    </span>
                    <span style={{ fontFamily: 'InterMedium', fontSize: '13px' }}>
                        <strong>Closing Paid:</strong> {fmt(rowData.closingAmountPaid)}
                    </span>
                    <span style={{ fontFamily: 'InterMedium', fontSize: '13px' }}>
                        <strong>Reason:</strong> {rowData.reason || '-'}
                    </span>
                    {rowData.closedDate && (
                        <span style={{ fontFamily: 'InterMedium', fontSize: '13px' }}>
                            <strong>Closed On:</strong> {moment(rowData.closedDate).format('DD-MM-YYYY')}
                        </span>
                    )}
                </div>

                <DataTable
                    value={installments}
                    responsiveLayout="scroll"
                    showGridlines
                    size="small"
                    className="dataTableValuesText"
                    emptyMessage="No installment details available for this fee type"
                >
                    <Column
                        header="#"
                        alignHeader="center"
                        bodyClassName="text-center"
                        body={(row, opts) => opts.rowIndex + 1}
                        style={{ width: '50px' }}
                    />
                    <Column
                        header="Installment"
                        field="paymentTerm"
                        alignHeader="center"
                        bodyClassName="text-center"
                    />
                    <Column
                        header="Due Date"
                        alignHeader="center"
                        bodyClassName="text-center"
                        body={(row) => row.dueDate ? moment(row.dueDate).format('DD-MM-YYYY') : '-'}
                    />
                    <Column
                        header="Installment Amount"
                        alignHeader="center"
                        bodyClassName="text-center"
                        body={(row) => fmt(row.termWiseActualValue)}
                    />
                    <Column
                        header="Amount Paid"
                        alignHeader="center"
                        bodyClassName="text-center"
                        body={(row) => fmt(row.amountPaid)}
                    />
                    <Column
                        header="Concession"
                        alignHeader="center"
                        bodyClassName="text-center"
                        body={(row) => fmt(row.concession)}
                    />
                    <Column
                        header="Closing Amount"
                        alignHeader="center"
                        bodyClassName="text-center"
                        body={(row) => fmt(row.amountPaid)}
                    />
                </DataTable>
            </div>
        );
    }

    getTermBasedData = () => {
        if (this.state.tab !== 1) return; // Ensure this function only runs when tab === 1

        this.setState({ isLoading: true, termBasedData: [] });
        const academicYear = localStorage.getItem('userAcademicYear');
        const { lazyParams } = this.state;
        const url = `${baseUrlAdmin}/fee-collect/fee-types?limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=`;

        let payload = {};
        if (this.state.searchLevel === 1 && !this.state.searchValue) {
            payload = {
                branchId: this.state?.dropdownsData?.branchId,
                boardId: this.state?.dropdownsData?.boardId,
                classId: this.state?.dropdownsData?.classId,
                sectionId: this.state?.dropdownsData?.sectionId,
                studentId: this.state.searchLevel === 1 ? this.state?.studentId : "",

                // studentId: this.state?.dropdownsData?.studentId,
                academicYear: academicYear,
                username: this.state.searchLevel === 2 ? this.state.searchValue : '',
                enrollmentNo: this.state.searchLevel === 1 ? this.state.searchValue : '',

                parentContactNumber: this.state?.dropdownsData?.parentContactNumber || '',


            }
        } else {
            payload = {
                // branchId: this.state?.dropdownsData?.branchId,
                // boardId: this.state?.dropdownsData?.boardId,
                // classId: this.state?.dropdownsData?.classId,
                // sectionId: this.state?.dropdownsData?.sectionId,
                studentId: this.state?.studentId,
                // studentId: this.state?.dropdownsData?.studentId,
                academicYear: academicYear,
                parentContactNumber: this.state?.dropdownsData?.parentContactNumber || '',
                username: this.state.searchLevel === 2 ? this.state.searchValue : '',
                enrollmentNo: this.state.searchLevel === 1 ? this.state.searchValue : ''

            }
        }

        this.service.post(url, payload, true)
            .then(data => {
                if (data?.status && data?.res?.data?.length) {
                    // Override partialPayment for avanttpayment user
                    const isAvanttPaymentUser = localStorage.getItem('mobileNoAsUsername') === 'avanttpayment';
                    const partialPaymentValue = isAvanttPaymentUser ? true : data.res.partialPayment;

                    this.setState({
                        termBasedData: data.res.data,
                        isLoading: false,
                        totalRecords: data.res.totalRecords,
                        partialPayment: partialPaymentValue,
                        studentId: data.res.studentId,
                        username: data.res.username,
                        user_info: data.res.user_info,
                        totalStudentDue: Number(data.res.totalStudentDue),
                        advanceInfo: data.res.advanceInfo || {},
                        closedFees: data.res.closedFees || []
                    }, () => {
                        // Update URL when student is found through search
                        if (data.res.studentId) {
                            this.updateURLQueryParams(data.res.studentId);
                        }
                    });
                } else if (data?.status && !data?.res?.data?.length) {
                    this.setState({ isLoading: false, username: null, studentId: null });
                    this.toast.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'No Fee Structure Assigned to Student',
                        life: 3000
                    });
                } else {
                    this.setState({ isLoading: false, username: null, studentId: null });
                    this.toast.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Error Occurred',
                        life: 3000
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching term-based data:', error);
                this.setState({ isLoading: false });
            });
    };

    getStudents = () => {
        this.setState({ isLoading: true });
        let academicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/fine/student?status=Active`; // Add status filter
        // let url = `${baseUrlAdmin}/fine/student`;
        let payload = {
            branchId: this.state.dropdownsData?.branchId,
            boardId: this.state.dropdownsData?.boardId,
            classId: this.state.dropdownsData?.classId,
            sectionId: this.state.dropdownsData?.sectionId,
            academicYear: academicYear,
            status: 'Active' // Add to payload as well
        };
        this.service
            .post(url, payload, true)
            .then((data) => {
                const studentsData = data?.res?.data.map((each) => {
                    return {
                        label: each?.name,
                        value: each?.user_id,
                        parentContactNo: each?.parentContactNo // Add parent contact number
                    };
                });
                console.log("Students Data:=======================", studentsData);


                if (data?.status) {
                    this.setState({
                        students: studentsData,
                        isLoading: false
                    });
                } else {
                    this.setState({ isLoading: false });
                    this.toast.show({ severity: 'error', summary: 'Some error occured', detail: data.errMessage, life: 3000 });
                }
            })
            .catch((error) => {
                this.setState({ isLoading: false });
            });
    };

    getBankDetails = () => {
        this.setState({
            isLoading: true
        });
        const AcademicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/bank?academicYear=${AcademicYear}`;
        this.service.get(url, true).then((data) => {
            const bankOptions = data?.res?.data?.map((each) => {
                return {
                    label: each?.name,
                    value: each?._id
                };
            });

            if (data.status) {
                if (data?.res?.status && data?.res?.data) {
                    this.setState({
                        bankOptions: bankOptions,
                        isLoading: false
                    });
                } else {
                    this.setState({
                        isLoading: false
                    });
                }
            } else {
                this.setState({
                    isLoading: false
                });
            }
        });
    };

    /**
     * Fetch general settings including payment gateway configuration
     */
    getGeneralSettings = () => {
        const academicYear = localStorage.getItem('userAcademicYear');
        const url = `${baseUrlAdmin}/feeSettings?academicYear=${academicYear}`;

        this.service.get(url, true).then((data) => {
            if (data.status && data?.res?.status && data?.res?.data?.feeSettings) {
                const settings = data.res.data.feeSettings;
                this.setState({
                    paymentGatewayWeb: settings?.paymentGatewayWeb || false,
                    paymentGatewayBoth: settings?.paymentGatewayBoth || false,
                    paymentGatewayMobile: settings?.paymentGatewayMobile || false
                });
                console.log('Payment gateway settings loaded:', {
                    web: settings?.paymentGatewayWeb,
                    both: settings?.paymentGatewayBoth,
                    mobile: settings?.paymentGatewayMobile
                });
            }
        }).catch((error) => {
            console.error('Error fetching general settings:', error);
        });
    };


    setDropdownValues = (dropdownsData) => {
        console.log("Dropdowns Data:", dropdownsData);
        let studentId = '';

        // If coming from BranchToSectionDD (array of studentIds)
        if (dropdownsData && Array.isArray(dropdownsData.studentIds) && dropdownsData.studentIds.length > 0) {
            studentId = dropdownsData.studentIds[0];
        }
        // If coming from ClassetStudentSearchFilter (array of single object with studentId)
        else if (
            dropdownsData &&
            Array.isArray(dropdownsData) &&
            dropdownsData.length > 0 &&
            dropdownsData[0].studentId
        ) {
            studentId = dropdownsData[0].studentId;
        }
        // If coming as a direct string (single studentId)
        else if (typeof dropdownsData === 'string') {
            studentId = dropdownsData;
        }

        this.setState(
            {
                dropdownsData,
                termBasedData: [],
                studentId,
                username: '',
                user_info: {},
                tab: 1

            },
            () => {
                // Update URL with studentId and additional parameters when student is selected
                const additionalParams = {};

                // Add search level to URL
                additionalParams.searchLevel = this.state.searchLevel;

                // Add orgId to URL
                if (this.state.orgId) {
                    additionalParams.orgId = this.state.orgId;
                }

                // Add dropdown data for branch search
                if (this.state.searchLevel === 1 && dropdownsData) {
                    if (dropdownsData.boardId) additionalParams.boardId = dropdownsData.boardId;
                    if (dropdownsData.branchId) additionalParams.branchId = dropdownsData.branchId;
                    if (dropdownsData.classId) additionalParams.classId = dropdownsData.classId;
                    if (dropdownsData.sectionId) additionalParams.sectionId = dropdownsData.sectionId;
                }

                this.updateURLQueryParams(studentId, additionalParams);

                if (this.state.searchLevel === 1) {
                    this.getStudents();
                } else {
                    this.getTermBasedData();
                }
            }
        );
    };

    handleSetSearchTypeValue = (value) => {
        this.setState({ searchType: value, termBasedData: [], }, () => {
            if (this.state.searchType == 'studentName') {
                this.setState({ isUserNameSearch: true });
            } else {
                this.setState({ isUserEnrollSearch: true });
            }
        });
    };


    handleSetSearchValue = (value) => {
        if (!value || value.trim() === '') {
            // Clear URL parameters when search is cleared except searchLevel
            this.updateURLQueryParams(null, { searchLevel: this.state.searchLevel });

            // Clear all relevant state for both tabs
            this.setState({
                searchValue: '',
                studentId: '',
                termBasedData: [],
                user_info: {},
                receipts: [],
                receiptsSummary: { totalPaid: 0, receiptCount: 0 },
                feeTypeInfo: [],
                refundReceipts: [],
                tab: 1 // Optionally reset to tab 1
            });
            return;
        }

        this.setState(
            {
                termBasedData: [],
                searchValue: value,
                dropdownsData: {
                    boardId: '',
                    branchId: '',
                    classId: '',
                    sectionId: '',
                    studentId: ''
                }
            },
            () => {
                // Update URL with search value
                this.updateURLQueryParams(null, {
                    searchLevel: this.state.searchLevel,
                    searchValue: value
                });

                if (this.state.searchValue !== '') {
                    this.debouncedApiCall();
                }
            }
        );
    };

    onStudentChange = (e) => {
        this.setState({
            studentId: e.value,
            termBasedData: [],
            receipts: [],
            receiptsSummary: [],
            tab: 1, // <-- This ensures tab 1 is selected
            feeTypeInfo: [],
            refundReceipts: []
        }, () => {
            // Update URL with studentId and current context when student is changed
            const additionalParams = {
                searchLevel: this.state.searchLevel,
                tab: this.state.tab
            };

            // Add orgId to URL
            if (this.state.orgId) {
                additionalParams.orgId = this.state.orgId;
            }

            // Add search value if using student search
            if (this.state.searchLevel === 2 && this.state.searchValue) {
                additionalParams.searchValue = this.state.searchValue;
            }

            this.updateURLQueryParams(e.value, additionalParams);

            this.getTermBasedData();
            this.fetchReceipts();
        });
    };
    onPage = (event) => {
        this.setState((prevState) => {
            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, this.getTermBasedData);
    };
    hideFeeReciept = () => {
        this.setState({
            isEnableRefundReceipt: false,
            isEnableReceipt: false

            //console.log('if needed to remove')
        }, () => {
            // Refresh the student's fee data after closing the receipt
            if (this.state.studentId && this.state.tab === 1) {
                this.getTermBasedData();
            }
        });
    };
    downloadBulkReciepts = (installmentId) => {
        this.setState({ isLoading: true });
        let academicYear = localStorage.getItem('userAcademicYear');
        let { lazyParams } = this.state;
        let url = `${baseUrlAdmin}/fee-collect/receipts`;

        let payload = {
            academicYear: academicYear,
            installmentId: installmentId,
            user_id: this.state.studentId
        };

        this.service
            ?.post(url, payload, true)
            .then((data) => {
                if (data?.status && data?.res?.data?.length) {
                    this.setState({
                        termWiseReceiptInfo: data?.res?.data,
                        isBulkfeeReceipts: true,
                        isLoading: false
                    });
                } else if (data?.status && !data?.res?.data?.length) {
                    this.setState({ isLoading: false });
                    this.toast.show({ severity: 'error', summary: 'Some error occured', detail: 'No Fee Paid By Student', life: 3000 });
                } else {
                    this.setState({ isLoading: false });
                    this.toast.show({ severity: 'error', summary: 'Some error occured', detail: 'Error Occured', life: 3000 });
                }
            })
            .catch((error) => {
                this.setState({ isLoading: false });
            });
    };

    installmentInfo = (data) => {
        this.setState({ isLoading: true });

        let payload = {
            installmentId: data?.installmentId,
            user_id: this.state.studentId,
            academicYear: localStorage.getItem('userAcademicYear')
        }
        let url = `${baseUrlAdmin}/fee-collect/installmentInfo`;
        this.service.post(url, payload, true).then(res => {
            if (res && res?.status) {
                this.setState({
                    installmentInfoData: res?.res?.data,
                    isLoading: false
                })

            } else {
                this.setState({ isLoading: false })
                this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: data.errMessage, life: 3000 });
            }

        }).catch(error => {
            this.setState({ isLoading: false })
            this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: data.errMessage, life: 3000 });
        })
    }

    isshowInstallmentInfo = async (data) => {
        await this.installmentInfo(data)
        this.setState({ isInstallmentInfo: true })
    }
    onHandleInstallmentInfo = () => {
        this.setState({ isInstallmentInfo: false, installmentInfoData: [] })
    }

    getFeeTypesData = () => {
        if (!this.state?.studentId) {
            return this.toast.show({ severity: 'error', summary: "Error", detail: 'Please select the student', life: 3000 });
        }
        this.setState({ isLoading: true })
        let academicYear = localStorage.getItem('userAcademicYear')
        let { lazyParams } = this.state;
        let url = `${baseUrlAdmin}/concession/get-feetype-terms/${this.state?.studentId}?academicYear=${academicYear}`

        this.service.get(url, true).then(data => {

            if (data?.status) {
                const rawAgg = data?.res?.data?.agg || [];
                const feeTypeData = rawAgg;
                this.setState({
                    feeTypeData,
                    advanceInfo: data?.res?.data.advanceInfo,
                    isLoading: false,
                    totalRecords: data?.res?.data?.length,
                })

            } else {
                this.setState({ isLoading: false })
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: data.errMessage, life: 3000 });
            }

        }).catch(error => {
            this.setState({ isLoading: false })

        })
    }
    onHandleFeePayClose = () => {
        this.setState({
            isPayOldFee: false,
            feeTypeData: [],
            useAdvanceAmount: false
        })
    }

    handleUseAdvanceChange = (e) => {
        const useAdvance = e.checked;
        const { advanceInfo, feeTypeData } = this.state;

        // If checked, reset all amounts if advance is selected
        if (useAdvance && advanceInfo && advanceInfo.advance > 0) {
            // Calculate amount to set based on due amount or advance available
            const dueAmount = Number(this.state.payFeeFormData?.dueAmount || 0);
            const advanceAvailable = Number(advanceInfo.advance || 0);

            // Use the smaller of dueAmount or advanceAvailable
            const amountToSet = Math.min(dueAmount, advanceAvailable).toString();

            // Update state with payment type set to Adjustment
            this.setState({
                useAdvanceAmount: useAdvance,
                payFeeFormData: {
                    ...this.state.payFeeFormData,
                    paymentType: "44f6b4d2-9f04-454c-b733-045a1bec3f39", // Adjustment payment type ID
                    amountPaying: amountToSet // Set amount to the calculated value
                }
            });

        } else {
            // If unchecking, reset the payment type and allow selection
            this.setState({
                useAdvanceAmount: useAdvance,
                payFeeFormData: {
                    ...this.state.payFeeFormData,
                    paymentType: useAdvance ? "44f6b4d2-9f04-454c-b733-045a1bec3f39" : "" // Reset payment type if unchecking
                }
            });
        }
    }; handleTermWisePercentageValue = (e, rowData) => {
        let feeAmount = Number(e.target.value);
        const { advanceInfo, useAdvanceAmount } = this.state;

        if (rowData.dueAmount > 0) {
            // Check if using advance amount and limit accordingly
            if (useAdvanceAmount && advanceInfo && advanceInfo.advance > 0) {
                const totalCurrentAmount = this.state.feeTypeData.reduce(
                    (sum, item) => sum + (item._id !== rowData._id ? Number(item.amount || 0) : 0),
                    0
                );

                const maxAdvanceAvailable = advanceInfo.advance - totalCurrentAmount;

                if (feeAmount > maxAdvanceAvailable) {
                    feeAmount = maxAdvanceAvailable > 0 ? maxAdvanceAvailable : 0;
                }
            }

            if (rowData?.dueAmount >= feeAmount) {
                const updatedData = this.state.feeTypeData.map(item => {
                    if (item._id === rowData._id) {
                        return { ...item, amount: feeAmount };
                    }
                    return item;
                });
                this.setState({ feeTypeData: updatedData });
            }
        }
    };

    onHandleCancelOldPayFee = () => {
        this.setState({
            isPayOldFeeInfo: false,
            feeTypeData: [],
            payFeeFormData: {},
            receiptDate: null,
            termsAccepted: false
        })
    }

    onHandleCollectFee = () => {
        if (this.state.studentId) {
            this.setState({ isPayOldFee: false }, () => { this.getFeeTypesData() });
        } else {
            return this.toast.show({ severity: 'error', summary: "Error", detail: 'Please select the student', life: 3000 })
        }
    }

    onHandlePayOldFee = () => {
        let feeInstallments = this.state.feeTypeData.filter(item => item.amount)
        if (feeInstallments.length) {
            this.setState({ isPayOldFee: false, isPayOldFeeInfo: true })
        }
        else {
            return this.toast.show({ severity: 'error', summary: "Error", detail: 'Please enter the fee amount', life: 3000 })
        }
    }

    onHandleOldFeePayment = async () => {
        const allInstallments = this.state.feeTypeData.filter(item => Number(item.amount) > 0);
        const regularInstallments = allInstallments.filter(item => !item.isAdHocCharge);
        const adHocInstallments = allInstallments.filter(item => item.isAdHocCharge);
        const formData = this.state.payFeeFormData;

        let payload = {
            paymentType: formData?.paymentType,
            remarks: formData?.remarks,
            feeInfo: regularInstallments,
            studentId: this.state.studentId,
            academicYear: localStorage.getItem('userAcademicYear'),
            boardId: this.state?.dropdownsData?.boardId,
            branchId: this.state?.dropdownsData?.branchId,
            classId: this.state?.dropdownsData?.classId,
            sectionId: this.state?.dropdownsData?.sectionId,
            receiptDate: this.state?.receiptDate,
            useAdvanceAmount: this.state?.useAdvanceAmount || false,
            destinationBank: this.state?.destinationBank || '',
        };

        if (formData?.paymentType === '74b95cc8-9736-44a0-b2df-325595783c3b') {
            payload.destinationBank = this.state.destinationBank;
        } else if (formData?.paymentType === '1c98862e-46dc-4454-a120-7d15e2e56e2f') {
            payload.chequeIssuedTo = this.state.chequeIssuedTo;
            payload.chequeNo = this.state.chequeNo;
            payload.chequeDate = convertUtc(this.state.chequeDate);
            payload.bankName = this.state.bankName;
            payload.bankBranchName = this.state.bankBranchName;
            payload.destinationBank = this.state.destinationBank;
        } else if (formData?.paymentType === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1') {
            payload.ddIssuedTo = this.state.chequeIssuedTo;
            payload.ddNo = this.state.chequeNo;
            payload.ddDate = convertUtc(this.state.chequeDate);
            payload.bankName = this.state.bankName;
            payload.bankBranchName = this.state.bankBranchName;
            payload.destinationBank = this.state.destinationBank;
        } else if (
            formData?.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' ||
            formData?.paymentType === 'b9e46415-1b11-4377-9105-58b98c230935' ||
            formData?.paymentType === '274a4416-2454-4f3a-b741-89c67361ae1f' ||
            formData?.paymentType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489'
        ) {
            payload.transctionId = this.state?.transctionId;
        }

        if (
            formData?.paymentType === 'b9e46415-1b11-4377-9105-58b98c230935' ||
            formData?.paymentType === '274a4416-2454-4f3a-b741-89c67361ae1f'
        ) {
            payload.cardNo = this.state?.cardNo;
            payload.approvalCode = this.state?.approvalCode;
            payload.rrNumber = this.state?.rrNumber;
            payload.userBankName = this.state?.userBankName;
        }

        const resetState = (receiptData) => {
            this.setState({
                openCreateFeeDialog: false,
                chequeIssuedTo: '',
                chequeNo: '',
                ddDate: '',
                bankName: '',
                isPayOldFeeInfo: false,
                bankBranchName: '',
                destinationBank: '',
                transctionId: '',
                payFeeFormData: {},
                isLoading: false,
                isEnableReceipt: !!receiptData,
                receiptData: receiptData || null,
                chequeDate: new Date(),
                approvalCode: '',
                rrNumber: '',
                userBankName: '',
                cardNo: '',
                transactionDate: null,
                receiptDate: null,
                useAdvanceAmount: false,
            });
            this.getFeeTypesData();
        };

        this.setState({ isLoading: true });

        try {
            let regularReceiptData = null;

            if (regularInstallments.length > 0) {
                const regularResult = await this.service.post(`${baseUrlAdmin}/fee-collect/pay_installment_wise`, payload, true);
                if (!regularResult.status) {
                    throw new Error(regularResult.errMessage || 'Fee collection failed');
                }
                regularReceiptData = regularResult?.res?.data;
            }

            if (adHocInstallments.length > 0) {
                const adHocPayload = {
                    orgId: this.getCurrentOrgId(),
                    academicYear: localStorage.getItem('userAcademicYear'),
                    user_id: this.state.studentId,
                    chargeIds: adHocInstallments.map(item => item.adHocChargeId),
                    amountPaying: adHocInstallments.reduce((sum, item) => sum + Number(item.amount), 0),
                    paymentType: formData?.paymentType,
                    transactionDate: this.state?.receiptDate || new Date(),
                    remarks: formData?.remarks,
                    destinationBank: payload.destinationBank,
                    chequeIssuedTo: payload.chequeIssuedTo,
                    chequeNo: payload.chequeNo,
                    chequeDate: payload.chequeDate,
                    bankName: payload.bankName,
                    bankBranchName: payload.bankBranchName,
                    ddIssuedTo: payload.ddIssuedTo,
                    ddNo: payload.ddNo,
                    ddDate: payload.ddDate,
                    transctionId: payload.transctionId,
                    cardNo: payload.cardNo,
                    approvalCode: payload.approvalCode,
                    rrNumber: payload.rrNumber,
                    userBankName: payload.userBankName,
                };
                const adHocResult = await this.service.post(`${baseUrlAdmin}/student-additional-charges/collect`, adHocPayload, true);
                if (!adHocResult.status) {
                    throw new Error(adHocResult.errMessage || 'One-time charge collection failed');
                }
                if (!regularReceiptData) {
                    regularReceiptData = adHocResult?.res?.data?.receiptData || null;
                }
            }

            this.toast.show({ severity: 'success', summary: 'Successful', detail: 'Fee collected successfully', life: 3000 });
            resetState(regularReceiptData);
        } catch (error) {
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', detail: error?.message || 'Some error occurred', summary: 'Error', life: 3000 });
        }
    }

    fetchReceipts = () => {
        if (this.state.tab !== 2) return;

        const payload = {
            user_id: this.state.studentId,
            academicYear: localStorage.getItem('userAcademicYear')
        };

        // Use the new API endpoint
        const url = `${baseUrlAdmin}/fee-collect/student-fee-info`;
        this.setState({ isLoading: true });

        this.service.post(url, payload, true)
            .then(response => {
                console.log('Receipts API Response:', response);

                if (response?.status && response?.res?.data?.receipts) {
                    const apiData = response.res.data;
                    const receipts = apiData.receipts;
                    const receiptsSummary = apiData.receiptsSummary;
                    const feeTypeInfo = apiData.feeTypeInfo;

                    // Process receipts to ensure numeric values
                    const processedReceipts = receipts.map(receipt => {
                        // Process fee paid details
                        if (receipt.feePaidDetails && Array.isArray(receipt.feePaidDetails)) {
                            receipt.feePaidDetails = receipt.feePaidDetails.map(detail => ({
                                ...detail,
                                amountPaying: Number(detail.amountPaying || 0),
                                amountPaid: Number(detail.amountPaid || 0),
                                termWiseActualValue: Number(detail.termWiseActualValue || 0),
                                totalFee: Number(detail.totalFee || 0),
                                balance: Number(detail.balance || 0),
                                gstPaidNow: Number(detail.gstPaidNow || 0),
                                gst: Number(detail.gst || 0),
                                gstPaid: Number(detail.gstPaid || 0)
                            }));
                        }

                        // Ensure amount fields are numbers
                        receipt.amountPaid = Number(receipt.amountPaid || 0);
                        receipt.totalAmount = Number(receipt.totalAmount || receipt.amountPaid || 0);

                        return receipt;
                    });

                    // Filter receipts by type
                    let feeReceipts = processedReceipts?.filter((each) => each?.receiptType === "receipt");
                    let refundReceipts = processedReceipts?.filter((each) => each?.receiptType === "Refund");

                    // Prepare state update - preserve existing user_info if API doesn't return it
                    const stateUpdate = {
                        receipts: feeReceipts || [],
                        receiptsSummary: receiptsSummary || { totalPaid: 0, receiptCount: 0 },
                        feeTypeInfo: feeTypeInfo || [],
                        refundReceipts: refundReceipts || [],
                        isLoading: false
                    };

                    // Only update user_info if API returns valid data
                    if (apiData.user_info && Object.keys(apiData.user_info).length > 0) {
                        stateUpdate.user_info = apiData.user_info;
                    }

                    this.setState(stateUpdate);
                } else {
                    this.setState({ isLoading: false });
                    this.toast.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: response?.res?.message || response?.message || 'Failed to fetch receipts',
                        life: 3000
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching receipts:', error);
                this.setState({ isLoading: false });
                this.toast.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'An error occurred while fetching receipts',
                    life: 3000
                });
            });
    };
    onReceiptEdit = (data) => {
        this.setState({
            isEnableEditReceipt: true,
            receiptModificationData: data,
        })
    }

    onHandleCancelEditReceipt = () => {
        this.setState({
            isEnableEditReceipt: false,
            modificationSummary: {},
            modifiedTransctionId: '',
            modifiedApprovalCode: '',
            modifiedCardNo: '',
            modifiedUserBankName: '',
            modifiedRrNumber: '',
            receiptModificationData: {},
            modifiedTransactionDate: null,
            modifiedChequeIssuedTo: '',
            modifiedChequeNo: '',
            modifiedChequeDate: null,
            modifiedBankName: '',
            modifiedBankBranchName: '',
            modificationRemarks: ""


        })
    }
    onHandleReceiptModificationSubmit = () => {
        const feePaidDetails = this.state.receiptModificationData.feePaidDetails;

        // Calculate total original amount
        const totalOriginalAmount = feePaidDetails.reduce((sum, item) => sum + Number(item.amountPaying || 0), 0);

        // Calculate total modified amount
        const totalModifiedAmount = feePaidDetails.reduce((sum, item) => sum + Number(item.modifiedAmount || 0), 0);

        // Check if modified amount exceeds original amount
        if (totalModifiedAmount > totalOriginalAmount) {
            this.toast.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Modified amount exceeds the original paid amount. Please pay the fee instead of modifying the receipt.',
                life: 3000
            });
            return;
        }

        // Validate modification remarks
        if (!this.state.modificationRemarks?.trim()) {
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Please enter modification remarks',
                life: 3000
            });
            return;
        }

        const modificationSummary = {
            _id: this.state.receiptModificationData?._id,
            modifiedTransctionId: this.state.modifiedTransctionId,
            modifiedTransactionDate: this.state.modifiedTransactionDate ? convertUtc(this.state.modifiedTransactionDate) : null,
            modifiedApprovalCode: this.state.modifiedApprovalCode,
            modifiedCardNo: this.state.modifiedCardNo,
            modifiedUserBankName: this.state.modifiedUserBankName,
            modifiedRrNumber: this.state.modifiedRrNumber,
            modifiedFeeInfo: feePaidDetails?.filter(each => each?.modifiedAmount).map(each => ({
                ...each,
                amount: Number(each.modifiedAmount) || 0
            })),
            modificationRemarks: this.state.modificationRemarks // Add modificationRemarks to summary
        };


        if (this.state.receiptModificationData?.paymentModeId === '1c98862e-46dc-4454-a120-7d15e2e56e2f') {
            //cheque
            modificationSummary.modifiedChequeIssuedTo = this.state.modifiedChequeIssuedTo;
            modificationSummary.modifiedChequeNo = this.state.modifiedChequeNo;
            modificationSummary.modifiedChequeDate = this.state.modifiedChequeDate ? convertUtc(this.state.modifiedChequeDate) : null;
            modificationSummary.modifiedBankName = this.state.modifiedBankName;
            modificationSummary.modifiedBankBranchName = this.state.modifiedBankBranchName;
        } else if (this.state.receiptModificationData?.paymentModeId === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1') {
            //dd
            modificationSummary.modifiedDdIssuedTo = this.state.modifiedChequeIssuedTo;
            modificationSummary.modifiedDdNo = this.state.modifiedChequeNo;
            modificationSummary.modifiedDdDate = this.state.modifiedChequeDate ? convertUtc(this.state.modifiedChequeDate) : null;
            modificationSummary.modifiedBankName = this.state.modifiedBankName;
            modificationSummary.modifiedBankBranchName = this.state.modifiedBankBranchName;
        }


        // Check if at least one modification has been made
        const hasAnyModification =
            modificationSummary.modifiedTransctionId ||
            modificationSummary.modifiedTransactionDate ||
            modificationSummary.modifiedApprovalCode ||
            modificationSummary.modifiedCardNo ||
            modificationSummary.modifiedUserBankName ||
            modificationSummary.modifiedRrNumber ||
            modificationSummary.modifiedFeeInfo.length > 0 ||
            modificationSummary.modifiedChequeIssuedTo ||
            modificationSummary.modifiedChequeNo ||
            modificationSummary.modifiedChequeDate ||
            modificationSummary.modifiedBankName ||
            modificationSummary.modifiedBankBranchName ||
            modificationSummary.modifiedDdIssuedTo ||
            modificationSummary.modifiedDdNo ||
            modificationSummary.modifiedDdDate;



        if (!hasAnyModification) {
            this.toast.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Please make at least one modification before submitting.',
                life: 3000
            });
            return;
        }

        this.setState({
            showConfirmationDialog: true,
            modificationSummary
        });
    };

    onConfirmModification = () => {
        const { modificationSummary, receiptModificationData } = this.state;
        this.setState({ isLoading: true });
        const url = `${baseUrlAdmin}/receipt-modification/add-receipt-modification`;

        // Prepare payload from modificationSummary
        const payload = {
            _id: modificationSummary._id,
            modifiedTransctionId: modificationSummary.modifiedTransctionId,
            modifiedCardNo: modificationSummary.modifiedCardNo,
            modifiedApprovalCode: modificationSummary.modifiedApprovalCode,
            modifiedRrNumber: modificationSummary.modifiedRrNumber,
            modifiedUserBankName: modificationSummary.modifiedUserBankName,
            modifiedFeeInfo: receiptModificationData.feePaidDetails,
            academicYear: receiptModificationData.academicYear,
            user_id: receiptModificationData.user_id,
            branchId: receiptModificationData.branchId,
            boardId: receiptModificationData.boardId,
            gradeId: receiptModificationData.gradeId,
            sectionId: receiptModificationData.sectionId,
            receiptNo: receiptModificationData.receiptNo,
            receiptDate: receiptModificationData.receiptDate,
            given_name: receiptModificationData.given_name,
            enrollmentId: receiptModificationData.username,
            modifiedTransactionDate: modificationSummary.modifiedTransactionDate,
            modificationRemarks: modificationSummary.modificationRemarks,

        };
        if (receiptModificationData?.paymentModeId === '1c98862e-46dc-4454-a120-7d15e2e56e2f') {
            //cheque
            payload.modifiedChequeIssuedTo = modificationSummary.modifiedChequeIssuedTo
            payload.modifiedChequeNo = modificationSummary.modifiedChequeNo
            payload.modifiedChequeDate = modificationSummary.modifiedChequeDate
            payload.modifiedBankName = modificationSummary.modifiedBankName
            payload.modifiedBankBranchName = modificationSummary.modifiedBankBranchName
        } else if (receiptModificationData?.paymentModeId === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1') {
            //dd
            payload.modifiedDdIssuedTo = modificationSummary.modifiedDdIssuedTo
            payload.modifiedDdNo = modificationSummary.modifiedDdNo
            payload.modifiedDdDate = modificationSummary.modifiedDdDate
            payload.modifiedBankName = modificationSummary.modifiedBankName
            payload.modifiedBankBranchName = modificationSummary.modifiedBankBranchName
        }
        this.service
            .post(url, payload, true)
            .then((response) => {
                if (response.status) {
                    // Close both dialogs
                    this.setState({
                        showConfirmationDialog: false,
                        modificationSummary: null,
                        isEnableEditReceipt: false,
                        isLoading: false,
                        receiptModificationData: {},
                        modifiedTransctionId: '',
                        modifiedApprovalCode: '',
                        modifiedCardNo: '',
                        modifiedUserBankName: '',
                        modifiedRrNumber: '',
                        modifiedChequeNo: '',
                        modifiedChequeDate: null,
                        modifiedBankName: '',
                        modifiedBankBranchName: '',
                        modifiedChequeIssuedTo: '',
                        modifiedChequeNo: '',
                        modifiedChequeDate: null,
                        modifiedBankName: '',
                        modifiedBankBranchName: '',
                        modifiedDdIssuedTo: "",
                        modifiedDdNo: "",
                        modifiedDdDate: null,
                        modifiedTransactionDate: null,
                        modificationRemarks: ''


                    });

                    this.toast.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: response?.res?.message || 'Receipt modifications saved successfully',
                        life: 3000
                    });

                    // Refresh receipts list
                    this.fetchReceipts();
                } else {
                    this.setState({ isLoading: false });
                    this.toast.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: response.errMessage || 'Failed to save modifications',
                        life: 3000
                    });
                }
            })
            .catch((error) => {
                this.setState({ isLoading: false });
                this.toast.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'An error occurred while saving modifications',
                    life: 3000
                });
                console.error('Error in receipt modification:', error);
            });
    };
    onRejectModification = () => {
        this.setState({
            showConfirmationDialog: false,
            modificationSummary: null
        });
    };
    onShowFeePreview = () => {
        const { useAdvanceAmount, advanceInfo, feeTypeData } = this.state;

        // Check if any amount is entered
        const totalAmount = feeTypeData?.reduce((total, item) => total + Number(item.amount || 0), 0);

        if (totalAmount <= 0) {
            this.toast.show({
                severity: 'error',
                summary: "Error",
                detail: "Please enter at least one fee amount",
                life: 3000
            });
            return;
        }

        // Validate if using advance amount
        if (useAdvanceAmount && advanceInfo) {
            if (totalAmount > advanceInfo.advance) {
                this.toast.show({
                    severity: 'error',
                    summary: "Error",
                    detail: `Total amount exceeds available advance amount by ₹${(Number(totalAmount) - Number(advanceInfo.advance)).toFixed(2)}`,
                    life: 3000
                });
                return;
            } else if (totalAmount <= 0) {
                this.toast.show({
                    severity: 'error',
                    summary: "Error",
                    detail: "Please enter a valid amount to use from advance",
                    life: 3000
                });
                return;
            }
        }

        this.setState({ showFeePreview: true });
    }
    onConfirmFeePreview = () => {
        this.setState({ showFeePreview: false });
        this.onHandlePayOldFee();
    }

    render() {
        console.log(this.state.termBasedData, "this.state.feeTypeInfo")
        const { payFeeFormData, formValidations, username, receiptModificationData } = this.state;
        const header = (
            <div className="table-header ma-tbl-header">
                <div className="ma-tbl-left font-semibold text-900 ">
                    <h5 style={{ fontFamily: "interSemiBold" }}>{username?.slice(3)?.toUpperCase()}</h5>
                </div>
            </div>
        );

        const feeTypeHeader = (
            <div className="table-header ma-tbl-header">
                <div className="flex justify-content-between align-items-start">
                    <div className="ma-tbl-left font-semibold text-900 flex align-items-center">
                        <h5 className="m-0" style={{ fontFamily: "interSemiBold" }}>{username?.slice(3)?.toUpperCase()}</h5>
                    </div>
                    {this.state.advanceInfo && this.state.advanceInfo.advance > 0 && (
                        <div className="flex flex-column align-items-end">
                            <div className="flex align-items-center justify-content-end mb-2">
                                <div className="mr-4">
                                    <p className="font-semibold text-900 m-0" style={{ fontSize: "18px" }}>
                                        Advance Amount: <span className="text-700" style={{ color: "#000" }}>₹ {this.state.advanceInfo.advance}</span>
                                    </p>
                                </div>
                                <div className="flex align-items-center">
                                    <Checkbox
                                        inputId="useAdvance"
                                        checked={this.state.useAdvanceAmount}
                                        onChange={this.handleUseAdvanceChange}
                                        className="mr-2"
                                    />
                                    <label htmlFor="useAdvance" className="font-medium text-900 m-0" style={{ fontSize: "16px" }}>
                                        Use Advance Amount
                                    </label>
                                </div>
                            </div>
                            {this.state.useAdvanceAmount && (
                                <div className="w-full">
                                    <div className="p-2 border-1 border-left-3 border-yellow-500 bg-yellow-50 text-yellow-800" style={{ borderRadius: '4px' }}>
                                        <i className="pi pi-info-circle mr-2"></i>
                                        <span>You can only enter up to a maximum of the available advance amount (₹{this.state.advanceInfo.advance}). The total entered amount cannot exceed the advance balance.</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
        return (
            <div className="ma-main">
                <div className=" datatable-crud-demo ma-m30 mx-2 mb-5">


                    {/* <div style={{ marginLeft: '100px' }} className="flex justify-content-start align-items-center">
                        <span className="">OR</span>
                    </div> */}
                    <div className="flex">
                        <div className="flex flex-column justify-content-center align-items-center mt-3">
                            <RadioButton inputId="ingredient1" onChange={(e) => this.handleSearchLevel(1)} selectedValue={this.state.searchLevel} checked={this.state.searchLevel === 1} setValues={this.setDropdownValues} />
                        </div>

                        <div>
                            <BranchToSectionDD selectedValue={this.state.searchLevel} setValues={this.setDropdownValues} />
                        </div>
                    </div>
                    <div className="col-12  ml-5">
                        <label className="label">
                            Student<span className="ma-required">*</span>
                        </label>
                        <div className="flex">
                            <div className="mt-2">
                                <ClassetDropdown
                                    id="paymentMode"
                                    className=""
                                    height="48px"
                                    width="328px"
                                    options={this.state?.students}
                                    value={this.state.studentId}
                                    disabled={this.state?.searchLevel === 2}
                                    onChange={this.onStudentChange}
                                    placeholder={
                                        <div>
                                            <span className="">Select Student</span>
                                        </div>
                                    }
                                />
                            </div>
                            {this.state.isLoading && <LoadingComponent />}
                        </div>
                    </div>
                    <div className="flex mt-4">
                        <div className="flex flex-column justify-content-center align-items-center mt-3">
                            <RadioButton inputId="ingredient2" onChange={(e) => this.handleSearchLevel(2)} checked={this.state.searchLevel === 2} />
                        </div>
                        <div className="field ml-4">
                            {/* <ClassetStudentSearch selectedValue={this.state.searchLevel} handleTypeValue={this.handleSetSearchTypeValue} handleSearchValue={this.handleSetSearchValue} /> */}

                            <ClassetStudentSearchFilter
                                ref={this.studentSearchRef}
                                selectedValue={this.state.searchLevel}
                                setValues={this.setDropdownValues}
                                singleSelectInput={true}
                            />

                        </div>
                    </div>
                </div>

                <div className="flex justify-content-between">
                    <div className="col-12 sm:col-8  m-2 mr-0">
                        {/* <SelectButton
                            className="button-group"
                            value={options}
                            options={options}
                            onChange={(e) => {
                                const newTab = e.value == null ? this.state.tab : e.value;
                                this.setState({ tab: newTab }, () => {
                                    // Update URL with new tab
                                    const additionalParams = {
                                        searchLevel: this.state.searchLevel,
                                        tab: newTab
                                    };
                                    
                                    // Add orgId to URL
                                    if (this.state.orgId) {
                                        additionalParams.orgId = this.state.orgId;
                                    }
                                    
                                    // Add search context if available
                                    if (this.state.searchLevel === 2 && this.state.searchValue) {
                                        additionalParams.searchValue = this.state.searchValue;
                                    }
                                    
                                    this.updateURLQueryParams(this.state.studentId, additionalParams);
                                    
                                    if (newTab === 1) {
                                        this.getTermBasedData();
                                    } else if (newTab === 2) {
                                        this.fetchReceipts(); // Call student-fee-info API
                                    }
                                });
                            }}
                        /> */}
                        {/* <SelectButton
    className="button-group"
    value={this.state.tab} // should be tab value, not options
    options={options}
    onChange={(e) => {
        const newTab = e.value == null ? this.state.tab : e.value;
        // Prevent switching to tab 1 if studentId is empty
        if (newTab === 1 && !this.state.studentId) {
            this.toast.show({
                severity: 'warn',
                summary: 'Select Student',
                detail: 'Please select a student before viewing Term Based.',
                life: 3000
            });
            return;
        }
        this.setState({ tab: newTab }, () => {
            // Update URL with new tab
            const additionalParams = {
                searchLevel: this.state.searchLevel,
                tab: newTab
            };
            
            // Add orgId to URL
            if (this.state.orgId) {
                additionalParams.orgId = this.state.orgId;
            }
            
            // Add search context if available
            if (this.state.searchLevel === 2 && this.state.searchValue) {
                additionalParams.searchValue = this.state.searchValue;
            }
            
            this.updateURLQueryParams(this.state.studentId, additionalParams);
            
            if (newTab === 1) {
                this.getTermBasedData();
            } else if (newTab === 2) {
                this.fetchReceipts();
            }
        });
    }}
/> */}
                        {/* <SelectButton
    className="button-group"
    value={this.state.tab}
    options={options}
    onChange={(e) => {
        const newTab = e.value == null ? this.state.tab : e.value;
        // Prevent switching to tab 1 if studentId is empty
        if (newTab === 1 && !this.state.studentId) {
            this.toast.show({
                severity: 'warn',
                summary: 'Select Student',
                detail: 'Please select a student before viewing Term Based.',
                life: 3000
            });
            return;
        }
        // Prevent switching to tab 2 if studentId is empty or termBasedData is not fetched
        if (
            newTab === 2 &&
            (!this.state.studentId || !Array.isArray(this.state.termBasedData) || this.state.termBasedData.length === 0)
        ) {
            this.toast.show({
                severity: 'warn',
                summary: 'Select Student',
                detail: 'Please select a student and fetch Term Based data before viewing Student Profile.',
                life: 3000
            });
            return;
        }
        this.setState({ tab: newTab }, () => {
            if (newTab === 1) {
                this.getTermBasedData();
            } else if (newTab === 2) {
                this.fetchReceipts();
            }
        });
    }}
/> */}
                        <SelectButton
                            className="collect-fee-tabs"
                            value={this.state.tab}
                            options={options}
                            onChange={(e) => {
                                const newTab = e.value == null ? this.state.tab : e.value;
                                // Prevent switching to tab 1 if studentId is empty
                                if (newTab === 1 && !this.state.studentId) {
                                    this.toast.show({
                                        severity: 'warn',
                                        summary: 'Select Student',
                                        detail: 'Please select a student before viewing Term Based.',
                                        life: 3000
                                    });
                                    return;
                                }
                                // Prevent switching to tab 2 unless tab 1 data is fetched (termBasedData is non-empty)
                                if (
                                    newTab === 2 &&
                                    (!this.state.studentId ||
                                        !Array.isArray(this.state.termBasedData) ||
                                        this.state.termBasedData.length === 0)
                                ) {
                                    this.toast.show({
                                        severity: 'warn',
                                        summary: 'Term Based Not Loaded',
                                        detail: 'Please select a student and fetch Term Based data before viewing Student Profile.',
                                        life: 3000
                                    });
                                    return;
                                }
                                // <<<<<<< HEAD
                                this.setState({ tab: newTab, useAdvanceAmount: false }, () => {
                                    // Update URL with new tab
                                    const additionalParams = {
                                        searchLevel: this.state.searchLevel,
                                        tab: newTab
                                    };

                                    // Add search context
                                    if (this.state.searchLevel === 2 && this.state.searchValue) {
                                        additionalParams.searchValue = this.state.searchValue;
                                    }

                                    this.updateURLQueryParams(this.state.studentId, additionalParams);


                                    // this.setState({ tab: newTab, useAdvanceAmount: false }, () => {
                                    if (newTab === 1) {
                                        this.getTermBasedData();
                                    } else if (newTab === 2) {
                                        this.fetchReceipts();
                                    }
                                    else if (newTab === 3) {
                                        this.onHandleCollectFee();
                                    }
                                });
                            }}
                        />
                    </div>
                    {this.state.tab == 1 && (
                        <div className="col-12  sm:col-3  flex justify-content-end align-items-center custom-fee">
                            {/* <Button disabled={!this.state.partialPayment} onClick={this.onHandleCollectFee}>
                                <p className="custom-fee-add">Old Fee Payment</p>
                            </Button> */}
                            {/* 
                            <img style={{ width: 40, height: 40, marginRight: 40 }} src="./Refresh_button_1.svg" onClick={this.calculateFine} className="refresh-i ma-pointer" /> */}

                            {/* <Button disabled={!this.state.partialPayment} onClick={this.onHandleCustomFee}>
                                <p className="custom-fee-add">Fee Payment aa</p>
                            </Button> */}

                            {/* COMMENT IT WHEN DEPLOYING TO THE PROD  QAtest*/}
                            {localStorage.getItem('mobileNoAsUsername') !== 'avanttpayment' && (
                                <Button className='text-center' disabled={!this.state.partialPayment} onClick={this.onHandleCustomFee} label='Fee Payment' style={{ fontFamily: 'InterSemiBold', fontWeight: 600, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.15px' }}>
                                   
                                </Button>
                            )}


                            {/* Original button hidden - only show for avanttpayment user */}
                            {localStorage.getItem('mobileNoAsUsername') === 'avanttpayment' && (
                                <Button className='text-center' disabled={!this.state.partialPayment} onClick={this.onHandleCustomFee} label='Fee Payment' style={{ fontFamily: 'InterSemiBold', fontWeight: 600, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.15px' }}>
                                    {/*    <p className="custom-fee-add"></p> */}
                                </Button>
                            )}

                            {/* {localStorage.getItem('mobileNoAsUsername') === 'avanttpayment' ? (
    <Button disabled={this.state.partialPayment} onClick={this.onHandleCustomFee}>
        <p className="custom-fee-add">Fee Payment</p>
    </Button>
) : (
    <Button disabled={this.state.partialPayment} onClick={this.onHandleCustomFee}>
        <p className="custom-fee-add">Fee Payment</p>
    </Button>
)} */}
                        </div>
                    )}
                </div>

                <div className="card datatable-crud-demo ma-m30  m-2">
                    {/* <div className="col-12 flex justify-content-between align-items-center custom-fee">
                        <div className="flex border-2">
                            <div className="cursor-pointer p-6">TermBased</div>
                            <div className="cursor-pointer p-6">Student Profile</div>
                        </div>
                        <div>
                            <img style={{ width: 40, height: 40, marginRight: 40 }} src="./Refresh_button_1.svg" onClick={this.calculateFine} className="refresh-i ma-pointer" />
                            <Button disabled={!this.state.partialPayment} onClick={this.onHandleCustomFee}>
                                <p className="custom-fee-add">Custom Fee Payment</p>
                            </Button>
                        </div>
                    </div> */}
                    {this.state.tab == 1 && (
                        <>
                            <DataTable
                                ref={(el) => (this.dt = el)}
                                value={this.state.termBasedData}
                                dataKey="id"
                                paginator
                                lazy
                                responsiveLayout="scroll"
                                className="dataTableValuesText"
                                showGridlines
                                selectionMode={'checkbox'}
                                columnResizeMode="expand"
                                resizableColumns
                                onPage={this.onPage}
                                first={this.state.lazyParams.first}
                                last={this.state.totalRecords}
                                rows={this.state.lazyParams.rows}
                                totalRecords={this.state.totalRecords}
                                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                globalFilter={this.state.globalFilter}
                                header={header}
                            >
                                <Column
                                    alignHeader={'center'}

                                    bodyClassName="text-center"
                                    header="Installment"
                                    body={(rowData, { rowIndex }) => {
                                        return <div className="flex justify-content-center">{` ${rowData.feeinstallmentTitle}`}</div>;
                                    }}
                                ></Column>
                                <Column
                                    alignHeader={'center'}
                                    bodyClassName="text-center"
                                    header="Total Fee"
                                    body={(rowData, { rowIndex }) => {
                                        return <div className="flex justify-content-center">{rowData?.totalAmount + rowData?.actualGst}</div>
                                    }}
                                ></Column>
                                <Column filterField="concession" field="concession" bodyClassName="text-center" header="Concession" alignHeader={'center'} />
                                <Column filterField="fineAmt" field="fineAmt" bodyClassName="text-center" header="Fine Amount" alignHeader={'center'} />
                                <Column filterField="amountPaid" field="amountPaid" bodyClassName="text-center" header="Paid Fee" alignHeader={'center'}
                                />
                                <Column filterField="totalDue" field="dueAmount" bodyClassName="text-center" header="Total Due" alignHeader={'center'} body={(rowData, { rowIndex }) => {
                                    return <div className="flex justify-content-center"> {(Number(rowData?.dueAmount) || 0).toFixed(2)}</div>;
                                }} />
                                <Column
                                    alignHeader={'center'}
                                    bodyClassName="text-center"
                                    header="Due Date"
                                    body={(rowData, { rowIndex }) => {
                                        return <div className="flex justify-content-center">{moment(rowData.dueDate).format('YYYY-MM-DD')}</div>;
                                    }}
                                ></Column>
                                <Column
                                    alignHeader={'center'}
                                    bodyClassName="text-center"
                                    header="Actions"
                                    body={(rowData, { rowIndex }) => {
                                        return (
                                            <div className="flex justify-content-center">
                                                <>
                                                    <div className='mx-2'
                                                        onClick={() => {
                                                            this.downloadBulkReciepts(rowData?.installmentId);
                                                        }}
                                                    >
                                                        <DownloadIcon width={20} height={20} color={'#076EFF'} />
                                                    </div>
                                                    <div
                                                        onClick={() => {
                                                            this.isshowInstallmentInfo(rowData);
                                                        }}
                                                    >
                                                        <InfoIcon2 width={20} height={20} color={'#076EFF'} />
                                                    </div>
                                                </>
                                            </div>
                                        );
                                    }}

                                ></Column>
                            </DataTable>

                            <div className="flex justify-content-end mt-4 p-4 border-round-lg bg-gray-50">
                                <div className="flex gap-6">
                                    <div className="flex align-items-center gap-2">
                                        <span className="font-bold text-xl" style={{ color: "#076EFF" }}>Total Fee:</span>
                                        <span className="text-xl">₹{this.state.termBasedData?.reduce((sum, row) => sum + (Number(row.totalAmount) + Number(row.actualGst || 0)), 0).toFixed(2)}</span>
                                    </div>
                                    <div className="flex align-items-center gap-2">
                                        <span className="font-bold text-xl" style={{ color: "#076EFF" }}>Concession:</span>
                                        <span className="text-xl">₹{this.state.termBasedData?.reduce((sum, row) => sum + (Number(row.concession) || 0), 0).toFixed(2)}</span>
                                    </div>
                                    <div className="flex align-items-center gap-2">
                                        <span className="font-bold text-xl" style={{ color: "#076EFF" }}>Total Paid:</span>
                                        <span className="text-xl">
                                            ₹{(
                                                this.state.termBasedData?.reduce((sum, row) => sum + (Number(row.amountPaid) || 0), 0) +
                                                (
                                                    this.state.advanceInfo?.advanceHistory?.some(item => item.fromCollectFee)
                                                        ? (Number(this.state.advanceInfo?.advance) || 0)
                                                        : 0
                                                )
                                            ).toFixed(2)}
                                        </span>
                                    </div>
                                    <div className="flex align-items-center gap-2">
                                        <span className="font-bold text-xl " style={{ color: "#076EFF" }}>Total Due:</span>
                                        <span className="text-xl">₹{this.state.termBasedData?.reduce((sum, row) => sum + (Number(row.dueAmount) || 0), 0).toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    {this.state.tab == 1 && this.state.closedFees?.length > 0 && (
                        <div className="mt-4">
                            <div className="flex align-items-center gap-2 mb-3 p-3" style={{ background: '#f5f5f5', borderLeft: '4px solid #616161', borderRadius: '4px' }}>
                                <i className="pi pi-lock" style={{ fontSize: '1.2rem' }}></i>
                                <span className="font-bold text-xl">Closed Fee History</span>
                            </div>
                            <DataTable
                                value={this.state.closedFees}
                                responsiveLayout="scroll"
                                className="dataTableValuesText"
                                showGridlines
                                stripedRows
                                emptyMessage="No closed fees found"
                                expandedRows={this.state.expandedClosedFeeRows}
                                onRowToggle={(e) => this.setState({ expandedClosedFeeRows: e.data })}
                                rowExpansionTemplate={this.closedFeeRowExpansionTemplate}
                                dataKey="feeTypeId"
                            >
                                <Column expander style={{ width: '3rem' }} />
                                <Column alignHeader="center" bodyClassName="text-center" header="Fee Type" field="feeType" />
                                <Column alignHeader="center" bodyClassName="text-center" header="Total Fee"
                                    body={(rowData) => `₹${(Number(rowData.totalFee) || 0).toFixed(2)}`}
                                />
                                <Column alignHeader="center" bodyClassName="text-center" header="Amount Paid"
                                    body={(rowData) => `₹${(Number(rowData.amountPaid) || 0).toFixed(2)}`}
                                />
                                <Column alignHeader="center" bodyClassName="text-center" header="Closing Amount"
                                    body={(rowData) => `₹${(Number(rowData.closingAmount) || 0).toFixed(2)}`}
                                />
                                <Column alignHeader="center" bodyClassName="text-center" header="Closing Paid"
                                    body={(rowData) => `₹${(Number(rowData.closingAmountPaid) || 0).toFixed(2)}`}
                                />
                                <Column alignHeader="center" bodyClassName="text-center" header="Due at Closing"
                                    body={(rowData) => `₹${(Number(rowData.closingDueAmt) || 0).toFixed(2)}`}
                                />
                                <Column alignHeader="center" bodyClassName="text-center" header="Closed On"
                                    body={(rowData) => rowData.closedDate ? moment(rowData.closedDate).format('DD-MM-YYYY') : '-'}
                                />
                            </DataTable>
                        </div>
                    )}
                    {this.state.tab == 2 && (
                        <div className='grid '>
                            <div className="col-8 flex justify-content-between flex=wrap align-items-start p-5">
                                <div style={{ fontWeight: 'bolder', fontSize: '17px', flex: 0.3, color: 'black' }}>
                                    <div>
                                        <p style={{ fontWeight: 'bolder', fontSize: '25px', marginBottom: '20px' }}>Student Information</p>
                                        <div className="mt-1" style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                            <div className="studentProfileAlignment">
                                                <p>Student Name</p>
                                                <p>:</p>
                                                <p>{this.state.user_info?.firstName} {this.state.user_info?.lastName}</p>
                                            </div>
                                            <div className="studentProfileAlignment">
                                                <p>Enrollment Id</p>
                                                <p>:</p>
                                                <p>{this.state.user_info?.enrollmentId}</p>
                                            </div>
                                            <div className="studentProfileAlignment">
                                                <p>Admission Category</p>
                                                <p>:</p>
                                                <p>{this.state.user_info?.categoryName}</p>
                                            </div>
                                            <div className="studentProfileAlignment">
                                                <p>Branch Name</p>
                                                <p>:</p>
                                                <p>{this.state.user_info?.branchName}</p>
                                            </div>
                                            <div className="studentProfileAlignment">
                                                <p>Board Name</p>
                                                <p>:</p>
                                                <p>{this.state.user_info?.["custom:board"]}</p>
                                            </div>
                                            <div className="studentProfileAlignment">
                                                <p>Class Name</p>
                                                <p>:</p>
                                                <p>{this.state.user_info?.["custom:grade"]}</p>
                                            </div>
                                            <div className="studentProfileAlignment">
                                                <p>Section Name</p>
                                                <p>:</p>
                                                <p>{this.state.user_info?.sectionName}</p>
                                            </div>
                                            <div className="studentProfileAlignment">
                                                <p>Father's Name</p>
                                                <p>:</p>
                                                <p>{this.state.user_info?.contactPersonName}</p>
                                            </div>
                                            <div className="studentProfileAlignment">
                                                <p>Contact No</p>
                                                <p>:</p>
                                                <p>{this.state.user_info?.parentContactNo}</p>
                                            </div>
                                            <div className="studentProfileAlignment">
                                                <p>Email Id</p>
                                                <p>:</p>
                                                <p>{this.state.user_info?.email}</p>
                                            </div>

                                            {/*    <div className="studentProfileAlignment">
                                                <p>Address</p>
                                                <p>:</p>
                                                <p>----</p>
                                            </div> */}
                                        </div>
                                    </div>
                                    <div>
                                        <div style={{ width: '75vw' }} className="mt-4">
                                            <h2>Additional Information</h2>
                                            <Accordion multiple activeIndex={[0]} className="fee-info-accordion">
                                                <AccordionTab
                                                    header={
                                                        <div className="flex align-items-center gap-2 p-2">
                                                            <i className="pi pi-book text-xl"></i>
                                                            <span className="font-bold text-xl">Fee Type Information</span>
                                                        </div>
                                                    }
                                                    className="fee-type-tab"
                                                >
                                                    <div className="p-4 border-round-lg bg-white">
                                                        <DataTable
                                                            value={this.state.feeTypeInfo}
                                                            paginator
                                                            rows={5}
                                                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                                            className="p-datatable-xl fee-type-table"
                                                            emptyMessage="No fee type information found"
                                                            responsiveLayout="scroll"
                                                            showGridlines
                                                            stripedRows
                                                        >
                                                            <Column
                                                                field="feeType"
                                                                header="Fee Type"
                                                                sortable
                                                                headerClassName="text-xl p-3"
                                                                bodyClassName="text-lg p-3 text-center"
                                                                alignHeader="center"
                                                            />
                                                            <Column
                                                                field="totalFee"
                                                                header="Total Fee"
                                                                sortable
                                                                headerClassName="text-xl p-3"
                                                                bodyClassName="text-lg p-3 text-center"
                                                                alignHeader="center"
                                                            />
                                                            <Column
                                                                header="Amount Paid"
                                                                body={(rowData) => `${rowData?.amountPaid || 0}`}
                                                                sortable
                                                                headerClassName="text-xl p-3"
                                                                bodyClassName="text-lg p-3 text-center"
                                                                alignHeader="center"
                                                            />
                                                            <Column
                                                                field="totalConcession"
                                                                header="Concession"
                                                                sortable
                                                                headerClassName="text-xl p-3"
                                                                bodyClassName="text-lg p-3 text-center"
                                                                alignHeader="center"
                                                            />
                                                            <Column
                                                                header="Fee Due"
                                                                body={(rowData) => {
                                                                    console.log(rowData, "rowData")
                                                                    const totalAmount = rowData?.totalFee || 0;
                                                                    const amountPaid = rowData?.amountPaid || 0;
                                                                    const concession = rowData?.totalConcession || 0;

                                                                    const feeDue = totalAmount - (amountPaid) - concession;

                                                                    return (Number(feeDue) || 0).toFixed(2);
                                                                }}
                                                                sortable
                                                                headerClassName="text-xl p-3"
                                                                bodyClassName="text-lg p-3 text-center"
                                                                alignHeader="center"
                                                            />
                                                        </DataTable>

                                                        <div className="flex justify-content-end mt-4 p-4 border-round-lg bg-gray-50">
                                                            <div className="flex gap-6">
                                                                <div className="flex align-items-center gap-2">
                                                                    <span className="font-bold text-xl" style={{ color: "#076EFF" }}>Total Fee:</span>
                                                                    <span className="text-xl">₹{this.state.feeTypeInfo?.reduce((sum, row) => sum + (Number(row.totalFee) || 0), 0).toFixed(2)}</span>
                                                                </div>
                                                                <div className="flex align-items-center gap-2">
                                                                    <span className="font-bold text-xl" style={{ color: "#076EFF" }}>Concession:</span>
                                                                    <span className="text-xl">₹{this.state.termBasedData?.reduce((sum, row) => sum + (Number(row.concession) || 0), 0).toFixed(2)}</span>
                                                                </div>
                                                                <div className="flex align-items-center gap-2">
                                                                    <span className="font-bold text-xl" style={{ color: "#076EFF" }}>Total Paid:</span>
                                                                    <span className="text-xl">
                                                                        ₹{(
                                                                            this.state.feeTypeInfo?.reduce((sum, row) => sum + (Number(row.amountPaid) || 0), 0) +
                                                                            (
                                                                                this.state.advanceInfo?.advanceHistory?.some(item => item.fromCollectFee)
                                                                                    ? (Number(this.state.advanceInfo?.advance) || 0)
                                                                                    : 0
                                                                            )
                                                                        ).toFixed(2)}
                                                                    </span>
                                                                </div>
                                                                <div className="flex align-items-center gap-2">
                                                                    <span className="font-bold text-xl" style={{ color: "#076EFF" }}>Total Due:</span>
                                                                    <span className="text-xl">₹{this.state.termBasedData?.reduce((sum, row) => sum + (Number(row.dueAmount)), 0).toFixed(2)}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </AccordionTab>

                                                {this.state.closedFees?.length > 0 && (
                                                    <AccordionTab
                                                        header={
                                                            <div className="flex align-items-center gap-2 p-2">
                                                                <i className="pi pi-lock text-xl"></i>
                                                                <span className="font-bold text-xl">Closed Fee History</span>
                                                            </div>
                                                        }
                                                        className="fee-type-tab"
                                                    >
                                                        <div className="p-4 border-round-lg bg-white">
                                                            <DataTable
                                                                value={this.state.closedFees}
                                                                responsiveLayout="scroll"
                                                                className="p-datatable-xl fee-type-table"
                                                                showGridlines
                                                                stripedRows
                                                                emptyMessage="No closed fees found"
                                                                expandedRows={this.state.expandedClosedFeeRows}
                                                                onRowToggle={(e) => this.setState({ expandedClosedFeeRows: e.data })}
                                                                rowExpansionTemplate={this.closedFeeRowExpansionTemplate}
                                                                dataKey="feeTypeId"
                                                            >
                                                                <Column expander style={{ width: '3rem' }} />
                                                                <Column field="feeType" header="Fee Type" alignHeader="center" bodyClassName="text-lg p-3 text-center" headerClassName="text-xl p-3" />
                                                                <Column header="Total Fee" alignHeader="center" bodyClassName="text-lg p-3 text-center" headerClassName="text-xl p-3"
                                                                    body={(rowData) => `₹${(Number(rowData.totalFee) || 0).toFixed(2)}`}
                                                                />
                                                                <Column header="Amount Paid" alignHeader="center" bodyClassName="text-lg p-3 text-center" headerClassName="text-xl p-3"
                                                                    body={(rowData) => `₹${(Number(rowData.amountPaid) || 0).toFixed(2)}`}
                                                                />
                                                                <Column header="Closing Amount" alignHeader="center" bodyClassName="text-lg p-3 text-center" headerClassName="text-xl p-3"
                                                                    body={(rowData) => `₹${(Number(rowData.closingAmount) || 0).toFixed(2)}`}
                                                                />
                                                                <Column header="Closing Paid" alignHeader="center" bodyClassName="text-lg p-3 text-center" headerClassName="text-xl p-3"
                                                                    body={(rowData) => `₹${(Number(rowData.closingAmountPaid) || 0).toFixed(2)}`}
                                                                />
                                                                <Column header="Due at Closing" alignHeader="center" bodyClassName="text-lg p-3 text-center" headerClassName="text-xl p-3"
                                                                    body={(rowData) => `₹${(Number(rowData.closingDueAmt) || 0).toFixed(2)}`}
                                                                />
                                                                <Column header="Closed On" alignHeader="center" bodyClassName="text-lg p-3 text-center" headerClassName="text-xl p-3"
                                                                    body={(rowData) => rowData.closedDate ? moment(rowData.closedDate).format('DD-MM-YYYY') : '-'}
                                                                />
                                                            </DataTable>
                                                        </div>
                                                    </AccordionTab>
                                                )}

                                                <AccordionTab
                                                    header={
                                                        <div className="flex align-items-center gap-2 p-2">
                                                            <i className="pi pi-file-pdf text-xl"></i>
                                                            <span className="font-bold text-xl">Fee Receipts</span>
                                                        </div>
                                                    }
                                                    className="fee-receipts-tab"
                                                >
                                                    <div className="p-3">
                                                        <DataTable
                                                            value={this.state.receipts}
                                                            paginator
                                                            rows={5}
                                                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                                            className="p-datatable-sm fee-type-table"
                                                            emptyMessage="No fee type information found"
                                                            responsiveLayout="scroll"
                                                            showGridlines
                                                            stripedRows
                                                        >
                                                            <Column
                                                                field="receiptNo"
                                                                header="Receipt No"
                                                                sortable
                                                                headerClassName="text-xl p-3"
                                                                bodyClassName="text-lg p-3"
                                                            />
                                                            <Column
                                                                field="receiptDate"
                                                                header="Date"
                                                                sortable
                                                                body={(rowData) => moment(rowData.receiptDate).format('DD-MM-YYYY')}
                                                                headerClassName="text-xl p-3"
                                                                bodyClassName="text-lg p-3"
                                                            />
                                                            <Column
                                                                field="paymentMode"
                                                                header="Payment Mode"
                                                                sortable
                                                                headerClassName="text-xl p-3"
                                                                bodyClassName="text-lg p-3"
                                                            />
                                                            <Column
                                                                field="amountPaid"
                                                                header="Amount"
                                                                sortable
                                                                headerClassName="text-xl p-3"
                                                                bodyClassName="text-lg p-3"
                                                                body={(rowData) => `₹${rowData.amountPaid}`}
                                                            />
                                                            <Column
                                                                header="Actions"
                                                                headerClassName="text-xl p-3"
                                                                bodyClassName="text-lg p-3"
                                                                body={(rowData, rowIndex) => (
                                                                    <>
                                                                        <div className='display-flex gap-2'>


                                                                            <Button
                                                                                icon="pi pi-download"
                                                                                className="p-button-text "
                                                                                onClick={() => {
                                                                                    this.setState({
                                                                                        isEnableReceipt: true,
                                                                                        receiptData: rowData
                                                                                    });
                                                                                }}
                                                                                tooltip="Download Receipt"
                                                                            />
                                                                            {rowData?.paymentMode !== "Adjustment" && (
                                                                                <Button
                                                                                    data-pr-tooltip="Edit"
                                                                                    className="p-button-text"
                                                                                    onClick={() => {
                                                                                        if (!rowData?.isModificationRequestRaised) {
                                                                                            this.onReceiptEdit(rowData);
                                                                                        } else {
                                                                                            this.toast.show({
                                                                                                severity: 'info',
                                                                                                summary: 'Info',
                                                                                                detail: 'Modification request is raised for this receipt, you cannot edit it now.',
                                                                                                life: 3000
                                                                                            });
                                                                                        }
                                                                                    }}

                                                                                >
                                                                                    <ClassetEditIcon width={22} height={22} color={'#2196F3'} />
                                                                                </Button>
                                                                            )}

                                                                        </div>
                                                                    </>
                                                                )}
                                                            />
                                                        </DataTable>
                                                    </div>
                                                </AccordionTab>
                                                <AccordionTab
                                                    header={
                                                        <div className="flex align-items-center gap-2 p-2">
                                                            <i className="pi pi-money-bill text-xl"></i>
                                                            <span className="font-bold text-xl">Refund Receipts</span>
                                                        </div>
                                                    }
                                                    className="fee-receipts-tab"
                                                >
                                                    <div className="p-3">
                                                        <DataTable
                                                            value={this.state.refundReceipts}
                                                            paginator
                                                            rows={5}
                                                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                                            className="p-datatable-sm fee-type-table"
                                                            emptyMessage="No refund receipts found"
                                                            responsiveLayout="scroll"
                                                            showGridlines
                                                            stripedRows
                                                        >
                                                            <Column
                                                                field="receiptNo"
                                                                header="Receipt No"
                                                                sortable
                                                                headerClassName="text-xl p-3"
                                                                bodyClassName="text-lg p-3"
                                                            />
                                                            <Column
                                                                field="receiptDate"
                                                                header="Date"
                                                                sortable
                                                                body={(rowData) => moment(rowData.receiptDate).format('DD-MM-YYYY')}
                                                                headerClassName="text-xl p-3"
                                                                bodyClassName="text-lg p-3"
                                                            />
                                                            <Column
                                                                field="paymentMode"
                                                                header="Payment Mode"
                                                                sortable
                                                                headerClassName="text-xl p-3"
                                                                bodyClassName="text-lg p-3"
                                                            />
                                                            <Column
                                                                header="Amount"
                                                                sortable
                                                                headerClassName="text-xl p-3"
                                                                bodyClassName="text-lg p-3"
                                                                body={(rowData) => {
                                                                    const refundAmount = rowData?.feePaidDetails?.reduce(
                                                                        (sum, row) => sum + (Number(row.refundAmt) || 0),
                                                                        0
                                                                    );
                                                                    return <p className="text-xl">{(Number(refundAmount) || 0).toFixed(2)}</p>;
                                                                }}
                                                            />
                                                            <Column
                                                                header="Actions"
                                                                headerClassName="text-xl p-3"
                                                                bodyClassName="text-lg p-3"
                                                                body={(rowData) => (
                                                                    <Button
                                                                        icon="pi pi-download"
                                                                        className="p-button-text"
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                isEnableRefundReceipt: true,
                                                                                receiptData: rowData
                                                                            });
                                                                        }}
                                                                        tooltip="Download Receipt"
                                                                    />
                                                                )}
                                                            />
                                                        </DataTable>
                                                    </div>
                                                </AccordionTab>
                                            </Accordion>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-1'></div>
                            <div className="col-1 mt-5 ml-5 ">
                                {this.state?.user_info?.studentPhoto ? <img
                                    src={`${this.state?.user_info?.studentPhoto?.storageLocation}`}
                                    style={{ width: '201px', height: '207px' }}
                                /> : <FinanceStudentProfile width={201} />}
                            </div>
                        </div>
                    )}

                    {this.state.tab == 3 && (
                        <div>
                            <DataTable ref={(el) => this.dt = el}
                                value={this.state?.feeTypeData}
                                dataKey="id"
                                paginator
                                rows={10}
                                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                globalFilter={this.state.globalFilter}
                                header={feeTypeHeader}
                            >

                                <Column filterField="feeType" field="feeType" sortable bodyClassName='text-center' header="Fee Type" alignHeader={"center"} />
                                <Column filterField="feeTermName" sortable bodyClassName='text-center' header="Fee Term Name" alignHeader={"center"} body={(rowData, index) => {
                                    return (
                                        <p>{`${rowData?.paymentTerm}`}</p>
                                    )
                                }} />
                                <Column filterField="termWiseActualValue" field="termWiseActualValue" sortable bodyClassName='text-center' header="Term wise Actual Fee" alignHeader={"center"}
                                    body={(rowData, { rowIndex }) => {
                                        return <div className="flex justify-content-center">{` ${Math.round((rowData?.termWiseActualValue) * 100) / 100}`}</div>;
                                    }} />
                                <Column filterField="concession" field="concession" sortable bodyClassName='text-center' header="Concession" alignHeader={"center"} />
                                <Column filterField="amountPaid" field="amountPaid" sortable bodyClassName='text-center' header="Paid Fee" alignHeader={"center"} />
                                <Column filterField="totalDue" field="" sortable bodyClassName='text-center' header="Total Due" alignHeader={"center"} body={(rowData, index) => {
                                    let dueAmount = (Number(rowData?.dueAmount || 0))
                                    let conAmt = Number(rowData?.currentConAmt) || 0
                                    let finalDue = (Number(dueAmount - conAmt) || 0).toFixed(2)
                                    return (
                                        <p>{finalDue}</p>
                                    )
                                }} />
                                <Column bodyClassName='text-center' header="Amount Paying" body={(rowData, index) => {

                                    if (rowData?.isAdHocCharge) {
                                        return (
                                            <ClassetInputText
                                                className="text-xl hide-number-spinners"
                                                type="text"
                                                height="48px"
                                                width="216px"
                                                value={rowData?.amount || ''}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (value === '' || value.match(/^\d*\.?\d{0,2}$/)) {
                                                        this.handleTermWisePercentageValue(e, rowData);
                                                    }
                                                }}
                                                onWheel={(e) => e.target.blur()}
                                                disabled={rowData?.dueAmount <= 0}
                                            />
                                        );
                                    }

                                    return (
                                        <>
                                            <ClassetInputText
                                                className="text-xl hide-number-spinners"
                                                type="text"
                                                height="48px"
                                                width="216px"
                                                placeholder={!(rowData?.amount) ? 'Enter Value' : ''}
                                                value={rowData?.dueAmount > 0 ? rowData?.amount || '' : rowData?.amount || 0}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (value === '' || value.match(/^\d*\.?\d{0,2}$/)) {
                                                        this.handleTermWisePercentageValue(e, rowData);
                                                    }
                                                }}
                                                onWheel={(e) => e.target.blur()}
                                                disabled={rowData?.dueAmount > 0 ? false : true}
                                            />
                                        </>
                                    )
                                }} />

                            </DataTable>

                            <div className="flex justify-content-end align-items-center mr-4 mt-3">
                                <div className="flex align-items-center gap-2">
                                    <span className="font-bold text-lg">Total Amount:</span>
                                    <span className={this.state.useAdvanceAmount && this.state.advanceInfo &&
                                        this.state.feeTypeData?.reduce((total, item) => total + Number(item.amount || 0), 0) > this.state.advanceInfo.advance
                                        ? 'text-lg text-red-500 font-semibold' : 'text-lg'}>
                                        ₹{this.state.feeTypeData?.reduce((total, item) => total + Number(item.amount || 0), 0).toFixed(2)}
                                    </span>
                                    {this.state.useAdvanceAmount && this.state.advanceInfo && (
                                        <div className={this.state.feeTypeData?.reduce((total, item) => total + Number(item.amount || 0), 0) > this.state.advanceInfo.advance
                                            ? 'ml-3 p-2 border-1 border-left-3 border-red-500 bg-red-50'
                                            : 'ml-3 p-2 border-1 border-left-3 border-green-500 bg-green-50'}
                                            style={{ borderRadius: '4px' }}>
                                            <i className={this.state.feeTypeData?.reduce((total, item) => total + Number(item.amount || 0), 0) > this.state.advanceInfo.advance
                                                ? 'pi pi-exclamation-triangle mr-2 text-red-500'
                                                : 'pi pi-check-circle mr-2 text-green-500'}>
                                            </i>
                                            <span className={this.state.feeTypeData?.reduce((total, item) => total + Number(item.amount || 0), 0) > this.state.advanceInfo.advance
                                                ? 'text-red-700' : 'text-green-700'}>
                                                {this.state.feeTypeData?.reduce((total, item) => total + Number(item.amount || 0), 0) > this.state.advanceInfo.advance
                                                    ? `Exceeds advance amount by ₹${(Number(this.state.feeTypeData?.reduce((total, item) => total + Number(item.amount || 0), 0)) - Number(this.state.advanceInfo.advance)).toFixed(2)}`
                                                    : `Available advance: ₹${(Number(this.state.advanceInfo.advance) - Number(this.state.feeTypeData?.reduce((total, item) => total + Number(item.amount || 0), 0))).toFixed(2)}`
                                                }
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className='flex justify-content-center  align-items-center mt-4'>
                                <Button
                                    label='Next'
                                    className='submitButtonn mr-4 button text-lg '
                                    onClick={this.onShowFeePreview}
                                    disabled={this.state.termBasedData.length === 0 || !this.state.username}
                                />
                                {/*    <Button className='cancelButtonn '
                                    onClick={this.onHandleFeePayClose} >
                                    <p className='cancelButtonnText'>Cancel</p>
                                </Button> */}
                            </div>

                            {this.state.closedFees?.length > 0 && (
                                <div className="mt-5">
                                    <div className="flex align-items-center gap-2 mb-3 p-3" style={{ background: '#f5f5f5', borderLeft: '4px solid #616161', borderRadius: '4px' }}>
                                        <i className="pi pi-lock" style={{ fontSize: '1.2rem' }}></i>
                                        <span className="font-bold text-xl">Closed Fee History</span>
                                    </div>
                                    <DataTable
                                        value={this.state.closedFees}
                                        responsiveLayout="scroll"
                                        className="dataTableValuesText"
                                        showGridlines
                                        stripedRows
                                        emptyMessage="No closed fees found"
                                        expandedRows={this.state.expandedClosedFeeRows}
                                        onRowToggle={(e) => this.setState({ expandedClosedFeeRows: e.data })}
                                        rowExpansionTemplate={this.closedFeeRowExpansionTemplate}
                                        dataKey="feeTypeId"
                                    >
                                        <Column expander style={{ width: '3rem' }} />
                                        <Column alignHeader="center" bodyClassName="text-center" header="Fee Type" field="feeType" />
                                        <Column alignHeader="center" bodyClassName="text-center" header="Total Fee"
                                            body={(rowData) => `₹${(Number(rowData.totalFee) || 0).toFixed(2)}`}
                                        />
                                        <Column alignHeader="center" bodyClassName="text-center" header="Amount Paid"
                                            body={(rowData) => `₹${(Number(rowData.amountPaid) || 0).toFixed(2)}`}
                                        />
                                        <Column alignHeader="center" bodyClassName="text-center" header="Closing Amount"
                                            body={(rowData) => `₹${(Number(rowData.closingAmount) || 0).toFixed(2)}`}
                                        />
                                        <Column alignHeader="center" bodyClassName="text-center" header="Closing Paid"
                                            body={(rowData) => `₹${(Number(rowData.closingAmountPaid) || 0).toFixed(2)}`}
                                        />
                                        <Column alignHeader="center" bodyClassName="text-center" header="Due at Closing"
                                            body={(rowData) => `₹${(Number(rowData.closingDueAmt) || 0).toFixed(2)}`}
                                        />
                                        <Column alignHeader="center" bodyClassName="text-center" header="Closed On"
                                            body={(rowData) => rowData.closedDate ? moment(rowData.closedDate).format('DD-MM-YYYY') : '-'}
                                        />
                                    </DataTable>
                                </div>
                            )}
                        </div>
                    )}

                    <Dialog
                        visible={this.state.openCreateFeeDialog}
                        className="pay-fee"
                        style={{ position: 'fixed', right: '0' }}
                        draggable={false}
                        onHide={this.onHandleCancelPayFee}
                        closable={false}
                        header={() => {
                            return (
                                <div className="mt-2 mb-4">
                                    <h3 className="formhead text-center ">Pay Fee</h3>
                                </div>
                            );
                        }}
                    ><>
                            <div className="mb-5 ml-5 mr-5">
                                <div>
                                    {!this.state.partialPayment && (
                                        <div className="col-12">
                                            <label className="label mb-2 ">
                                                Installement<span className="ma-required">*</span>
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="term"
                                                    icon={<CodeLinkIcon height={22} />}
                                                    className=""
                                                    height="48px"
                                                    width="368px"
                                                    placeholder="Enter Installment"
                                                    value={`${payFeeFormData.feeinstallmentTitle}`}
                                                    disabled={true}
                                                    onChange={(e) => onTextChange(e.target.value, 'feeinstallmentTitle', this, createFields, payFeeFormData, formValidations, 'payFeeFormData', formValidations)}
                                                />
                                            </div>
                                            {formValidations && !formValidations.fields['feeinstallmentTitle'].isValid && <p className="p-error">{formValidations.fields['feeinstallmentTitle'].errorMsg}</p>}
                                        </div>
                                    )}

                                    {!this.state.partialPayment && (
                                        <div className="col-12">
                                            <label className="label mb-2 ">
                                                Due Amount<span className="ma-required">*</span>
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="dueAmount"
                                                    icon={<CodeLinkIcon height={22} />}
                                                    className=""
                                                    height="48px"
                                                    width="368px"
                                                    placeholder="Enter Due Amount"
                                                    value={payFeeFormData.dueAmount}
                                                    disabled={true}
                                                    onChange={(e) => onTextChange(e.target.value, 'dueAmount', this, createFields, payFeeFormData, formValidations, 'payFeeFormData', formValidations)}
                                                />
                                            </div>
                                            {formValidations && !formValidations.fields['dueAmount'].isValid && <p className="p-error">{formValidations.fields['dueAmount'].errorMsg}</p>}
                                        </div>
                                    )}
                                    {/* Advance Amount Display and Checkbox */}
                                    {this.state.advanceInfo && this.state.advanceInfo.advance > 0 && (
                                        <div className="col-12 mb-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
                                            <div className="flex align-items-center justify-content-between">
                                                <div className='flex'>
                                                    <p className="font-semibold text-900" style={{ fontSize: "14px" }}>
                                                        Advance: <span className="text-700" style={{ color: "#000" }}>₹ {this.state.advanceInfo.advance}</span>
                                                    </p>
                                                </div>
                                                <div className="flex align-items-center">
                                                    <Checkbox
                                                        inputId="useAdvance"
                                                        checked={this.state.useAdvanceAmount}
                                                        onChange={this.handleUseAdvanceChange}
                                                        className="mr-2"
                                                    />
                                                    <label htmlFor="useAdvance" className="font-medium text-900" style={{ fontSize: "14px" }}>
                                                        Use Advance Amount
                                                    </label>
                                                </div>
                                            </div>
                                            {this.state.useAdvanceAmount && (
                                                <div className="mt-2">
                                                    <div className="p-2 border-1 border-left-3 border-yellow-500 bg-yellow-50 text-yellow-800" style={{ borderRadius: '4px' }}>
                                                        <i className="pi pi-info-circle mr-2"></i>
                                                        <span>You can only use up to a maximum of the available advance amount (₹{this.state.advanceInfo.advance}).</span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    <div className="col-12">
                                        <label className="label mb-2 ">
                                            Payment Type<span className="ma-required">*</span>
                                        </label>
                                        <div className="mt-2">
                                            <ClassetDropdown
                                                id="paymentType"
                                                className=""
                                                height="48px"
                                                width="368px"
                                                options={
                                                    !this.state.useAdvanceAmount ?
                                                        paymentModes?.filter(el => el.label !== "Adjustment" && el.label !== "Cheque") : paymentModes?.filter(el => el.label !== "Cheque")
                                                }
                                                value={payFeeFormData.paymentType}
                                                onChange={(e) => {
                                                    onDropDownChange(e.target.value, 'paymentType', this, createFields, payFeeFormData, formValidations, 'payFeeFormData', formValidations);
                                                }}
                                                placeholder={
                                                    <div>
                                                        <span className="">Select Payment Type</span>
                                                    </div>
                                                }
                                                disabled={this.state.useAdvanceAmount}
                                            />
                                        </div>
                                        {formValidations && !formValidations.fields['paymentType'].isValid && <p className="p-error">{formValidations.fields['paymentType'].errorMsg}</p>}
                                    </div>
                                    <div className="col-12">
                                        <label className="label mb-2 ">
                                            Transaction Date
                                        </label>
                                        <div className="mt-2">
                                            <ClassetCalendar

                                                className=""
                                                height="48px"
                                                width="368px"
                                                placeholder="Select Date"
                                                calendarMode="single"
                                                value={this.state.transactionDate}
                                                onChange={(e) => this.setState({ transactionDate: e.value })}
                                                maxDate={new Date()}
                                            />
                                        </div>
                                    </div>
                                    {payFeeFormData.paymentType && this.state.partialPayment && (
                                        <div className="col-12">
                                            <label className="label mb-2 ">
                                                Paid Amount<span className="ma-required">*</span>
                                                {this.state.useAdvanceAmount && this.state.advanceInfo && (
                                                    <span className="text-sm text-primary font-medium ml-2">
                                                        (Max: ₹{this.state.advanceInfo.advance})
                                                    </span>
                                                )}
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="amountPaying"
                                                    className={this.state.useAdvanceAmount && Number(payFeeFormData.amountPaying) > this.state.advanceInfo?.advance ? "p-invalid" : ""}
                                                    height="48px"
                                                    width="368px"
                                                    keyfilter="num"
                                                    placeholder="Enter Paid Amount"
                                                    value={payFeeFormData.amountPaying}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        // If using advance amount, enforce the limit
                                                        if (this.state.useAdvanceAmount && this.state.advanceInfo && Number(value) > this.state.advanceInfo.advance) {
                                                            // Show toast notification
                                                            this.toast.show({
                                                                severity: 'warn',
                                                                summary: 'Amount Limit',
                                                                detail: `Amount cannot exceed available advance of ₹${this.state.advanceInfo.advance}`,
                                                                life: 3000
                                                            });
                                                            // Set to max available advance
                                                            onTextChange(this.state.advanceInfo.advance.toString(), 'amountPaying', this, createFields, payFeeFormData, formValidations, 'payFeeFormData', formValidations);
                                                        } else {
                                                            onTextChange(value, 'amountPaying', this, createFields, payFeeFormData, formValidations, 'payFeeFormData', formValidations);
                                                        }
                                                    }}
                                                />
                                            </div>
                                            {this.state.useAdvanceAmount && Number(payFeeFormData.amountPaying) > this.state.advanceInfo?.advance && (
                                                <small className="p-error">
                                                    <i className="pi pi-exclamation-triangle mr-1"></i>
                                                    Amount cannot exceed available advance (₹{this.state.advanceInfo.advance})
                                                </small>
                                            )}
                                            {formValidations && !formValidations.fields['amountPaying'].isValid && <p className="p-error">{formValidations.fields['amountPaying'].errorMsg}</p>}
                                        </div>
                                    )}
                                    {(payFeeFormData.paymentType === '1c98862e-46dc-4454-a120-7d15e2e56e2f' || payFeeFormData.paymentType === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1') && (
                                        <>
                                            <div className="col-12">
                                                {payFeeFormData.paymentType === '1c98862e-46dc-4454-a120-7d15e2e56e2f' && (
                                                    <label className="label mb-2 ">
                                                        Cheque Issued To<span className="ma-required">*</span>
                                                    </label>
                                                )}
                                                {payFeeFormData.paymentType === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1' && (
                                                    <label className="label mb-2 ">
                                                        DD Issued To<span className="ma-required">*</span>
                                                    </label>
                                                )}
                                                <div className="mt-2">
                                                    <ClassetInputText
                                                        icon={<CodeLinkIcon height={22} />}
                                                        className=""
                                                        height="48px"
                                                        width="368px"
                                                        placeholder="Enter Check Issued To"
                                                        value={this.state.chequeIssuedTo}
                                                        onChange={(e) => this.setState({ chequeIssuedTo: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                {payFeeFormData.paymentType === '1c98862e-46dc-4454-a120-7d15e2e56e2f' && (
                                                    <label className="label mb-2 ">
                                                        Cheque No<span className="ma-required">*</span>
                                                    </label>
                                                )}
                                                {payFeeFormData.paymentType === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1' && (
                                                    <label className="label mb-2 ">
                                                        DD No<span className="ma-required">*</span>
                                                    </label>
                                                )}
                                                <div className="mt-2">
                                                    <ClassetInputText
                                                        icon={<CodeLinkIcon height={22} />}
                                                        className=""
                                                        height="48px"
                                                        width="368px"
                                                        placeholder="Enter Cheque No"
                                                        value={this.state.chequeNo}
                                                        onChange={(e) => this.setState({ chequeNo: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                {payFeeFormData.paymentType === '1c98862e-46dc-4454-a120-7d15e2e56e2f' && (
                                                    <label className="label mb-2 ">
                                                        Cheque Date<span className="ma-required">*</span>
                                                    </label>
                                                )}
                                                {payFeeFormData.paymentType === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1' && (
                                                    <label className="label mb-2 ">
                                                        DD Date<span className="ma-required">*</span>
                                                    </label>
                                                )}
                                                <div className="mt-2">
                                                    <ClassetCalendar

                                                        className=""
                                                        height="48px"
                                                        width="368px"
                                                        placeholder="Select Date"
                                                        calendarMode="single"
                                                        value={this.state.chequeDate}
                                                        onChange={(e) => this.setState({ chequeDate: e.value })}
                                                        maxDate={new Date()}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <label className="label mb-2 ">
                                                    Bank Name<span className="ma-required">*</span>
                                                </label>
                                                <div className="mt-2">
                                                    <ClassetInputText
                                                        icon={<CodeLinkIcon height={22} />}
                                                        className=""
                                                        height="48px"
                                                        width="368px"
                                                        placeholder="Enter Bank Name"
                                                        value={this.state.bankName}
                                                        onChange={(e) => this.setState({ bankName: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <label className="label mb-2 ">
                                                    Bank Branch Name<span className="ma-required">*</span>
                                                </label>
                                                <div className="mt-2">
                                                    <ClassetInputText
                                                        id="feeType"
                                                        icon={<CodeLinkIcon height={22} />}
                                                        className=""
                                                        height="48px"
                                                        width="368px"
                                                        placeholder="Bank Branch Name"
                                                        value={this.state.bankBranchName}
                                                        onChange={(e) => this.setState({ bankBranchName: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    {(payFeeFormData.paymentType === 'b9e46415-1b11-4377-9105-58b98c230935' ||
                                        payFeeFormData.paymentType === '274a4416-2454-4f3a-b741-89c67361ae1f') && (
                                            <>
                                                <div className="col-12">
                                                    <label className="label mb-2 ">
                                                        Card Last 4 Digits
                                                    </label>
                                                    <div className="mt-2">
                                                        <ClassetInputText
                                                            className=""
                                                            height="48px"
                                                            width="368px"
                                                            keyfilter="int"
                                                            maxLength={4}
                                                            minLength={4}
                                                            placeholder="Enter Card Last 4 Digits"
                                                            value={this.state.cardNo}
                                                            onChange={(e) => this.setState({ cardNo: e.target.value })}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <label className="label mb-2 ">
                                                        Approval Code
                                                    </label>
                                                    <div className="mt-2">
                                                        <ClassetInputText
                                                            className=""
                                                            height="48px"
                                                            width="368px"
                                                            placeholder="Enter Approval Code"
                                                            value={this.state.approvalCode}
                                                            onChange={(e) => this.setState({ approvalCode: e.target.value })}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <label className="label mb-2 ">
                                                        RR Number
                                                    </label>
                                                    <div className="mt-2">
                                                        <ClassetInputText
                                                            className=""
                                                            height="48px"
                                                            width="368px"
                                                            placeholder="Enter RR Number"
                                                            value={this.state.rrNumber}
                                                            onChange={(e) => this.setState({ rrNumber: e.target.value })}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <label className="label mb-2 ">
                                                        Bank Name
                                                    </label>
                                                    <div className="mt-2">
                                                        <ClassetInputText
                                                            className=""
                                                            height="48px"
                                                            width="368px"
                                                            placeholder="Enter Bank Name"
                                                            value={this.state.userBankName}
                                                            onChange={(e) => this.setState({ userBankName: e.target.value })}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                    <div className="col-12">
                                        <label className="label mb-2 ">
                                            Destination Bank
                                        </label>
                                        <div className="mt-2">
                                            <ClassetDropdown
                                                className=""
                                                height="48px"
                                                width="368px"
                                                placeholder="Enter Destination Bank Name"
                                                options={this.state?.bankOptions}
                                                value={this.state.destinationBank}
                                                onChange={(e) => this.setState({ destinationBank: e.target.value })}
                                            />
                                        </div>
                                    </div>


                                    {(payFeeFormData.paymentType === 'b9e46415-1b11-4377-9105-58b98c230935' ||
                                        payFeeFormData.paymentType === '274a4416-2454-4f3a-b741-89c67361ae1f' || payFeeFormData.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' || payFeeFormData?.paymentType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489') && (
                                            <div className="col-12">
                                                <label className="label mb-2 ">
                                                    Transaction Id
                                                </label>
                                                <div className="mt-2">
                                                    <ClassetInputText
                                                        icon={<CodeLinkIcon height={22} />}
                                                        className=""
                                                        height="48px"
                                                        width="368px"
                                                        placeholder="Enter Transaction Id"
                                                        value={this.state.transctionId}
                                                        onChange={(e) => this.setState({ transctionId: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                        )}


                                    {payFeeFormData.paymentType && (
                                        <div className="col-12">
                                            <label className="label mb-2 ">
                                                Remarks
                                            </label>
                                            <div className="mt-2">
                                                <ClassetTextArea
                                                    id="feeType"
                                                    className=""
                                                    height="48px"
                                                    width="368px"
                                                    placeholder="Enter Remarks"
                                                    value={payFeeFormData.remarks}
                                                    onChange={(e) => onTextChange(e.target.value, 'remarks', this, createFields, payFeeFormData, formValidations, 'payFeeFormData', formValidations)}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {payFeeFormData.amountPaying && <h5 className='text-center' style={{ color: '#076EFF' }}> Amount : {payFeeFormData.amountPaying}</h5>}
                                    {/* Display advance amount status if using advance */}
                                    {this.state.useAdvanceAmount && this.state.advanceInfo && payFeeFormData.amountPaying && (
                                        <div className="col-12 mt-3">
                                            <div className={Number(payFeeFormData.amountPaying) > this.state.advanceInfo.advance
                                                ? 'p-2 border-1 border-left-3 border-red-500 bg-red-50'
                                                : 'p-2 border-1 border-left-3 border-green-500 bg-green-50'}
                                                style={{ borderRadius: '4px' }}>
                                                <i className={Number(payFeeFormData.amountPaying) > this.state.advanceInfo.advance
                                                    ? 'pi pi-exclamation-triangle mr-2 text-red-500'
                                                    : 'pi pi-check-circle mr-2 text-green-500'}>
                                                </i>
                                                <span className={Number(payFeeFormData.amountPaying) > this.state.advanceInfo.advance
                                                    ? 'text-red-700' : 'text-green-700'}>
                                                    {Number(payFeeFormData.amountPaying) > this.state.advanceInfo.advance
                                                        ? `Exceeds advance amount by ₹${(Number(payFeeFormData.amountPaying) - Number(this.state.advanceInfo.advance)).toFixed(2)}`
                                                        : `Using ₹${Number(payFeeFormData.amountPaying).toFixed(2)} from available advance of ₹${(Number(this.state.advanceInfo.advance) || 0).toFixed(2)}`
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                    )}

                                    {payFeeFormData.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' && this.props.termsAndConditions?.storageLocation && (
                                        <div className="col-12 flex align-items-center gap-2 mb-3">
                                            <Checkbox
                                                inputId="termsAccepted"
                                                checked={this.state.termsAccepted}
                                                onChange={(e) => this.setState({ termsAccepted: e.checked })}
                                            />
                                            <label htmlFor="termsAccepted" className="ml-2">
                                                I agree to the{' '}
                                                <a href={this.props.termsAndConditions.storageLocation} target="_blank" rel="noopener noreferrer" style={{ color: '#076EFF' }}>
                                                    Terms and Conditions
                                                </a>
                                            </label>
                                        </div>
                                    )}
                                    <div className="flex justify-content-center mb-4 mt-4">
                                        <Button
                                            className="formSubmitButtonn mr-2"
                                            style={{ borderRadius: '12px', fontSize: '16px', backgroundColor: '#076EFF' }}
                                            onClick={this.handlePayment}
                                            disabled={(this.state.useAdvanceAmount && this.state.advanceInfo &&
                                                (Number(payFeeFormData.amountPaying) > this.state.advanceInfo.advance ||
                                                    !payFeeFormData.amountPaying ||
                                                    Number(payFeeFormData.amountPaying) <= 0)) ||
                                                (payFeeFormData.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' &&
                                                    !!this.props.termsAndConditions?.storageLocation &&
                                                    !this.state.termsAccepted)}
                                        >
                                            <AddIcon2 />
                                            <p className="formSubmitButtonnText">Pay Now</p>
                                        </Button>

                                        <Button className="cancelButtonn w-4" onClick={this.onHandleCancelPayFee}>
                                            <p className="cancelButtonnText">Cancel</p>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            {this.state.isLoading && <LoadingComponent />}
                        </>
                    </Dialog>
                    {this.state.isEnableReceipt && (
                        <NewFeeReciept
                            receiptData={this.state?.receiptData}
                            hideFeeReciept={() => {
                                this.setState({
                                    isEnableReceipt: false,
                                    receiptData: []
                                });
                            }}
                        />
                    )}
                    {this.state.isEnableRefundReceipt && (

                        <NewFeeReciept
                            isRefundReceipt={this.state.isEnableRefundReceipt}
                            receiptData={this.state?.receiptData}
                            hideFeeReciept={() => {
                                this.setState({
                                    isEnableRefundReceipt: false,
                                    receiptData: []
                                });
                            }}
                        />)
                    }
                    {this.state.isBulkfeeReceipts && (
                        <BulkFeeReciepts
                            receiptData={this.state?.termWiseReceiptInfo}
                            hideFeeReciept={() => {
                                this.setState({
                                    isBulkfeeReceipts: false,
                                    termWiseReceiptInfo: []
                                });
                            }}
                        />
                    )}
                    <Toast ref={(el) => (this.toast = el)} position="bottom" />
                </div>

                <Dialog
                    visible={this.state.adHocCollectDialogVisible}
                    onHide={() => this.setState({ adHocCollectDialogVisible: false, adHocCollectCharge: null, adHocCollectAmount: '' })}
                    header="Collect Ad Hoc Charge"
                    style={{ width: '450px' }}
                    draggable={false}
                    footer={
                        <div>
                            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={() => this.setState({ adHocCollectDialogVisible: false, adHocCollectCharge: null })} />
                            <Button label="Collect" icon="pi pi-check" className="p-button-sm" onClick={this.collectAdHocCharge} />
                        </div>
                    }
                >
                    <div className="p-fluid">
                        <div className="mb-3">
                            <label className="block mb-1 font-medium">Fee Type</label>
                            <p className="font-bold">{this.state.adHocCollectCharge?.feeinstallmentTitle || this.state.adHocCollectCharge?.feeType}</p>
                        </div>
                        <div className="mb-3">
                            <label className="block mb-1 font-medium">Balance Due</label>
                            <p>₹{this.state.adHocCollectCharge?.dueAmount || 0}</p>
                        </div>
                        <div className="mb-3">
                            <label className="block mb-1 font-medium">Amount Paying</label>
                            <ClassetInputText
                                type="text"
                                value={this.state.adHocCollectAmount}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (val === '' || val.match(/^\d*\.?\d{0,2}$/)) {
                                        this.setState({ adHocCollectAmount: val });
                                    }
                                }}
                                placeholder="Enter amount"
                                height="48px"
                            />
                        </div>
                        <div className="mb-3">
                            <label className="block mb-1 font-medium">Payment Mode</label>
                            <ClassetDropdown
                                options={[
                                    { label: 'Cash', value: '74b95cc8-9736-44a0-b2df-325595783c3b' },
                                    { label: 'Online', value: '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' },
                                    { label: 'Cheque', value: '1c98862e-46dc-4454-a120-7d15e2e56e2f' },
                                    { label: 'DD', value: '9d08ebab-2d3e-4a30-8460-4e4092fe30a1' }
                                ]}
                                value={this.state.adHocCollectPaymentType}
                                onChange={(e) => this.setState({ adHocCollectPaymentType: e.value })}
                                placeholder="Select Payment Mode"
                                height="48px"
                            />
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    isopen={this.state.isInstallmentInfo}
                    visible={this.state.isInstallmentInfo}
                    width={"80vw"}
                    height={"80vh"}
                    draggable={false}
                    onHide={this.onHandleInstallmentInfo}
                    closable={true}
                    header={() => {
                        return (
                            <div className="mt-2 mb-4">
                                <h3 className="formhead text-center ">Fee Installment Details</h3>
                            </div>
                        );
                    }}
                >
                    <>
                        <DataTable
                            ref={(el) => (this.dt = el)}
                            value={this.state.installmentInfoData}
                            dataKey="id" lazy
                            responsiveLayout="scroll"
                            className="dataTableValuesText"
                            showGridlines
                            columnResizeMode="expand"
                            resizableColumns
                            onPage={this.onPage}
                            rows={this.state.lazyParams.rows}
                        >
                            <Column header='Sl.No' alignHeader={'center'} bodyClassName='text-center' className='col-1' body={(rowData, index) => {
                                return (<span >{index.rowIndex + 1}</span>)
                            }} />
                            <Column
                                alignHeader={'center'}
                                sortable
                                bodyClassName="text-center"
                                header="Fee Type"
                                filterField="feeType" field="feeType"
                            ></Column>
                            <Column
                                alignHeader={'center'}
                                sortable
                                bodyClassName="text-center"
                                header="Term Amount"
                                filterField="termWiseActualValue"
                                body={(rowData, { rowIndex }) => {
                                    return <div className="flex justify-content-center">{` ${Math.round(((rowData?.termAmt ?? rowData?.termWiseActualValue) || 0) * 100) / 100}`}</div>;

                                }}
                            ></Column>
                            <Column
                                alignHeader={'center'}
                                sortable
                                bodyClassName="text-center"
                                header="Gst(%)"
                                filterField="gstPer" field="gstPer"
                            ></Column>
                            <Column
                                alignHeader={'center'}
                                sortable
                                bodyClassName="text-center"
                                body={(rowData, { rowIndex }) => {
                                    return <div className="flex justify-content-center">{rowData?.concession || 0}</div>;
                                }}
                                header="Concession"

                            />

                            <Column
                                alignHeader={'center'}
                                sortable
                                bodyClassName="text-center"
                                body={(rowData, { rowIndex }) => {
                                    return <div className="flex justify-content-center">{rowData?.fineAmt || 0}</div>;
                                }}
                                header="Fine"
                                filterField="fineAmt" field="fineAmt">
                            </Column>
                            <Column
                                alignHeader={'center'}
                                sortable
                                bodyClassName="text-center"
                                header="Refund"
                                filterField="" field=""
                                body={(rowData, { rowIndex }) => {
                                    return <div className="flex justify-content-center">{`${rowData?.refundAmt ? (Math.round((rowData?.refundAmt) * 100) / 100) : 0}`}</div>;

                                }}
                            ></Column>
                            <Column
                                alignHeader={'center'}
                                sortable
                                bodyClassName="text-center"
                                header="Total Amount"
                                body={(rowData, { rowIndex }) => {
                                    const value = rowData.termWiseActualValue * (rowData.gstPer / 100) + rowData.termWiseActualValue;
                                    const roundedValue = Math.round(value * 100) / 100;
                                    return <div className="flex justify-content-center">{roundedValue}</div>;
                                }}
                            ></Column>
                            <Column
                                alignHeader={'center'}
                                sortable
                                bodyClassName="text-center"
                                header="Paid Amount"
                                filterField="amountPaid" field="amountPaid"
                                body={(rowData, { rowIndex }) => {
                                    return <div className="flex justify-content-center">{` ${Math.round((rowData.amountPaid + ((rowData?.gstPaid || 0) - (rowData?.gstForRefundAmt || 0))) * 100) / 100}`}</div>;

                                }}
                            ></Column>
                            <Column
                                alignHeader={'center'}
                                sortable
                                bodyClassName="text-center"
                                header="Due Amount"
                                body={(rowData, { rowIndex }) => {
                                    return <div className="flex justify-content-center">
                                        {` ${Math.round(((rowData.termWiseActualValue * (rowData.gstPer / 100) + rowData.termWiseActualValue) - (rowData.amountPaid + ((rowData?.gstPaid || 0) - (rowData?.gstForRefundAmt || 0)))) * 100) / 100}`}
                                    </div>;
                                }}
                            ></Column>

                        </DataTable>
                        {this.state.isLoading && <LoadingComponent />}
                    </>
                </Dialog>

                <Dialog
                    visible={this.state.isPayOldFeeInfo}
                    className="pay-fee"
                    draggable={false}
                    onHide={this.onHandleCancelOldPayFee}
                    closable={false}
                    header={() => {
                        return (
                            <div className="mt-2 mb-4">
                                <h3 className="formhead text-center ">Pay Fee</h3>
                            </div>
                        );
                    }}
                ><>
                        <div className="mb-5 ml-5 mr-5">
                            <div>
                                <div className="col-12">
                                    <label className="label mb-2 ">
                                        Payment Type
                                    </label>
                                    <div className="mt-2">
                                        <ClassetDropdown
                                            id="paymentType"
                                            className=""
                                            height="48px"
                                            width="368px"
                                            options={
                                                !this.state.useAdvanceAmount ?
                                                    paymentModes?.filter(el => el.label !== "Adjustment") : paymentModes
                                            }
                                            value={payFeeFormData.paymentType}
                                            onChange={(e) => {
                                                onDropDownChange(e.target.value, 'paymentType', this, createFields, payFeeFormData, formValidations, 'payFeeFormData', formValidations);
                                            }}
                                            placeholder={
                                                <div>
                                                    <span className="">Select Payment Type</span>
                                                </div>
                                            }
                                            disabled={this.state.useAdvanceAmount ? true : false}
                                        />
                                    </div>
                                    {formValidations && !formValidations.fields['paymentType'].isValid && <p className="p-error">{formValidations.fields['paymentType'].errorMsg}</p>}
                                </div>
                                <div className="col-12">
                                    <label className="label mb-2 ">
                                        Transaction Date
                                    </label>
                                    <div className="mt-2">
                                        <ClassetCalendar

                                            className=""
                                            height="48px"
                                            width="368px"
                                            placeholder="Select Date"
                                            calendarMode="single"
                                            value={this.state.receiptDate}
                                            onChange={(e) => this.setState({ receiptDate: e.value })}
                                            maxDate={new Date()}
                                        />
                                    </div>
                                </div>
                                {(payFeeFormData.paymentType === 'b9e46415-1b11-4377-9105-58b98c230935' ||
                                    payFeeFormData.paymentType === '274a4416-2454-4f3a-b741-89c67361ae1f') && (
                                        <>
                                            <div className="col-12">
                                                <label className="label mb-2 ">
                                                    Card Last 4 Digits
                                                </label>
                                                <div className="mt-2">
                                                    <ClassetInputText
                                                        className=""
                                                        height="48px"
                                                        width="368px"
                                                        keyfilter="int"
                                                        maxLength={4}
                                                        minLength={4}
                                                        placeholder="Enter Card Last 4 Digits"
                                                        value={this.state.cardNo}
                                                        onChange={(e) => this.setState({ cardNo: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <label className="label mb-2 ">
                                                    Approval Code
                                                </label>
                                                <div className="mt-2">
                                                    <ClassetInputText
                                                        className=""
                                                        height="48px"
                                                        width="368px"
                                                        placeholder="Enter Approval Code"
                                                        value={this.state.approvalCode}
                                                        onChange={(e) => this.setState({ approvalCode: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <label className="label mb-2 ">
                                                    RR Number
                                                </label>
                                                <div className="mt-2">
                                                    <ClassetInputText
                                                        className=""
                                                        height="48px"
                                                        width="368px"
                                                        placeholder="Enter RR Number"
                                                        value={this.state.rrNumber}
                                                        onChange={(e) => this.setState({ rrNumber: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <label className="label mb-2 ">
                                                    Bank Name
                                                </label>
                                                <div className="mt-2">
                                                    <ClassetInputText
                                                        className=""
                                                        height="48px"
                                                        width="368px"
                                                        placeholder="Enter Bank Name"
                                                        value={this.state.userBankName}
                                                        onChange={(e) => this.setState({ userBankName: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}


                                {(payFeeFormData.paymentType === '1c98862e-46dc-4454-a120-7d15e2e56e2f' || payFeeFormData.paymentType === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1') && (
                                    <>
                                        <div className="col-12">
                                            {payFeeFormData.paymentType === '1c98862e-46dc-4454-a120-7d15e2e56e2f' && (
                                                <label className="label mb-2 ">
                                                    Cheque Issued To
                                                </label>
                                            )}
                                            {payFeeFormData.paymentType === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1' && (
                                                <label className="label mb-2 ">
                                                    DD Issued To
                                                </label>
                                            )}
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    icon={<CodeLinkIcon height={22} />}
                                                    className=""
                                                    height="48px"
                                                    width="368px"
                                                    placeholder={payFeeFormData.paymentType === '1c98862e-46dc-4454-a120-7d15e2e56e2f' ? "Enter Check Issued To" : "Enter DD Issued To"}
                                                    value={this.state.chequeIssuedTo}
                                                    onChange={(e) => this.setState({ chequeIssuedTo: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            {payFeeFormData.paymentType === '1c98862e-46dc-4454-a120-7d15e2e56e2f' && (
                                                <label className="label mb-2 ">
                                                    Cheque No
                                                </label>
                                            )}
                                            {payFeeFormData.paymentType === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1' && (
                                                <label className="label mb-2 ">
                                                    DD No
                                                </label>
                                            )}
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    icon={<CodeLinkIcon height={22} />}
                                                    className=""
                                                    height="48px"
                                                    width="368px"
                                                    placeholder={payFeeFormData.paymentType === '1c98862e-46dc-4454-a120-7d15e2e56e2f' ? "Enter Cheque No" : "Enter DD No"}
                                                    value={this.state.chequeNo}
                                                    onChange={(e) => this.setState({ chequeNo: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            {payFeeFormData.paymentType === '1c98862e-46dc-4454-a120-7d15e2e56e2f' && (
                                                <label className="label mb-2 ">
                                                    Cheque Date
                                                </label>
                                            )}
                                            {payFeeFormData.paymentType === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1' && (
                                                <label className="label mb-2 ">
                                                    DD Date
                                                </label>
                                            )}
                                            <div className="mt-2">
                                                <ClassetCalendar

                                                    className=""
                                                    height="48px"
                                                    width="368px"
                                                    placeholder="Select Date"
                                                    calendarMode="single"
                                                    value={this.state.chequeDate}
                                                    onChange={(e) => this.setState({ chequeDate: e.value })}
                                                    maxDate={new Date()}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <label className="label mb-2 ">
                                                Bank Name
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    icon={<CodeLinkIcon height={22} />}
                                                    className=""
                                                    height="48px"
                                                    width="368px"
                                                    placeholder="Enter Bank Name"
                                                    value={this.state.bankName}
                                                    onChange={(e) => this.setState({ bankName: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <label className="label mb-2 ">
                                                Bank Branch Name
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="feeType"
                                                    icon={<CodeLinkIcon height={22} />}
                                                    className=""
                                                    height="48px"
                                                    width="368px"
                                                    placeholder="Bank Branch Name"
                                                    value={this.state.bankBranchName}
                                                    onChange={(e) => this.setState({ bankBranchName: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}

                                <div className="col-12">
                                    <label className="label mb-2 ">
                                        Destination Bank
                                    </label>
                                    <div className="mt-2">
                                        <ClassetDropdown
                                            className=""
                                            height="48px"
                                            width="368px"
                                            placeholder="Enter Destination Bank Name"
                                            options={this.state?.bankOptions}
                                            value={this.state.destinationBank}
                                            onChange={(e) => this.setState({ destinationBank: e.target.value })}
                                        />
                                    </div>
                                </div>


                                {(payFeeFormData.paymentType === 'b9e46415-1b11-4377-9105-58b98c230935' ||
                                    payFeeFormData.paymentType === '274a4416-2454-4f3a-b741-89c67361ae1f' || payFeeFormData.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' || payFeeFormData?.paymentType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489') && (
                                        <div className="col-12">
                                            <label className="label mb-2 ">
                                                Transaction Id
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    icon={<CodeLinkIcon height={22} />}
                                                    className=""
                                                    height="48px"
                                                    width="368px"
                                                    placeholder="Enter Transaction Id"
                                                    value={this.state.transctionId}
                                                    onChange={(e) => this.setState({ transctionId: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    )}


                                {payFeeFormData.paymentType && (
                                    <div className="col-12">
                                        <label className="label mb-2 ">
                                            Remarks
                                        </label>
                                        <div className="mt-2">
                                            <ClassetTextArea
                                                id="feeType"
                                                className=""
                                                height="48px"
                                                width="368px"
                                                placeholder="Enter Remarks"
                                                value={payFeeFormData.remarks}
                                                onChange={(e) => onTextChange(e.target.value, 'remarks', this, createFields, payFeeFormData, formValidations, 'payFeeFormData', formValidations)}
                                            />
                                        </div>
                                    </div>
                                )}

                                {payFeeFormData.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' && this.props.termsAndConditions?.storageLocation && (
                                    <div className="col-12 flex align-items-center gap-2 mb-3">
                                        <Checkbox
                                            inputId="termsAcceptedOld"
                                            checked={this.state.termsAccepted}
                                            onChange={(e) => this.setState({ termsAccepted: e.checked })}
                                        />
                                        <label htmlFor="termsAcceptedOld" className="ml-2">
                                            I agree to the{' '}
                                            <a href={this.props.termsAndConditions.storageLocation} target="_blank" rel="noopener noreferrer" style={{ color: '#076EFF' }}>
                                                Terms and Conditions
                                            </a>
                                        </label>
                                    </div>
                                )}
                                <div className="flex justify-content-center mb-4 mt-4">
                                    <Button className="formSubmitButtonn mr-2" style={{ borderRadius: '12px', fontSize: '16px', backgroundColor: '#076EFF' }}
                                        onClick={this.onHandleOldFeePayment}
                                        disabled={payFeeFormData.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' &&
                                            !!this.props.termsAndConditions?.storageLocation &&
                                            !this.state.termsAccepted}
                                    >
                                        <AddIcon2 />
                                        <p className="formSubmitButtonnText">Pay Now</p>
                                    </Button>
                                    <Button className="cancelButtonn w-4" onClick={this.onHandleCancelOldPayFee}>
                                        <p className="cancelButtonnText">Cancel</p>
                                    </Button>
                                </div>
                            </div>
                        </div>
                        {this.state.isLoading && <LoadingComponent />}
                    </>
                </Dialog>


                <Dialog
                    visible={this.state.isEnableEditReceipt}
                    draggable={false}
                    onHide={this.onHandleCancelEditReceipt}
                    closable={true}
                    className="w-11"
                    header={() => {
                        return (
                            <div className="mt-2 mb-4">
                                <h3 className="formhead text-center ">Receipt Modifications</h3>
                            </div>
                        );
                    }}
                >
                    <div className="p-2">
                        <div className="grid">
                            <div className="col-12">
                                <div className="grid">
                                    {/* Basic Info */}
                                    <div className="col-4">
                                        <div className="flex align-items-center">
                                            <span className="font-semibold text-900 w-4">Student Name : </span>
                                            <span className="text-700"> {receiptModificationData?.given_name || 'N/A'}</span>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="flex align-items-center">
                                            <span className="font-semibold text-900 w-4">Enrollment ID : </span>
                                            <span className="text-700"> {receiptModificationData?.username || 'N/A'}</span>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="flex align-items-center">
                                            <span className="font-semibold text-900 w-4">Receipt No : </span>
                                            <span className="text-700"> {receiptModificationData?.receiptNo || 'N/A'}</span>
                                        </div>
                                    </div>

                                    {/* Receipt Info */}
                                    <div className="col-4">
                                        <div className="flex align-items-center">
                                            <span className="font-semibold text-900 w-4">Receipt Date : </span>
                                            <span className="text-700"> {receiptModificationData?.receiptDate ? moment(receiptModificationData.receiptDate).format('DD-MM-YYYY') : 'N/A'}</span>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="flex align-items-center">
                                            <span className="font-semibold text-900 w-4">Transaction Date : </span>
                                            <span className="text-700"> {receiptModificationData?.transactionDate ? moment(receiptModificationData.transactionDate).format('DD-MM-YYYY') : 'N/A'}</span>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="flex align-items-center">
                                            <span className="font-semibold text-900 w-4">Payment Mode : </span>
                                            <span className="text-700"> {receiptModificationData?.paymentMode || 'N/A'}</span>
                                        </div>
                                    </div>

                                    {/* Transaction ID for specific payment modes */}
                                    {(receiptModificationData.paymentModeId === 'b9e46415-1b11-4377-9105-58b98c230935' ||
                                        receiptModificationData.paymentModeId === '274a4416-2454-4f3a-b741-89c67361ae1f' ||
                                        receiptModificationData.paymentModeId === '32b180cf-7727-46ef-b2a8-e7b1b19fd489' || receiptModificationData?.paymentModeId === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54') && (
                                            <div className="col-4">
                                                <div className="flex align-items-center">
                                                    <span className="font-semibold text-900 w-4">Transaction ID : </span>
                                                    <span className="text-700"> {receiptModificationData?.transctionId || 'N/A'}</span>
                                                </div>
                                            </div>
                                        )}

                                    {/* Cheque Details */}
                                    {receiptModificationData.paymentModeId === '1c98862e-46dc-4454-a120-7d15e2e56e2f' && (
                                        <>
                                            <div className="col-4">
                                                <div className="flex align-items-center">
                                                    <span className="font-semibold text-900 w-4">Cheque Issued To : </span>
                                                    <span className="text-700"> {receiptModificationData?.chequeIssuedTo || 'N/A'}</span>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="flex align-items-center">
                                                    <span className="font-semibold text-900 w-4">Cheque No : </span>
                                                    <span className="text-700"> {receiptModificationData?.chequeNo || 'N/A'}</span>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="flex align-items-center">
                                                    <span className="font-semibold text-900 w-4">Cheque Date : </span>
                                                    <span className="text-700"> {receiptModificationData?.chequeDate ? moment(receiptModificationData.chequeDate).format('DD-MM-YYYY') : 'N/A'}</span>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="flex align-items-center">
                                                    <span className="font-semibold text-900 w-4">Bank Name : </span>
                                                    <span className="text-700"> {receiptModificationData?.bankName || 'N/A'}</span>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="flex align-items-center">
                                                    <span className="font-semibold text-900 w-4">Bank Branch Name : </span>
                                                    <span className="text-700"> {receiptModificationData?.bankBranchName || 'N/A'}</span>
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    {/* DD Details */}
                                    {receiptModificationData.paymentModeId === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1' && (
                                        <>
                                            <div className="col-4">
                                                <div className="flex align-items-center">
                                                    <span className="font-semibold text-900 w-4">DD Issued To : </span>
                                                    <span className="text-700"> {receiptModificationData?.ddIssuedTo || 'N/A'}</span>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="flex align-items-center">
                                                    <span className="font-semibold text-900 w-4">DD No : </span>
                                                    <span className="text-700"> {receiptModificationData?.ddNo || 'N/A'}</span>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="flex align-items-center">
                                                    <span className="font-semibold text-900 w-4">DD Date : </span>
                                                    <span className="text-700"> {receiptModificationData?.ddDate ? moment(receiptModificationData.ddDate).format('DD-MM-YYYY') : 'N/A'}</span>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="flex align-items-center">
                                                    <span className="font-semibold text-900 w-4">Bank Name : </span>
                                                    <span className="text-700"> {receiptModificationData?.bankName || 'N/A'}</span>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="flex align-items-center">
                                                    <span className="font-semibold text-900 w-4">Bank Branch Name : </span>
                                                    <span className="text-700"> {receiptModificationData?.bankBranchName || 'N/A'}</span>
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    {/* Card Payment Details */}
                                    {(receiptModificationData?.paymentModeId === 'b9e46415-1b11-4377-9105-58b98c230935' ||
                                        receiptModificationData?.paymentModeId === '274a4416-2454-4f3a-b741-89c67361ae1f') && (
                                            <>
                                                <div className="col-4">
                                                    <div className="flex align-items-center">
                                                        <span className="font-semibold text-900 w-4">Card Number : </span>
                                                        <span className="text-700"> {receiptModificationData?.cardNo || 'N/A'}</span>
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="flex align-items-center">
                                                        <span className="font-semibold text-900 w-4">Approval Code : </span>
                                                        <span className="text-700"> {receiptModificationData?.approvalCode || 'N/A'}</span>
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="flex align-items-center">
                                                        <span className="font-semibold text-900 w-4">RR Number : </span>
                                                        <span className="text-700"> {receiptModificationData?.rrNumber || 'N/A'}</span>
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="flex align-items-center">
                                                        <span className="font-semibold text-900 w-4">Bank Name : </span>
                                                        <span className="text-700"> {receiptModificationData?.userBankName || 'N/A'}</span>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='grid'>
                        {(receiptModificationData.paymentModeId === 'b9e46415-1b11-4377-9105-58b98c230935' ||
                            receiptModificationData.paymentModeId === '274a4416-2454-4f3a-b741-89c67361ae1f' ||
                            receiptModificationData.paymentModeId === '32b180cf-7727-46ef-b2a8-e7b1b19fd489' ||
                            receiptModificationData?.paymentModeId === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54'
                        ) && (
                                <div className="col-3">
                                    <label className="label mb-2 ">
                                        Transaction Id
                                    </label>
                                    <div className="mt-2">
                                        <ClassetInputText
                                            className=""
                                            height="48px"
                                            width="368px"
                                            placeholder="Enter Transaction Id"
                                            value={receiptModificationData?.modifiedTransctionId}
                                            onChange={(e) => this.setState({ modifiedTransctionId: e.target.value })}
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="col-3">
                            <label className="label mb-2 ">
                                Transaction Date
                            </label>
                            <div className="mt-2">
                                <ClassetCalendar
                                    className=""
                                    height="48px"
                                    width="368px"
                                    placeholder="Select Date"
                                    calendarMode="single"
                                    value={this.state.modifiedTransactionDate}
                                    onChange={(e) => this.setState({ modifiedTransactionDate: e.value })}
                                    maxDate={new Date()}
                                />
                            </div>
                        </div>

                        {(receiptModificationData?.paymentModeId === 'b9e46415-1b11-4377-9105-58b98c230935' ||
                            receiptModificationData?.paymentModeId === '274a4416-2454-4f3a-b741-89c67361ae1f') && (
                                <>

                                    <div className="col-3">
                                        <label className="label mb-2 ">
                                            Card Last 4 Digits
                                        </label>
                                        <div className="mt-2">
                                            <ClassetInputText
                                                className=""
                                                height="48px"
                                                width="368px"
                                                keyfilter="int"
                                                maxLength={4}
                                                minLength={4}
                                                placeholder="Enter Card Last 4 Digits"
                                                value={receiptModificationData.modifiedCardNo}
                                                onChange={(e) => this.setState({ modifiedCardNo: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <label className="label mb-2 ">
                                            Approval Code
                                        </label>
                                        <div className="mt-2">
                                            <ClassetInputText
                                                className=""
                                                height="48px"
                                                width="368px"
                                                placeholder="Enter Approval Code"
                                                value={receiptModificationData.modifiedApprovalCode}
                                                onChange={(e) => this.setState({ modifiedApprovalCode: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <label className="label mb-2 ">
                                            RR Number
                                        </label>
                                        <div className="mt-2">
                                            <ClassetInputText
                                                className=""
                                                height="48px"
                                                width="368px"
                                                placeholder="Enter RR Number"
                                                value={receiptModificationData.modifiedRrNumber}
                                                onChange={(e) => this.setState({ modifiedRrNumber: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <label className="label mb-2 ">
                                            Bank Name
                                        </label>
                                        <div className="mt-2">
                                            <ClassetInputText
                                                className=""
                                                height="48px"
                                                width="368px"
                                                placeholder="Enter Bank Name"
                                                value={receiptModificationData.modifiedUserBankName}
                                                onChange={(e) => this.setState({ modifiedUserBankName: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                </>
                            )}

                        {(receiptModificationData.paymentModeId === '1c98862e-46dc-4454-a120-7d15e2e56e2f' || receiptModificationData.paymentModeId === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1') && (
                            <>
                                <div className="col-3">
                                    {receiptModificationData.paymentModeId === '1c98862e-46dc-4454-a120-7d15e2e56e2f' && (
                                        <label className="label mb-2 ">
                                            Cheque Issued To
                                        </label>
                                    )}
                                    {receiptModificationData.paymentModeId === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1' && (
                                        <label className="label mb-2 ">
                                            DD Issued To
                                        </label>
                                    )}
                                    <div className="mt-2">
                                        <ClassetInputText
                                            icon={<CodeLinkIcon height={22} />}
                                            className=""
                                            height="48px"
                                            width="368px"
                                            placeholder={receiptModificationData.paymentModeId === '1c98862e-46dc-4454-a120-7d15e2e56e2f' ? "Enter Check Issued To" : "Enter DD Issued To"}
                                            value={this.state.modifiedChequeIssuedTo}
                                            onChange={(e) => this.setState({ modifiedChequeIssuedTo: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="col-3">
                                    {receiptModificationData.paymentModeId === '1c98862e-46dc-4454-a120-7d15e2e56e2f' && (
                                        <label className="label mb-2 ">
                                            Cheque No
                                        </label>
                                    )}
                                    {receiptModificationData.paymentModeId === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1' && (
                                        <label className="label mb-2 ">
                                            DD No
                                        </label>
                                    )}
                                    <div className="mt-2">
                                        <ClassetInputText
                                            icon={<CodeLinkIcon height={22} />}
                                            className=""
                                            height="48px"
                                            width="368px"
                                            placeholder={receiptModificationData.paymentModeId === '1c98862e-46dc-4454-a120-7d15e2e56e2f' ? "Enter Cheque No" : "Enter DD No"}
                                            value={this.state.modifiedChequeNo}
                                            onChange={(e) => this.setState({ modifiedChequeNo: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="col-3">
                                    {receiptModificationData.paymentModeId === '1c98862e-46dc-4454-a120-7d15e2e56e2f' && (
                                        <label className="label mb-2 ">
                                            Cheque Date
                                        </label>
                                    )}
                                    {receiptModificationData.paymentModeId === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1' && (
                                        <label className="label mb-2 ">
                                            DD Date
                                        </label>
                                    )}
                                    <div className="mt-2">
                                        <ClassetCalendar

                                            className=""
                                            height="48px"
                                            width="368px"
                                            placeholder="Select Date"
                                            calendarMode="single"
                                            value={this.state.modifiedChequeDate ?? null}
                                            onChange={(e) => this.setState({ modifiedChequeDate: e.value })}
                                            maxDate={new Date()}
                                        />
                                    </div>
                                </div>
                                <div className="col-3">
                                    <label className="label mb-2 ">
                                        Bank Name
                                    </label>
                                    <div className="mt-2">
                                        <ClassetInputText
                                            icon={<CodeLinkIcon height={22} />}
                                            className=""
                                            height="48px"
                                            width="368px"
                                            placeholder="Enter Bank Name"
                                            value={this.state.modifiedBankName}
                                            onChange={(e) => this.setState({ modifiedBankName: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="col-3">
                                    <label className="label mb-2 ">
                                        Bank Branch Name
                                    </label>
                                    <div className="mt-2">
                                        <ClassetInputText
                                            id="feeType"
                                            icon={<CodeLinkIcon height={22} />}
                                            className=""
                                            height="48px"
                                            width="368px"
                                            placeholder="Bank Branch Name"
                                            value={this.state.modifiedBankBranchName}
                                            onChange={(e) => this.setState({ modifiedBankBranchName: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                        <div className="col-12">
                            <DataTable
                                value={receiptModificationData?.feePaidDetails?.filter(item =>
                                    typeof item.amountPaying === 'number' && !isNaN(item.amountPaying)
                                ) || []}
                                className="p-datatable-xl fee-type-table"
                                showGridlines
                                responsiveLayout="scroll"
                                stripedRows
                            >
                                <Column
                                    header="Fee Type"
                                    field="feeType"
                                    sortable
                                    headerClassName="text-xl p-3"
                                    bodyClassName="text-lg p-3 text-center"
                                    alignHeader="center"
                                />
                                <Column
                                    header="Payment Term"
                                    field="paymentTerm"
                                    sortable
                                    headerClassName="text-xl p-3"
                                    bodyClassName="text-lg p-3 text-center"
                                    alignHeader="center"
                                />
                                <Column
                                    header="Amount Paid"
                                    field="amountPaying"
                                    body={(rowData) => `₹${(rowData.amountPaying || 0).toFixed(2)}`}
                                    sortable
                                    headerClassName="text-xl p-3"
                                    bodyClassName="text-lg p-3 text-center"
                                    alignHeader="center"
                                />
                                <Column
                                    header="Amount Changes"
                                    sortable
                                    headerClassName="text-xl p-3"
                                    bodyClassName="text-lg p-3 text-center"
                                    alignHeader="center"
                                    body={(rowData, { rowIndex }) => (
                                        <div className="flex justify-content-center">
                                            <ClassetInputText
                                                className="text-center"
                                                height="40px"
                                                width="120px"
                                                value={rowData.modifiedAmount}
                                                keyfilter="money"
                                                placeholder="Enter amount"
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    // Validate that new amount doesn't exceed original amount paid
                                                    if (Number(newValue) <= Number(rowData.amountPaying)) {
                                                        const updatedDetails = [...receiptModificationData.feePaidDetails];
                                                        updatedDetails[rowIndex] = {
                                                            ...rowData,
                                                            modifiedAmount: newValue
                                                        };
                                                        this.setState(prevState => ({
                                                            receiptModificationData: {
                                                                ...prevState.receiptModificationData,
                                                                feePaidDetails: updatedDetails
                                                            }
                                                        }));
                                                    } else {
                                                        this.toast.show({
                                                            severity: 'error',
                                                            summary: 'Validation Error',
                                                            detail: 'Modified amount cannot exceed the original paid amount',
                                                            life: 3000
                                                        });
                                                    }
                                                }}
                                            />
                                        </div>
                                    )}
                                />
                            </DataTable>

                            <div className="flex justify-content-end mt-4 p-4 border-round-lg bg-gray-50">
                                <div className="flex gap-6">
                                    <div className="flex align-items-center gap-2">
                                        <span className="font-bold text-xl" style={{ color: "#076EFF" }}>Total Original Amount:</span>
                                        <span className="text-xl">₹{(receiptModificationData?.feePaidDetails?.reduce((sum, item) => sum + Number(item.amountPaying || 0), 0) || 0).toFixed(2)}</span>
                                    </div>
                                    <div className="flex align-items-center gap-2">
                                        <span className="font-bold text-xl" style={{ color: "#076EFF" }}>Total Modifying Amount:</span>
                                        <span className="text-xl">₹{(receiptModificationData?.feePaidDetails?.reduce((sum, item) => sum + Number(item.modifiedAmount || 0), 0) || 0).toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 mt-4">
                                <label className="label mb-2">
                                    Remarks<span className="ma-required">*</span>
                                </label>
                                <div className="mt-2">
                                    <ClassetTextArea
                                        className=""
                                        height="100px"
                                        width="100%"
                                        placeholder="Enter Remarks"
                                        value={this.state.modificationRemarks}
                                        onChange={(e) => this.setState({ modificationRemarks: e.target.value })}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Add the buttons container */}
                        <div className="col-12 flex justify-content-center gap-4 mt-4 text-center">
                            <Button
                                className="formSubmitButtonn"
                                style={{
                                    width: "120px",
                                    borderRadius: '12px',
                                    fontSize: '16px',
                                    backgroundColor: '#076EFF',
                                    textAlign: 'center'

                                }}
                                onClick={this.onHandleReceiptModificationSubmit}
                            >
                                <p className="pl-3">Submit</p>
                            </Button>

                            <Button
                                className="cancelButtonn"
                                style={{
                                    width: "120px",
                                    textAlign: 'center'
                                }}
                                onClick={this.onHandleCancelEditReceipt}
                            >
                                <p className="cancelButtonnText">Cancel</p>
                            </Button>
                        </div>
                    </div>
                </Dialog>


                <Dialog
                    visible={this.state.showConfirmationDialog}
                    style={{ width: '50vw' }}
                    header={<h4>Confirm Modifications</h4>}
                    headerClassName='text-xl font-semibold text-center'
                    modal
                    draggable={false}
                    footer={
                        <div className="flex justify-content-end gap-2">
                            <Button
                                label="Confirm"
                                style={{ backgroundColor: '#7CDD56', border: 'none', borderRadius: '5px' }}
                                onClick={this.onConfirmModification}
                            />
                            <Button
                                label="Cancel"
                                className="p-button-danger"
                                style={{ backgroundColor: '#C63737', border: 'none', borderRadius: '5px' }}
                                onClick={this.onRejectModification}
                            />
                        </div>
                    }
                    onHide={this.onRejectModification}
                >
                    {this.state.modificationSummary && (
                        <div className="p-4 text-center">



                            {/* Card/Payment Details */}
                            <div className="grid">
                                {/* Transaction Details */}
                                {this.state.modificationSummary.modifiedTransctionId && (
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2">Modified Transaction ID:</label>
                                            <span>{this.state.modificationSummary.modifiedTransctionId}</span>
                                        </div>
                                    </div>
                                )}
                                {this.state.modificationSummary.modifiedTransactionDate && (
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2">Modified Transaction Date:</label>
                                            <span>{moment(this.state.modificationSummary.modifiedTransactionDate).format('DD-MM-YYYY')}</span>
                                        </div>
                                    </div>
                                )}
                                {this.state.modificationSummary.modifiedCardNo && (
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2">Card Last 4 Digits:</label>
                                            <span>{this.state.modificationSummary.modifiedCardNo}</span>
                                        </div>
                                    </div>
                                )}
                                {this.state.modificationSummary.modifiedApprovalCode && (
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2">Approval Code:</label>
                                            <span>{this.state.modificationSummary.modifiedApprovalCode}</span>
                                        </div>
                                    </div>
                                )}
                                {this.state.modificationSummary.modifiedRrNumber && (
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2">RR Number:</label>
                                            <span>{this.state.modificationSummary.modifiedRrNumber}</span>
                                        </div>
                                    </div>
                                )}
                                {this.state.modificationSummary.modifiedUserBankName && (
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2">Bank Name:</label>
                                            <span>{this.state.modificationSummary.modifiedUserBankName}</span>
                                        </div>
                                    </div>
                                )}
                                {(this.state.receiptModificationData?.paymentModeId === "1c98862e-46dc-4454-a120-7d15e2e56e2f" && this.state.modificationSummary.modifiedChequeIssuedTo) && (
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2">Cheque Issued To:</label>
                                            <span>{this.state.modificationSummary.modifiedChequeIssuedTo}</span>
                                        </div>
                                    </div>
                                )}
                                {(this.state.receiptModificationData?.paymentModeId === "1c98862e-46dc-4454-a120-7d15e2e56e2f" && this.state.modificationSummary.modifiedChequeNo) && (
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2">Cheque No:</label>
                                            <span>{this.state.modificationSummary.modifiedChequeNo}</span>
                                        </div>
                                    </div>
                                )}
                                {(this.state.receiptModificationData?.paymentModeId === "1c98862e-46dc-4454-a120-7d15e2e56e2f" && this.state.modificationSummary.modifiedChequeDate) && (
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2">Cheque Date:</label>
                                            <span>{moment(this.state.modificationSummary.modifiedChequeDate).format('DD-MM-YYYY')}</span>
                                        </div>
                                    </div>
                                )}
                                {(this.state.receiptModificationData?.paymentModeId === "1c98862e-46dc-4454-a120-7d15e2e56e2f" && this.state.modificationSummary.modifiedBankName) && (
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2">Bank Name:</label>
                                            <span>{this.state.modificationSummary.modifiedBankName}</span>
                                        </div>
                                    </div>
                                )}
                                {(this.state.receiptModificationData?.paymentModeId === "1c98862e-46dc-4454-a120-7d15e2e56e2f" && this.state.modificationSummary.modifiedBankBranchName) && (
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2">Bank Branch Name:</label>
                                            <span>{this.state.modificationSummary.modifiedBankBranchName}</span>
                                        </div>
                                    </div>
                                )}
                                {(this.state.receiptModificationData?.paymentModeId === "9d08ebab-2d3e-4a30-8460-4e4092fe30a1" && this.state.modificationSummary.modifiedDdIssuedTo) && (
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2">DD Issued To:</label>
                                            <span>{this.state.modificationSummary.modifiedDdIssuedTo}</span>
                                        </div>
                                    </div>
                                )}
                                {(this.state.receiptModificationData?.paymentModeId === "9d08ebab-2d3e-4a30-8460-4e4092fe30a1" && this.state.modificationSummary.modifiedDdNo) && (
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2">DD No:</label>
                                            <span>{this.state.modificationSummary.modifiedDdNo}</span>
                                        </div>
                                    </div>
                                )}
                                {(this.state.receiptModificationData?.paymentModeId === "9d08ebab-2d3e-4a30-8460-4e4092fe30a1" && this.state.modificationSummary.modifiedDdDate) && (
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2">DD Date:</label>
                                            <span>{moment(this.state.modificationSummary.modifiedDdDate).format('DD-MM-YYYY')}</span>
                                        </div>
                                    </div>
                                )}
                                {(this.state.receiptModificationData?.paymentModeId === "9d08ebab-2d3e-4a30-8460-4e4092fe30a1" && this.state.modificationSummary.modifiedBankName) && (
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2">Bank Name:</label>
                                            <span>{this.state.modificationSummary.modifiedBankName}</span>
                                        </div>
                                    </div>
                                )}
                                {(this.state.receiptModificationData?.paymentModeId === "9d08ebab-2d3e-4a30-8460-4e4092fe30a1" && this.state.modificationSummary.modifiedBankBranchName) && (
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2">Bank Branch Name:</label>
                                            <span>{this.state.modificationSummary.modifiedBankBranchName}</span>
                                        </div>
                                    </div>
                                )}

                                {this.state.modificationSummary.modificationRemarks && (

                                    <div className="col-12 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2">Modification Remarks</label>
                                            <span>{this.state.modificationSummary.modificationRemarks}</span>
                                        </div>
                                    </div>
                                )}

                            </div>

                            {/* Fee Modifications in Confirmation Dialog */}
                            {this.state.modificationSummary.modifiedFeeInfo?.length > 0 && (
                                <div className="mt-4">
                                    <h4 className="mb-3">Fee Amount Changes</h4>
                                    <DataTable value={this.state.modificationSummary.modifiedFeeInfo}>
                                        <Column field="feeType" header="Fee Type" />
                                        <Column field="paymentTerm" header="Term" />
                                        <Column field="amountPaying" header="Original Amount" />
                                        <Column field="modifiedAmount" header="Modified Amount" />
                                    </DataTable>

                                    {/* Add summary section for Confirmation dialog */}
                                    <div className="flex justify-content-end mt-4 p-4 border-round-lg bg-gray-50">
                                        <div className="flex gap-6">
                                            <div className="flex align-items-center gap-2">
                                                <span className="font-bold text-xl" style={{ color: "#076EFF" }}>Total Original Amount:</span>
                                                <span className="text-xl">₹{this.state.modificationSummary.modifiedFeeInfo.reduce((sum, item) => sum + Number(item.amountPaying || 0), 0).toFixed(2)}</span>
                                            </div>
                                            <div className="flex align-items-center gap-2">
                                                <span className="font-bold text-xl" style={{ color: "#076EFF" }}>Total Modifying Amount:</span>
                                                <span className="text-xl">₹{this.state.modificationSummary.modifiedFeeInfo.reduce((sum, item) => sum + Number(item.modifiedAmount || 0), 0).toFixed(2)}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}


                        </div>
                    )}
                </Dialog>

                <Dialog
                    visible={this.state.showFeePreview}
                    style={{ width: '50vw' }}
                    header="Preview Fee Payment Details"
                    headerClassName='text-xl font-semibold text-center'
                    modal
                    draggable={false}
                    onHide={() => this.setState({ showFeePreview: false })}
                    footer={
                        <div className="flex justify-content-end gap-2">
                            <Button
                                label="Confirm"
                                style={{ backgroundColor: '#7CDD56', border: 'none', borderRadius: '5px' }}
                                onClick={this.onConfirmFeePreview}
                            />
                            <Button
                                label="Cancel"
                                className="p-button-danger"
                                style={{ backgroundColor: '#C63737', border: 'none', borderRadius: '5px' }}
                                onClick={() => this.setState({ showFeePreview: false })}
                            />
                        </div>
                    }
                >
                    <div className="p-4">
                        <DataTable value={this.state.feeTypeData?.filter(item => item.amount)}>
                            <Column field="feeType" header="Fee Type" className='text-center' />
                            <Column field="term" header="Term" body={(rowData) => `Installment ${rowData.term}`} className='text-center' />
                            <Column
                                field="termWiseActualValue"
                                header="Term Amount"
                                body={(rowData) => `₹${(rowData.termWiseActualValue - (rowData.refundAmt || 0)).toFixed(2)}`}
                                className='text-center'
                            />
                            <Column field="amount" header="Amount Paying" body={(rowData) => `₹${rowData.amount}`} className='text-center' />
                        </DataTable>

                        <div className="flex justify-content-end mt-4 p-4 border-round-lg bg-gray-50">
                            <div className="flex gap-6">
                                <div className="flex align-items-center gap-2">
                                    <span className="font-bold text-xl" style={{ color: "#076EFF" }}>Total Amount:</span>
                                    <span className="text-xl">₹{this.state.feeTypeData
                                        ?.reduce((total, item) => total + Number(item.amount || 0), 0)
                                        .toFixed(2)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>

                {/* NTT Payment Component */}
                <NTTPaymentComponent
                    showPaymentButton={this.state.showNTTPayment}
                    paymentData={this.state.nttPaymentData}
                    onPaymentSuccess={this.onNTTPaymentSuccess}
                    onPaymentError={this.onNTTPaymentError}
                    onPaymentCancel={this.onNTTPaymentCancel}
                />

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    termsAndConditions: state.orgData?.termsAndConditions
});

export default connect(mapStateToProps)(withRouter(CollectFee));